var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ApiHeader;
(function (ApiHeader) {
    var ApiService;
    (function (ApiService) {
        ApiService["Account"] = "/account/api";
        ApiService["Tunnel"] = "/tunnel/api";
        ApiService["Billing"] = "/billing/api";
        ApiService["Alarm"] = "/alarm/api";
        ApiService["Ecp"] = "/zstack/api";
        ApiService["Vpn"] = "/vpn/api";
        ApiService["Spm"] = "/spm/api";
        ApiService["Scs"] = "/scs/api";
        ApiService["Idc"] = "/idc/api";
        ApiService["Sdwan"] = "/sdwan/api";
        ApiService["Dcdn"] = "dcdn/api";
    })(ApiService = ApiHeader.ApiService || (ApiHeader.ApiService = {}));
    var APIQueryMsg = /** @class */ (function () {
        function APIQueryMsg() {
            this.replyWithCount = true;
        }
        return APIQueryMsg;
    }());
    ApiHeader.APIQueryMsg = APIQueryMsg;
    var QueryCondition = /** @class */ (function () {
        function QueryCondition() {
        }
        return QueryCondition;
    }());
    ApiHeader.QueryCondition = QueryCondition;
    var QueryObject = /** @class */ (function () {
        function QueryObject() {
            this.start = null;
            this.limit = null;
            this.count = false;
            this.replySharedResource = false;
            this.replyWithCount = true;
            this.onlySelf = false;
            this.conditions = [];
        }
        QueryObject.prototype.addCondition = function (cond) {
            if (!Utils.notNullnotUndefined(this.conditions)) {
                this.conditions = [];
            }
            this.conditions.push(cond);
        };
        return QueryObject;
    }());
    ApiHeader.QueryObject = QueryObject;
    var SessionInventory = /** @class */ (function () {
        function SessionInventory() {
        }
        return SessionInventory;
    }());
    ApiHeader.SessionInventory = SessionInventory;
    var ErrorCode = /** @class */ (function () {
        function ErrorCode() {
        }
        return ErrorCode;
    }());
    ApiHeader.ErrorCode = ErrorCode;
    var APIReply = /** @class */ (function () {
        function APIReply() {
        }
        return APIReply;
    }());
    ApiHeader.APIReply = APIReply;
    /*
     * 此部分和account 重复
     *
     */
    var APILogInByAccountMsg = /** @class */ (function () {
        function APILogInByAccountMsg() {
        }
        APILogInByAccountMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.account.header.identity.APILogInByAccountMsg': this
            };
            return msg;
        };
        APILogInByAccountMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APILogInByAccountMsg;
    }());
    ApiHeader.APILogInByAccountMsg = APILogInByAccountMsg;
    var APILogInByUserMsg = /** @class */ (function () {
        function APILogInByUserMsg() {
        }
        APILogInByUserMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.account.header.identity.APILogInByUserMsg': this
            };
            return msg;
        };
        APILogInByUserMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APILogInByUserMsg;
    }());
    ApiHeader.APILogInByUserMsg = APILogInByUserMsg;
    var APILogInReply = /** @class */ (function () {
        function APILogInReply() {
        }
        return APILogInReply;
    }());
    ApiHeader.APILogInReply = APILogInReply;
    //余额
    var BalanceInventory = /** @class */ (function () {
        function BalanceInventory() {
        }
        return BalanceInventory;
    }());
    ApiHeader.BalanceInventory = BalanceInventory;
    //账户
    var APIQueryAccountMsg = /** @class */ (function (_super) {
        __extends(APIQueryAccountMsg, _super);
        function APIQueryAccountMsg() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.queryCustomer = true;
            return _this;
        }
        APIQueryAccountMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.account.header.account.APIQueryAccountMsg': this
            };
            return msg;
        };
        APIQueryAccountMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryAccountMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryAccountMsg = APIQueryAccountMsg;
    var APIQueryAccountReply = /** @class */ (function () {
        function APIQueryAccountReply() {
        }
        return APIQueryAccountReply;
    }());
    ApiHeader.APIQueryAccountReply = APIQueryAccountReply;
    var APIProxyChangeAccountMsg = /** @class */ (function () {
        function APIProxyChangeAccountMsg() {
        }
        APIProxyChangeAccountMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.account.header.identity.APIProxyChangeAccountMsg': this
            };
            return msg;
        };
        APIProxyChangeAccountMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIProxyChangeAccountMsg;
    }());
    ApiHeader.APIProxyChangeAccountMsg = APIProxyChangeAccountMsg;
    var APIProxyChangeAccountReply = /** @class */ (function () {
        function APIProxyChangeAccountReply() {
        }
        return APIProxyChangeAccountReply;
    }());
    ApiHeader.APIProxyChangeAccountReply = APIProxyChangeAccountReply;
    var APIGetAccountBalanceListMsg = /** @class */ (function () {
        function APIGetAccountBalanceListMsg() {
        }
        APIGetAccountBalanceListMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.billing.header.balance.APIGetAccountBalanceListMsg': this
            };
            return msg;
        };
        APIGetAccountBalanceListMsg.prototype.service = function () {
            return ApiService.Billing;
        };
        return APIGetAccountBalanceListMsg;
    }());
    ApiHeader.APIGetAccountBalanceListMsg = APIGetAccountBalanceListMsg;
    var APIGetAccountBalanceListReply = /** @class */ (function () {
        function APIGetAccountBalanceListReply() {
        }
        return APIGetAccountBalanceListReply;
    }());
    ApiHeader.APIGetAccountBalanceListReply = APIGetAccountBalanceListReply;
    var APIQueryUserMsg = /** @class */ (function (_super) {
        __extends(APIQueryUserMsg, _super);
        function APIQueryUserMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryUserMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.account.header.user.APIQueryUserMsg': this
            };
            return msg;
        };
        APIQueryUserMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIQueryUserMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryUserMsg = APIQueryUserMsg;
    var APIQueryUserReply = /** @class */ (function () {
        function APIQueryUserReply() {
        }
        return APIQueryUserReply;
    }());
    ApiHeader.APIQueryUserReply = APIQueryUserReply;
    //用户
    var UserInventory = /** @class */ (function () {
        function UserInventory() {
        }
        return UserInventory;
    }());
    ApiHeader.UserInventory = UserInventory;
    //role
    var RoleInventory = /** @class */ (function () {
        function RoleInventory() {
        }
        return RoleInventory;
    }());
    ApiHeader.RoleInventory = RoleInventory;
    var APIGetAccountMsg = /** @class */ (function () {
        function APIGetAccountMsg() {
        }
        APIGetAccountMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.account.header.account.APIGetAccountMsg': this
            };
            return msg;
        };
        APIGetAccountMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIGetAccountMsg;
    }());
    ApiHeader.APIGetAccountMsg = APIGetAccountMsg;
    var APIGetAccountReply = /** @class */ (function () {
        function APIGetAccountReply() {
        }
        return APIGetAccountReply;
    }());
    ApiHeader.APIGetAccountReply = APIGetAccountReply;
    var APILogOutMsg = /** @class */ (function () {
        function APILogOutMsg() {
        }
        APILogOutMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.account.header.identity.APILogOutMsg': this
            };
            return msg;
        };
        APILogOutMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APILogOutMsg;
    }());
    ApiHeader.APILogOutMsg = APILogOutMsg;
    var APILogOutReply = /** @class */ (function () {
        function APILogOutReply() {
        }
        return APILogOutReply;
    }());
    ApiHeader.APILogOutReply = APILogOutReply;
    var APIValidateSessionMsg = /** @class */ (function () {
        function APIValidateSessionMsg() {
        }
        APIValidateSessionMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.account.header.identity.APIValidateSessionMsg': this
            };
            return msg;
        };
        APIValidateSessionMsg.prototype.service = function () {
            return ApiService.Account;
        };
        return APIValidateSessionMsg;
    }());
    ApiHeader.APIValidateSessionMsg = APIValidateSessionMsg;
    var APIValidateSessionReply = /** @class */ (function () {
        function APIValidateSessionReply() {
        }
        return APIValidateSessionReply;
    }());
    ApiHeader.APIValidateSessionReply = APIValidateSessionReply;
    //账户 api
    var AccountExtraInfoInventory = /** @class */ (function () {
        function AccountExtraInfoInventory() {
        }
        return AccountExtraInfoInventory;
    }());
    ApiHeader.AccountExtraInfoInventory = AccountExtraInfoInventory;
    var AccountInventory = /** @class */ (function () {
        function AccountInventory() {
        }
        return AccountInventory;
    }());
    ApiHeader.AccountInventory = AccountInventory;
    //查询信用额度，余额信息
    var APIGetAccountBalanceMsg = /** @class */ (function () {
        function APIGetAccountBalanceMsg() {
        }
        APIGetAccountBalanceMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.billing.header.balance.APIGetAccountBalanceMsg': this
            };
            return msg;
        };
        APIGetAccountBalanceMsg.prototype.service = function () {
            return ApiService.Billing;
        };
        return APIGetAccountBalanceMsg;
    }());
    ApiHeader.APIGetAccountBalanceMsg = APIGetAccountBalanceMsg;
    var APIGetAccountBalanceReply = /** @class */ (function () {
        function APIGetAccountBalanceReply() {
        }
        return APIGetAccountBalanceReply;
    }());
    ApiHeader.APIGetAccountBalanceReply = APIGetAccountBalanceReply;
    /**
     * vpn网关
     */
    //vpn 查询
    var APIQueryVpnMsg = /** @class */ (function (_super) {
        __extends(APIQueryVpnMsg, _super);
        function APIQueryVpnMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryVpnMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIQueryVpnMsg': this
            };
            return msg;
        };
        APIQueryVpnMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIQueryVpnMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryVpnMsg = APIQueryVpnMsg;
    var APIQueryVpnHostReply = /** @class */ (function () {
        function APIQueryVpnHostReply() {
        }
        return APIQueryVpnHostReply;
    }());
    ApiHeader.APIQueryVpnHostReply = APIQueryVpnHostReply;
    var VpnInventory = /** @class */ (function () {
        function VpnInventory() {
        }
        return VpnInventory;
    }());
    ApiHeader.VpnInventory = VpnInventory;
    //vpn 新增
    var APICreateVpnMsg = /** @class */ (function () {
        function APICreateVpnMsg() {
        }
        APICreateVpnMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APICreateVpnMsg': this
            };
            return msg;
        };
        APICreateVpnMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APICreateVpnMsg;
    }());
    ApiHeader.APICreateVpnMsg = APICreateVpnMsg;
    var APICreateVpnEvent = /** @class */ (function () {
        function APICreateVpnEvent() {
        }
        return APICreateVpnEvent;
    }());
    ApiHeader.APICreateVpnEvent = APICreateVpnEvent;
    //vpn 新增 查询带宽列表
    var APIQueryBandwidthOfferingMsg = /** @class */ (function (_super) {
        __extends(APIQueryBandwidthOfferingMsg, _super);
        function APIQueryBandwidthOfferingMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryBandwidthOfferingMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIQueryBandwidthOfferingMsg': this
            };
            return msg;
        };
        APIQueryBandwidthOfferingMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIQueryBandwidthOfferingMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryBandwidthOfferingMsg = APIQueryBandwidthOfferingMsg;
    //vpn 新增 查询专线列表
    var APIQueryTunnelMsg = /** @class */ (function (_super) {
        __extends(APIQueryTunnelMsg, _super);
        function APIQueryTunnelMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryTunnelMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.tunnel.tunnel.APIQueryTunnelMsg': this
            };
            return msg;
        };
        APIQueryTunnelMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryTunnelMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryTunnelMsg = APIQueryTunnelMsg;
    //获取连接点名称
    var APIQueryEndpointMsg = /** @class */ (function (_super) {
        __extends(APIQueryEndpointMsg, _super);
        function APIQueryEndpointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryEndpointMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.tunnel.endpoint.APIQueryEndpointMsg': this
            };
            return msg;
        };
        APIQueryEndpointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryEndpointMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryEndpointMsg = APIQueryEndpointMsg;
    //vpn 新增 节点选择
    var APIListSupportedEndpointMsg = /** @class */ (function () {
        function APIListSupportedEndpointMsg() {
        }
        APIListSupportedEndpointMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIListSupportedEndpointMsg': this
            };
            return msg;
        };
        APIListSupportedEndpointMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIListSupportedEndpointMsg;
    }());
    ApiHeader.APIListSupportedEndpointMsg = APIListSupportedEndpointMsg;
    //vpn 新增 查询价格
    var APIGetVpnPriceMsg = /** @class */ (function () {
        function APIGetVpnPriceMsg() {
        }
        APIGetVpnPriceMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIGetVpnPriceMsg': this
            };
            return msg;
        };
        APIGetVpnPriceMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIGetVpnPriceMsg;
    }());
    ApiHeader.APIGetVpnPriceMsg = APIGetVpnPriceMsg;
    //vpn 修改名称
    var APIUpdateVpnMsg = /** @class */ (function () {
        function APIUpdateVpnMsg() {
        }
        APIUpdateVpnMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIUpdateVpnMsg': this
            };
            return msg;
        };
        APIUpdateVpnMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIUpdateVpnMsg;
    }());
    ApiHeader.APIUpdateVpnMsg = APIUpdateVpnMsg;
    var APIUpdateVpnEvent = /** @class */ (function () {
        function APIUpdateVpnEvent() {
        }
        return APIUpdateVpnEvent;
    }());
    ApiHeader.APIUpdateVpnEvent = APIUpdateVpnEvent;
    //查询vpn修改次数
    var APIGetVpnModifyMsg = /** @class */ (function () {
        function APIGetVpnModifyMsg() {
        }
        APIGetVpnModifyMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIGetVpnModifyMsg': this
            };
            return msg;
        };
        APIGetVpnModifyMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIGetVpnModifyMsg;
    }());
    ApiHeader.APIGetVpnModifyMsg = APIGetVpnModifyMsg;
    //查询修改带宽价格
    var APIGetModifyVpnPriceDiffMsg = /** @class */ (function () {
        function APIGetModifyVpnPriceDiffMsg() {
        }
        APIGetModifyVpnPriceDiffMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIGetModifyVpnPriceDiffMsg': this
            };
            return msg;
        };
        APIGetModifyVpnPriceDiffMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIGetModifyVpnPriceDiffMsg;
    }());
    ApiHeader.APIGetModifyVpnPriceDiffMsg = APIGetModifyVpnPriceDiffMsg;
    //修改VPN带宽
    var APIUpdateVpnBandwidthMsg = /** @class */ (function () {
        function APIUpdateVpnBandwidthMsg() {
        }
        APIUpdateVpnBandwidthMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIUpdateVpnBandwidthMsg': this
            };
            return msg;
        };
        APIUpdateVpnBandwidthMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIUpdateVpnBandwidthMsg;
    }());
    ApiHeader.APIUpdateVpnBandwidthMsg = APIUpdateVpnBandwidthMsg;
    //解绑证书
    var APIDetachVpnCertMsg = /** @class */ (function () {
        function APIDetachVpnCertMsg() {
        }
        APIDetachVpnCertMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIDetachVpnCertMsg': this
            };
            return msg;
        };
        APIDetachVpnCertMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIDetachVpnCertMsg;
    }());
    ApiHeader.APIDetachVpnCertMsg = APIDetachVpnCertMsg;
    //绑定证书
    var APIAttachVpnCertMsg = /** @class */ (function () {
        function APIAttachVpnCertMsg() {
        }
        APIAttachVpnCertMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIAttachVpnCertMsg': this
            };
            return msg;
        };
        APIAttachVpnCertMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIAttachVpnCertMsg;
    }());
    ApiHeader.APIAttachVpnCertMsg = APIAttachVpnCertMsg;
    //修改VPN状态 L2
    var APIUpdateVpnStateMsg = /** @class */ (function () {
        function APIUpdateVpnStateMsg() {
        }
        APIUpdateVpnStateMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIUpdateVpnStateMsg': this
            };
            return msg;
        };
        APIUpdateVpnStateMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIUpdateVpnStateMsg;
    }());
    ApiHeader.APIUpdateVpnStateMsg = APIUpdateVpnStateMsg;
    //修改VPN状态 L3
    var APIUpdateL3VpnStateMsg = /** @class */ (function () {
        function APIUpdateL3VpnStateMsg() {
        }
        APIUpdateL3VpnStateMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIUpdateL3VpnStateMsg': this
            };
            return msg;
        };
        APIUpdateL3VpnStateMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIUpdateL3VpnStateMsg;
    }());
    ApiHeader.APIUpdateL3VpnStateMsg = APIUpdateL3VpnStateMsg;
    //删除VPN
    var APIDeleteVpnMsg = /** @class */ (function () {
        function APIDeleteVpnMsg() {
        }
        APIDeleteVpnMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIDeleteVpnMsg': this
            };
            return msg;
        };
        APIDeleteVpnMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIDeleteVpnMsg;
    }());
    ApiHeader.APIDeleteVpnMsg = APIDeleteVpnMsg;
    //删除vpn网关 查询返回金额
    var APIGetUnscribeVpnPriceDiffMsg = /** @class */ (function () {
        function APIGetUnscribeVpnPriceDiffMsg() {
        }
        APIGetUnscribeVpnPriceDiffMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIGetUnscribeVpnPriceDiffMsg': this
            };
            return msg;
        };
        APIGetUnscribeVpnPriceDiffMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIGetUnscribeVpnPriceDiffMsg;
    }());
    ApiHeader.APIGetUnscribeVpnPriceDiffMsg = APIGetUnscribeVpnPriceDiffMsg;
    //重置证书key
    var APIResetVpnSecretKeyMsg = /** @class */ (function () {
        function APIResetVpnSecretKeyMsg() {
        }
        APIResetVpnSecretKeyMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIResetVpnSecretKeyMsg': this
            };
            return msg;
        };
        APIResetVpnSecretKeyMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIResetVpnSecretKeyMsg;
    }());
    ApiHeader.APIResetVpnSecretKeyMsg = APIResetVpnSecretKeyMsg;
    //查询续费价格
    var APIGetRenewVpnPriceMsg = /** @class */ (function () {
        function APIGetRenewVpnPriceMsg() {
        }
        APIGetRenewVpnPriceMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIGetRenewVpnPriceMsg': this
            };
            return msg;
        };
        APIGetRenewVpnPriceMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIGetRenewVpnPriceMsg;
    }());
    ApiHeader.APIGetRenewVpnPriceMsg = APIGetRenewVpnPriceMsg;
    //续费
    var APIRenewVpnMsg = /** @class */ (function () {
        function APIRenewVpnMsg() {
        }
        APIRenewVpnMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIRenewVpnMsg': this
            };
            return msg;
        };
        APIRenewVpnMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIRenewVpnMsg;
    }());
    ApiHeader.APIRenewVpnMsg = APIRenewVpnMsg;
    /**
     * L3 vpn网关
     */
    //L3 vpn 查询
    var APIQueryL3VpnMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3VpnMsg, _super);
        function APIQueryL3VpnMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3VpnMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIQueryL3VpnMsg': this
            };
            return msg;
        };
        APIQueryL3VpnMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIQueryL3VpnMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3VpnMsg = APIQueryL3VpnMsg;
    //L3 查询云网络列表
    var APIQueryL3NetworkMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3NetworkMsg, _super);
        function APIQueryL3NetworkMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3NetworkMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.tunnel.network.APIQueryL3NetworkMsg': this
            };
            return msg;
        };
        APIQueryL3NetworkMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3NetworkMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3NetworkMsg = APIQueryL3NetworkMsg;
    //L3 云网络节点
    var APIQueryL3EndpointMsg = /** @class */ (function (_super) {
        __extends(APIQueryL3EndpointMsg, _super);
        function APIQueryL3EndpointMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryL3EndpointMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.tunnel.network.APIQueryL3EndpointMsg': this
            };
            return msg;
        };
        APIQueryL3EndpointMsg.prototype.service = function () {
            return ApiService.Tunnel;
        };
        return APIQueryL3EndpointMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryL3EndpointMsg = APIQueryL3EndpointMsg;
    //L3 查询可用节点选择
    var APIListSupportedL3EndpointMsg = /** @class */ (function () {
        function APIListSupportedL3EndpointMsg() {
        }
        APIListSupportedL3EndpointMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIListSupportedL3EndpointMsg': this
            };
            return msg;
        };
        APIListSupportedL3EndpointMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIListSupportedL3EndpointMsg;
    }());
    ApiHeader.APIListSupportedL3EndpointMsg = APIListSupportedL3EndpointMsg;
    //L3 vpn 新增
    var APICreateL3VpnMsg = /** @class */ (function () {
        function APICreateL3VpnMsg() {
        }
        APICreateL3VpnMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APICreateL3VpnMsg': this
            };
            return msg;
        };
        APICreateL3VpnMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APICreateL3VpnMsg;
    }());
    ApiHeader.APICreateL3VpnMsg = APICreateL3VpnMsg;
    //L3 客户端模式
    var APIGetL3VpnWorkModeMsg = /** @class */ (function () {
        function APIGetL3VpnWorkModeMsg() {
        }
        APIGetL3VpnWorkModeMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIGetL3VpnWorkModeMsg': this
            };
            return msg;
        };
        APIGetL3VpnWorkModeMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIGetL3VpnWorkModeMsg;
    }());
    ApiHeader.APIGetL3VpnWorkModeMsg = APIGetL3VpnWorkModeMsg;
    //L3 设置路由ip
    var APIUpdateL3VpnIPMsg = /** @class */ (function () {
        function APIUpdateL3VpnIPMsg() {
        }
        APIUpdateL3VpnIPMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIUpdateL3VpnIPMsg': this
            };
            return msg;
        };
        APIUpdateL3VpnIPMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIUpdateL3VpnIPMsg;
    }());
    ApiHeader.APIUpdateL3VpnIPMsg = APIUpdateL3VpnIPMsg;
    //L3 调整模式
    var APIUpdateL3VpnWorkModeMsg = /** @class */ (function () {
        function APIUpdateL3VpnWorkModeMsg() {
        }
        APIUpdateL3VpnWorkModeMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIUpdateL3VpnWorkModeMsg': this
            };
            return msg;
        };
        APIUpdateL3VpnWorkModeMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIUpdateL3VpnWorkModeMsg;
    }());
    ApiHeader.APIUpdateL3VpnWorkModeMsg = APIUpdateL3VpnWorkModeMsg;
    //监控
    var APIQueryOpentsdbConditionMsg = /** @class */ (function () {
        function APIQueryOpentsdbConditionMsg() {
        }
        APIQueryOpentsdbConditionMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.monitor.APIQueryOpentsdbConditionMsg': this
            };
            return msg;
        };
        APIQueryOpentsdbConditionMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIQueryOpentsdbConditionMsg;
    }());
    ApiHeader.APIQueryOpentsdbConditionMsg = APIQueryOpentsdbConditionMsg;
    /**
     * vpn证书
     */
    //查询 证书
    var APIQueryVpnCertMsg = /** @class */ (function (_super) {
        __extends(APIQueryVpnCertMsg, _super);
        function APIQueryVpnCertMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APIQueryVpnCertMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIQueryVpnCertMsg': this
            };
            return msg;
        };
        ;
        APIQueryVpnCertMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIQueryVpnCertMsg;
    }(APIQueryMsg));
    ApiHeader.APIQueryVpnCertMsg = APIQueryVpnCertMsg;
    //新增 证书
    var APICreateVpnCertMsg = /** @class */ (function (_super) {
        __extends(APICreateVpnCertMsg, _super);
        function APICreateVpnCertMsg() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        APICreateVpnCertMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APICreateVpnCertMsg': this
            };
            return msg;
        };
        APICreateVpnCertMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APICreateVpnCertMsg;
    }(APIQueryMsg));
    ApiHeader.APICreateVpnCertMsg = APICreateVpnCertMsg;
    var APICreateVpnCertEvent = /** @class */ (function () {
        function APICreateVpnCertEvent() {
        }
        return APICreateVpnCertEvent;
    }());
    ApiHeader.APICreateVpnCertEvent = APICreateVpnCertEvent;
    //修改证书
    var APIUpdateVpnCertMsg = /** @class */ (function () {
        function APIUpdateVpnCertMsg() {
        }
        APIUpdateVpnCertMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIUpdateVpnCertMsg': this
            };
            return msg;
        };
        APIUpdateVpnCertMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIUpdateVpnCertMsg;
    }());
    ApiHeader.APIUpdateVpnCertMsg = APIUpdateVpnCertMsg;
    var APIUpdateVpnCertEvent = /** @class */ (function () {
        function APIUpdateVpnCertEvent() {
        }
        return APIUpdateVpnCertEvent;
    }());
    ApiHeader.APIUpdateVpnCertEvent = APIUpdateVpnCertEvent;
    //删除证书
    var APIDeleteVpnCertMsg = /** @class */ (function () {
        function APIDeleteVpnCertMsg() {
        }
        APIDeleteVpnCertMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIDeleteVpnCertMsg': this
            };
            return msg;
        };
        APIDeleteVpnCertMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIDeleteVpnCertMsg;
    }());
    ApiHeader.APIDeleteVpnCertMsg = APIDeleteVpnCertMsg;
    //重置证书
    var APIResetVpnCertMsg = /** @class */ (function () {
        function APIResetVpnCertMsg() {
        }
        APIResetVpnCertMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIResetVpnCertMsg': this
            };
            return msg;
        };
        APIResetVpnCertMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIResetVpnCertMsg;
    }());
    ApiHeader.APIResetVpnCertMsg = APIResetVpnCertMsg;
    //获取下载证书url
    var APIGenerateDownloadUrlMsg = /** @class */ (function () {
        function APIGenerateDownloadUrlMsg() {
        }
        APIGenerateDownloadUrlMsg.prototype.toApiMap = function () {
            var msg = {
                'com.syscxp.header.vpn.vpn.APIGenerateDownloadUrlMsg': this
            };
            return msg;
        };
        APIGenerateDownloadUrlMsg.prototype.service = function () {
            return ApiService.Vpn;
        };
        return APIGenerateDownloadUrlMsg;
    }());
    ApiHeader.APIGenerateDownloadUrlMsg = APIGenerateDownloadUrlMsg;
})(ApiHeader || (ApiHeader = {}));
/// <reference path="d.ts/angularjs/angular.d.ts" />
var Utils;
(function (Utils) {
    function notNullnotUndefined(arg) {
        return angular.isDefined(arg) && arg != null;
    }
    Utils.notNullnotUndefined = notNullnotUndefined;
    function notNullnotUndefinedNotEmptyString(arg) {
        return notNullnotUndefined(arg) && arg != '';
    }
    Utils.notNullnotUndefinedNotEmptyString = notNullnotUndefinedNotEmptyString;
    function firstItem(obj) {
        return obj[Object.keys(obj)[0]];
    }
    Utils.firstItem = firstItem;
    function isEmptyObject(obj) {
        if (!notNullnotUndefined(obj)) {
            return true;
        }
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    Utils.isEmptyObject = isEmptyObject;
    function arrayRemoveIndex(arr, index) {
        if (index != -1) {
            arr.splice(index, 1);
        }
    }
    Utils.arrayRemoveIndex = arrayRemoveIndex;
    function arrayUpdateItem(arr, item) {
        var index = -1;
        angular.forEach(arr, function (it, i) {
            if (it.uuid == item.uuid) {
                index = i;
                return false;
            }
        });
        if (index > -1) {
            angular.extend(arr[index], item);
        }
    }
    Utils.arrayUpdateItem = arrayUpdateItem;
    function arrayDeleteItem(arr, item) {
        var index = -1;
        angular.forEach(arr, function (it, i) {
            if (it.uuid == item.uuid) {
                index = i;
                return false;
            }
        });
        if (index > -1) {
            arr.splice(index, 1);
        }
    }
    Utils.arrayDeleteItem = arrayDeleteItem;
    function safeApply(scope, func) {
        if (!scope.$$phase) {
            scope.$apply(function () {
                func();
            });
        }
        else {
            func();
        }
    }
    Utils.safeApply = safeApply;
    function addCommas(str) {
        return (str + '').replace(/\b(\d+)((\.\d+)*)\b/g, function (a, b, c) {
            return (b.charAt(0) > 0 && !(c || '.').lastIndexOf('.') ? b.replace(/(\d)(?=(\d{3})+$)/g, '$1,') : b) + c;
        });
    }
    Utils.addCommas = addCommas;
    function stringContains(str, tofind) {
        return str.indexOf(tofind) > -1;
    }
    Utils.stringContains = stringContains;
    function uuid() {
        var dec2hex = [];
        for (var i = 0; i <= 15; i++) {
            dec2hex[i] = i.toString(16);
        }
        return function () {
            var uuid = '';
            for (var i = 1; i <= 36; i++) {
                if (i === 9 || i === 14 || i === 19 || i === 24) {
                    continue;
                }
                else if (i === 15) {
                    uuid += 4;
                }
                else if (i === 20) {
                    uuid += dec2hex[(Math.random() * 4 | 0 + 8)];
                }
                else {
                    uuid += dec2hex[(Math.random() * 15 | 0)];
                }
            }
            return uuid;
        }();
    }
    Utils.uuid = uuid;
    function toFixed(num, precision) {
        var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(num * multiplier);
        return Math.round(wholeNumber / 10) * 10 / multiplier;
    }
    Utils.toFixed = toFixed;
    function sprintf(fmt) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return fmt.replace(/{(\d+)}/g, function (match, index) {
            return typeof args[index] != 'undefined'
                ? args[index]
                : '';
        });
    }
    Utils.sprintf = sprintf;
    function toPercentageString(input) {
        var per = parseFloat(input) * 100;
        var perStr = per.toString();
        if (perStr.length > 5) {
            perStr = perStr.slice(0, 5);
        }
        return Utils.sprintf('{0}%', perStr);
    }
    Utils.toPercentageString = toPercentageString;
    function commaString(input) {
        return Utils.addCommas(input.toString());
    }
    Utils.commaString = commaString;
    //grid 自适应高度
    function ngGridFlexibleHeightPlugin(opts) {
        var self = this;
        self.grid = null;
        self.scope = null;
        self.init = function (scope, grid, services) {
            self.domUtilityService = services.DomUtilityService;
            self.grid = grid;
            self.scope = scope;
            var recalcHeightForData = function () {
                setTimeout(innerRecalcForData, 1);
            };
            var innerRecalcForData = function () {
                var gridId = self.grid.gridId;
                var footerPanelSel = '.' + gridId + ' .ngFooterPanel';
                var extraHeight = self.grid.$topPanel.height() + $(footerPanelSel).height();
                var row = $(self.grid.$canvas).find('.ngRow');
                var naturalHeight = 0;
                row.each(function () {
                    naturalHeight += $(this).height();
                });
                if (opts != null) {
                    if (opts.minHeight != null && (naturalHeight + extraHeight) < opts.minHeight) {
                        naturalHeight = opts.minHeight - extraHeight - 2;
                    }
                }
                var newViewportHeight = naturalHeight + 2;
                if (!self.scope.baseViewportHeight || self.scope.baseViewportHeight !== newViewportHeight) {
                    self.grid.$viewport.css('height', newViewportHeight + 'px');
                    self.grid.$root.css('height', (newViewportHeight + extraHeight) + 'px');
                    self.scope.baseViewportHeight = newViewportHeight;
                    self.domUtilityService.UpdateGridLayout(self.scope, self.grid);
                }
            };
            self.scope.catHashKeys = function () {
                var hash = '', idx;
                for (idx in self.scope.renderedRows) {
                    hash += self.scope.renderedRows[idx].$$hashKey;
                }
                return hash;
            };
            self.scope.$watch('catHashKeys()', innerRecalcForData);
            self.scope.$watch(self.grid.config.data, recalcHeightForData, true);
        };
    }
    Utils.ngGridFlexibleHeightPlugin = ngGridFlexibleHeightPlugin;
    function flexRowHeight() {
        var self = this;
        self.grid = null;
        self.scope = null;
        self.init = function (scope, grid, services) {
            self.domUtilityService = services.DomUtilityService;
            self.grid = grid;
            self.scope = scope;
            var adjust = function () {
                setTimeout(function () {
                    var row = $(self.grid.$canvas).find('.ngRow'), offs;
                    row.each(function () {
                        var mh = 0, s = angular.element(this).scope(), len = $(this).find('>div').length, lastMh = 0;
                        $(this).find('> div').each(function (index, elem) {
                            // var h = $(this)[0].scrollHeight;
                            // if (h > mh)
                            // 		mh = h;
                            //
                            // $(this).css('height', '100%');
                            if (index == len - 1) {
                                mh = lastMh;
                                $(this).css('height', '100%');
                                return;
                            }
                            else {
                                var h = $(this)[0].scrollHeight;
                                if (h > mh)
                                    mh = lastMh = h;
                                $(this).css('height', '100%');
                            }
                        });
                        $(this).height(mh);
                        // $(this).find('.ngCellText').height(mh);//zhanming
                        if (offs)
                            $(this).css('top', offs + 'px');
                        offs = $(this).position().top + mh;
                        self.scope.$apply(function () {
                            s.rowHeight = mh;
                        });
                    });
                }, 1);
            };
            self.scope.$watch(self.grid.config.data, adjust, true);
        };
    }
    Utils.flexRowHeight = flexRowHeight;
    var DialogOptions = /** @class */ (function () {
        function DialogOptions() {
        }
        return DialogOptions;
    }());
    var DialogManage = /** @class */ (function () {
        function DialogManage(element, options) {
            if (options === void 0) { options = { width: '500px', type: 'center', top: 0, height: 600 }; }
            this.element = element;
            this.options = options;
            this.initDialog();
        }
        DialogManage.prototype.initDialog = function () {
            if (this.options.type == 'center') {
                var left = -parseFloat(this.options.width) / 2 + 'px', element = this.element.find('.sys-center-dialog'), height = this.options.height || element.height(), top_1 = notNullnotUndefined(this.options.top) ? -(height / 2 + this.options.top) + 'px' : -(height / 2) + 'px';
                element.css({ width: this.options.width });
                element.css({ marginLeft: left, marginTop: top_1 });
                this.element.hide();
            }
            else {
                var element_1 = this.element.find('.sys-right-dialog');
                element_1.css({ right: '-100%', opacity: 0 });
                this.element.hide();
                this.element.on('click', function (e) {
                    if (angular.element(e.target).closest(".sys-right-dialog").length == 0) {
                        element_1.animate({ opacity: 0, right: '-100%' }, 200).queue(function () {
                            element_1.parent().hide();
                            element_1.dequeue();
                        });
                    }
                });
            }
        };
        DialogManage.prototype.open = function () {
            if (this.options.type == 'center') {
                this.element.show();
            }
            else {
                var element_2 = this.element.find('.sys-right-dialog');
                this.element.show().queue(function () {
                    element_2.animate({ opacity: 1, right: 0 }, 200);
                    $(this).dequeue();
                });
            }
        };
        DialogManage.prototype.close = function (e) {
            if (this.options.type == 'center') {
                this.element.hide();
            }
            else {
                var right = -parseFloat(this.options.width) + 'px', element = this.element.find('.sys-right-dialog'), parent_1 = this.element;
                element.animate({ transform: 'translateX(100%)' }, 800).queue(function () {
                    parent_1.hide();
                    $(this).dequeue();
                });
            }
            if (notNullnotUndefined(e)) {
                e.stopPropagation();
            }
        };
        return DialogManage;
    }());
    Utils.DialogManage = DialogManage;
    function getConditionFromUrl(urlSearch, find) {
        var conds = [];
        if (urlSearch.account) {
            conds.push({ name: find.accountName, op: '=', value: urlSearch.account });
        }
        if (urlSearch.start) {
            conds.push({ name: find.dateName, op: '>=', value: urlSearch.start + ' 00:00:00' });
        }
        if (urlSearch.end) {
            conds.push({ name: find.dateName, op: '<', value: urlSearch.end + ' 23:59:59' });
        }
        if (urlSearch.name && urlSearch.value) {
            angular.forEach(find.listName, function (item) {
                if (item.name == urlSearch.name) {
                    if (item.isSelect) {
                        if (urlSearch.name == 'expireDate') {
                            if (urlSearch.value == 'expired') {
                                conds.push({ name: urlSearch.name, op: '<', value: MRoot.filterDate()(new Date()) });
                            }
                            else if (urlSearch.value == 'expireing') {
                                var timestamp = 1000 * 60 * 60 * 24 * 7 + new Date().getTime();
                                conds.push({
                                    name: urlSearch.name,
                                    op: '<',
                                    value: MRoot.filterDate()(new Date(timestamp))
                                });
                                conds.push({ name: urlSearch.name, op: '>', value: MRoot.filterDate()(new Date()) });
                            }
                            else {
                                // let timestamp=1000*60*60*24*7+new Date().getTime();
                                var timestamp = new Date().getTime();
                                conds.push({
                                    name: urlSearch.name,
                                    op: '>',
                                    value: MRoot.filterDate()(new Date(timestamp))
                                });
                            }
                        }
                        else {
                            conds.push({ name: urlSearch.name, op: '=', value: urlSearch.value });
                        }
                    }
                    else {
                        var op = urlSearch.name.indexOf('uid') == -1 ? 'like' : '=';
                        var value = urlSearch.name.indexOf('uid') == -1 ? '%' + urlSearch.value + '%' : urlSearch.value;
                        conds.push({ name: urlSearch.name, op: op, value: value });
                    }
                    return false;
                }
            });
        }
        if (urlSearch.otherName && urlSearch.otherValue) {
            angular.forEach(find.otherName, function (item) {
                if (item.name == urlSearch.otherName) {
                    if (item.isSelect) {
                        conds.push({ name: urlSearch.otherName, op: '=', value: urlSearch.otherValue });
                    }
                    else {
                        conds.push({ name: urlSearch.otherName, op: 'like', value: '%' + urlSearch.otherValue + '%' });
                    }
                    return false;
                }
            });
        }
        if (find.textName) {
            angular.forEach(find.textName, function (item) {
                if (urlSearch[item]) {
                    conds.push({ name: item, op: '=', value: urlSearch[item] });
                }
            });
        }
        if (find.relateName) {
            angular.forEach(find.relateName, function (item) {
                if (urlSearch[item]) {
                    conds.push({ name: item, op: '=', value: urlSearch[item] });
                }
            });
        }
        if (find.linkageName) {
            angular.forEach(find.linkageName, function (item) {
                if (urlSearch[item]) {
                    conds.push({ name: item, op: '=', value: urlSearch[item] });
                }
            });
        }
        return conds;
    }
    Utils.getConditionFromUrl = getConditionFromUrl;
    function parseSize(sizeStr) {
        var K = 1024;
        var quantity = sizeStr.substr(sizeStr.length - 1, 1);
        var size = parseInt(sizeStr);
        if (quantity == 'K' || quantity == 'k') {
            return size * K;
        }
        else if (quantity == 'M' || quantity == 'm') {
            return size * K * K;
        }
        else if (quantity == 'G' || quantity == 'g') {
            return size * K * K * K;
        }
        else if (quantity == 'T' || quantity == 't') {
            return size * K * K * K * K;
        }
        else if (quantity == 'P' || quantity == 'p') {
            return size * K * K * K * K * K;
        }
        else {
            return parseInt(sizeStr);
        }
    }
    Utils.parseSize = parseSize;
    function sizeRoundToString(size) {
        var K = 1024;
        var sizeMap = {
            'P': K * K * K * K * K,
            'T': K * K * K * K,
            'G': K * K * K,
            'M': K * K,
            'K': K
        }, roundSize = '0B', flag = true;
        if (!notNullnotUndefined(size) || size < K) {
            return sprintf('{0}bps', size);
        }
        else {
            angular.forEach(sizeMap, function (value, key) {
                var s = size / value;
                if (s >= 1 && flag) {
                    roundSize = s.toFixed(2) + key + 'bps';
                    flag = false;
                }
            });
            return roundSize;
        }
    }
    Utils.sizeRoundToString = sizeRoundToString;
    Utils.bandwidthRanges = [{ name: "range1", text: "小于100M" }, { name: "range2", text: "100M-200M" }, { name: "range3", text: "200M-1G" }, { name: "range4", text: "大于1G" }];
})(Utils || (Utils = {}));
/// <reference path="d.ts/angularjs/angular.d.ts" />
var RESTApiFacade;
(function (RESTApiFacade) {
    var Receipt = /** @class */ (function () {
        function Receipt() {
        }
        return Receipt;
    }());
    var Api = /** @class */ (function () {
        function Api($http, $rootScope, $location, $cookies) {
            this.$http = $http;
            this.$rootScope = $rootScope;
            this.$location = $location;
            this.$cookies = $cookies;
            this.$inject = ['$http', '$rootScope', '$location'];
            this.beforeCallListeners = [];
            this.afterCallListeners = [];
            this.errorCallListeners = [];
            this.session = new ApiHeader.SessionInventory();
        }
        Api.getMsgRestCallUrl = function (msg) {
            return msg.service();
        };
        Api.getMsgRestQueryUrl = function (msg, id) {
            return msg.service() + '/result/' + id;
        };
        Api.prototype.fireAfterListener = function (recepit) {
            angular.forEach(this.afterCallListeners, function (item) {
                item(recepit.request, JSON.parse(recepit.result));
            });
        };
        Api.prototype.fireErrorListener = function (reason) {
            angular.forEach(this.errorCallListeners, function (item) {
                item(reason);
            });
        };
        Api.prototype.restCall = function (msg, callback, error) {
            var _this = this;
            if (Utils.notNullnotUndefined(this.$cookies.get('sessionid'))) {
                this.session.uuid = this.$cookies.get('sessionid');
            }
            msg.session = this.session;
            this.$http.post(Api.getMsgRestCallUrl(msg), msg.toApiMap(), {
                headers: { 'referer-url': this.$location.path() }
            }).success(function (receipt) {
                if (receipt.state == Api.STATUS_DONE) {
                    var ret = Utils.firstItem(JSON.parse(receipt.result));
                    if (Utils.notNullnotUndefined(ret.error)) {
                        if (ret.error.code == 'ID.1001') {
                            _this.$rootScope.loginFlag = false;
                            if (_this.$location.absUrl().indexOf("/login") == -1) {
                                location.href = '/naas/account/login.html';
                            }
                            return;
                        }
                        else {
                            var r = new Receipt();
                            r.request = msg;
                            r.result = receipt.result;
                            _this.fireAfterListener(r);
                        }
                    }
                    callback(ret);
                }
                else if (receipt.state == Api.STATUS_PROCESSING) {
                    angular.forEach(_this.beforeCallListeners, function (item) {
                        item(msg);
                    });
                    receipt.request = msg;
                    _this.poll(msg, receipt, callback, error);
                }
            }).error(function (reason, status) {
                if (error) {
                    error(reason, status);
                }
                _this.fireErrorListener({
                    request: msg,
                    data: reason,
                    status: status
                });
            });
        };
        Api.prototype.restCalls = function (msg, callback, error) {
            var _this = this;
            if (Utils.notNullnotUndefined(this.$rootScope.sessionUuid)) {
                this.session.uuid = this.$rootScope.sessionUuid;
            }
            msg.session = this.session;
            this.$http.post(Api.getMsgRestCallUrl(msg), msg.toApiMap()).success(function (receipt) {
                var ret = Utils.firstItem(receipt);
                callback(ret);
            }).error(function (reason, status) {
                if (error) {
                    error(reason, status);
                }
                _this.fireErrorListener({
                    request: msg,
                    data: reason,
                    status: status
                });
            });
        };
        Api.prototype.poll = function (msg, receipt, callback, error) {
            var _this = this;
            if (receipt.state == Api.STATUS_DONE) {
                this.fireAfterListener(receipt);
                var rsp = Utils.firstItem(angular.fromJson(receipt.result));
                if (rsp.success) {
                    callback(rsp);
                }
                else {
                    if (Utils.notNullnotUndefined(error)) {
                        error(rsp);
                    }
                }
                return;
            }
            this.$http.get(Api.getMsgRestQueryUrl(msg, receipt.uuid) + "?t=" + new Date().getTime(), {
                headers: { 'referer-url': this.$location.path() }
            }).success(function (re) {
                re.request = receipt.request;
                if (re.state == Api.STATUS_DONE) {
                    _this.fireAfterListener(re);
                    var rsp = Utils.firstItem(angular.fromJson(re.result));
                    if (rsp.success) {
                        callback(rsp);
                    }
                    else {
                        if (Utils.notNullnotUndefined(error)) {
                            error(rsp);
                        }
                    }
                    return;
                }
                setTimeout(function () {
                    Utils.safeApply(_this.$rootScope, function () {
                        _this.poll(msg, re, callback, error);
                    });
                }, 1000);
            }).error(function (reason, status) {
                if (error) {
                    error(reason, status);
                }
                _this.fireErrorListener({
                    request: receipt.request,
                    data: reason,
                    status: status
                });
            });
        };
        Api.prototype.installListener = function (before, after, error) {
            if (before === void 0) { before = null; }
            if (after === void 0) { after = null; }
            if (error === void 0) { error = null; }
            if (Utils.notNullnotUndefined(before)) {
                this.beforeCallListeners.push(before);
            }
            if (Utils.notNullnotUndefined(after)) {
                this.afterCallListeners.push(after);
            }
            if (Utils.notNullnotUndefined(error)) {
                this.errorCallListeners.push(error);
            }
        };
        Api.STATUS_DONE = 'Done';
        Api.STATUS_PROCESSING = 'Processing';
        return Api;
    }());
    RESTApiFacade.Api = Api;
})(RESTApiFacade || (RESTApiFacade = {}));
angular.module("app.service", []).factory('Api', ['$http', '$rootScope', '$location', '$cookies', function ($http, $rootScope, $location, $cookies) {
        return new RESTApiFacade.Api($http, $rootScope, $location, $cookies);
    }]);
/// <reference path = './d.ts/angularjs/angular.d.ts'/>
var MDirective;
(function (MDirective) {
    var LeftNav_old = /** @class */ (function () {
        function LeftNav_old($location, $rootScope, $cookies, $window) {
            this.scope = {
                initMenu: '=',
                menuData: '='
            };
            this.restrict = 'EA';
            this.replace = true;
            this.link = function ($scope, $element, $attrs, $ctrl, $transclude) {
                $scope.path = null;
                $rootScope.$on('$routeChangeSuccess', function (e, current) {
                    var path = $location.path();
                    $scope.path = path == '/' ? '#' + $scope.initMenu.defaultLink : '#' + path;
                    angular.forEach($scope.menuData, function (item, index) {
                        if (item.main.test($scope.path)) {
                            $scope.initMenu.id = index;
                            return false;
                        }
                    });
                });
                $rootScope.$on('$locationChangeSuccess', function (e, current) {
                    var path = $location.path();
                    $scope.path = path == '/' ? '#' + $scope.initMenu.defaultLink : '#' + path;
                    angular.forEach($scope.menuData, function (item, index) {
                        if (item.main.test($scope.path)) {
                            $scope.initMenu.id = index;
                            return false;
                        }
                    });
                });
                $scope.toggleNav = function () {
                    $scope.initMenu.showNavText = !$scope.initMenu.showNavText;
                    angular.element(window).resize();
                };
                angular.element('.left-nav .main-nav').on('click', 'li', function () {
                    var dataId = angular.element(this).attr('data-id');
                    var toggleFlag = $scope.initMenu.showNavText ? 'open' : 'close';
                    $scope.$apply(function () {
                        $scope.initMenu.id = dataId;
                        var path = $scope.path = $scope.menuData[dataId].firstLink;
                        if ($scope.menuData[dataId].isSkip) {
                            $cookies.put('sidebar', toggleFlag, { path: '/' });
                            $window.location.href = path;
                        }
                        else {
                            $location.url(path);
                        }
                    });
                });
                $element.find('.sub-nav').on('click', '.nav-link', function () {
                    $('.left-nav .sub-nav .nav-link').removeClass('current');
                    $(this).addClass('current');
                });
                $element.find('.sub-nav').on('click', '.accordion-toggle', function () {
                    $(this).find('.iconfont').toggleClass('icon-arrow_down');
                });
            };
            this.templateUrl = '/vpn/template/left-nav.html';
        }
        return LeftNav_old;
    }());
    MDirective.LeftNav_old = LeftNav_old;
    var LeftNav = /** @class */ (function () {
        function LeftNav($location, $rootScope) {
            this.scope = {
                menuConfig: '='
            };
            this.restrict = 'A';
            this.replace = true;
            this.link = function ($scope, $element, $attrs, $ctrl, $transclude) {
                $scope.currentUrl = '/';
                $scope.menu = [];
                function urlChangeHandler() {
                    if ($scope.currentUrl !== $location.absUrl()) {
                        $scope.currentUrl = $location.absUrl();
                        $scope.menuConfig.forEach(function (item) {
                            if (item.main.test($scope.currentUrl)) {
                                $scope.menu = item.config;
                            }
                        });
                        $scope.menu.forEach(function (item) {
                            if (!item.isHeader && !item.hasMenu) {
                                item.selected = item.urlRegexp.test($scope.currentUrl);
                            }
                            else if (item.hasMenu) {
                                for (var i = 0; i < item.subTab.length; i++) {
                                    if (item.subTab[i].urlRegexp.test($scope.currentUrl)) {
                                        item.toggle = true;
                                        item.subTab[i].selected = true;
                                    }
                                    else {
                                        item.subTab[i].selected = false;
                                    }
                                }
                            }
                        });
                    }
                }
                $rootScope.$on('$routeChangeSuccess', function (e, current) {
                    urlChangeHandler();
                });
                $rootScope.$on('$locationChangeSuccess', function (e, current) {
                    urlChangeHandler();
                });
            };
            this.template = "<div class=\"sys-sub-menu\">\n                                <div class=\"menu-item\" ng-repeat=\"item in menu\">\n                                    <h3 ng-if=\"item.isHeader\">{{item.text}}</h3>\n                                    <a ng-if=\"!item.isHeader && !item.hasMenu\" ng-href=\"{{item.link}}\" ng-class=\"{select: item.selected}\">{{item.text}}</a>\n                                    <div class=\"menu-dropdown\" ng-if=\"item.hasMenu\">\n                                        <div class=\"menu-dropdown-toggle\" ng-click=\"item.toggle = !item.toggle;\">{{item.text}}<i class=\"iconfont\" ng-class=\"{'icon-arrow_down': item.toggle, 'icon-arrow_right': !item.toggle}\"></i></div>\n                                        <ul class=\"menu-dropdown-list\" ng-class=\"{'menu-list-hide': !item.toggle}\">\n                                            <li ng-repeat=\"cell in item.subTab\"><a ng-href=\"{{cell.link}}\" ng-class=\"{select: cell.selected}\">{{cell.text}}</a></li>    \n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>";
        }
        return LeftNav;
    }());
    MDirective.LeftNav = LeftNav;
    var Pagination = /** @class */ (function () {
        function Pagination($location) {
            var _this = this;
            this.$location = $location;
            this.restrict = 'EA';
            this.replace = true;
            this.scope = {
                pageOptions: '='
            };
            this.link = function ($scope, $element, $attrs, ctrl) {
                function createPageInfo() {
                    var currentPage = $scope.pageOptions.currentPage, totalPage = Math.ceil($scope.pageOptions.totalSize / $scope.pageOptions.pageSize), pageInfo = [], pageInfoItem = {
                        pageNum: 0,
                        isCurrent: false,
                        isEllipsis: false
                    }, startPage = currentPage - 2, endPage = currentPage + 2;
                    if (totalPage < 6) {
                        for (var i = 1; i <= totalPage; i++) {
                            pageInfoItem.pageNum = i;
                            pageInfoItem.isEllipsis = false;
                            pageInfoItem.isCurrent = (currentPage == i);
                            pageInfo.push(pageInfoItem);
                            pageInfoItem = {
                                pageNum: 0,
                                isCurrent: false,
                                isEllipsis: false
                            };
                        }
                    }
                    else {
                        if (startPage <= 1) {
                            startPage = 1;
                        }
                        else {
                            pageInfo.push({
                                pageNum: 1,
                                isCurrent: false,
                                isEllipsis: false
                            });
                            pageInfo.push({
                                pageNum: '...',
                                pageLink: null,
                                isCurrent: false,
                                isEllipsis: true
                            });
                        }
                        for (var i = 0; i < 5; i++) {
                            var j = startPage + i;
                            pageInfoItem.pageNum = j;
                            pageInfoItem.isEllipsis = false;
                            pageInfoItem.isCurrent = (currentPage == j);
                            pageInfo.push(pageInfoItem);
                            pageInfoItem = {
                                pageNum: 0,
                                isCurrent: false,
                                isEllipsis: false
                            };
                            if (j >= totalPage)
                                break;
                        }
                        if (endPage >= totalPage) {
                            endPage = totalPage;
                        }
                        else {
                            pageInfo.push({
                                pageNum: '...',
                                isCurrent: false,
                                isEllipsis: true
                            });
                            pageInfo.push({
                                pageNum: totalPage,
                                isCurrent: false,
                                isEllipsis: false
                            });
                        }
                    }
                    pageInfoItem = null;
                    return pageInfo;
                }
                _this.$scope = $scope;
                var totalPage = Math.ceil($scope.pageOptions.totalSize / $scope.pageOptions.pageSize);
                $scope.infoPagination = {
                    show: totalPage >= 1,
                    totalPage: totalPage,
                    pageInfo: createPageInfo(),
                    goToNext: function () {
                        $scope.pageOptions.currentPage = $scope.pageOptions.currentPage < $scope.infoPagination.totalPage ? ++$scope.pageOptions.currentPage : $scope.infoPagination.totalPage;
                    },
                    goToPrev: function () {
                        $scope.pageOptions.currentPage = $scope.pageOptions.currentPage > 1 ? --$scope.pageOptions.currentPage : 1;
                    },
                    clickGoTo: function (num) {
                        $scope.pageOptions.currentPage = num;
                    }
                };
                $scope.$watch('pageOptions.totalSize', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        var totalPage_1 = Math.ceil($scope.pageOptions.totalSize / $scope.pageOptions.pageSize);
                        $scope.infoPagination.show = totalPage_1 >= 1;
                        $scope.infoPagination.totalPage = totalPage_1;
                        $scope.infoPagination.pageInfo = createPageInfo();
                    }
                });
                $scope.$watch('pageOptions.pageSize', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        var size = Math.ceil($scope.pageOptions.totalSize / $scope.pageOptions.pageSize);
                        $scope.infoPagination.totalPage = size;
                        $scope.infoPagination.show = size >= 1;
                        $scope.infoPagination.pageInfo = createPageInfo();
                        if ($scope.pageOptions.currentPage != 1) {
                            $scope.pageOptions.currentPage = 1;
                        }
                        if ($scope.pageOptions.showPageOnUrl) {
                            $location.search('size', newVal);
                        }
                    }
                });
                $scope.$watch('pageOptions.currentPage', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        $scope.infoPagination.pageInfo = createPageInfo();
                        if (Utils.notNullnotUndefined($scope.pageOptions.getData)) {
                            $scope.pageOptions.getData();
                        }
                    }
                    if ($scope.pageOptions.showPageOnUrl) {
                        if ((newVal != 1 || oldVal != 1) && oldVal != newVal) {
                            $location.search('page', newVal);
                        }
                    }
                });
            };
            this.templateUrl = '/vpn/template/directives/syspagination.html';
        }
        return Pagination;
    }());
    MDirective.Pagination = Pagination;
    var GridRowClick = /** @class */ (function () {
        function GridRowClick() {
            this.restrict = 'EA';
            this.replace = false;
            this.scope = false;
            this.link = function ($scope, $element, $attrs, ctrl) {
                var method = $scope[$attrs.wGridRowClick], grid = $($element);
                grid.on('click', '.ngRow', function (e) {
                    if (Utils.notNullnotUndefined(method)) {
                        method(e);
                    }
                });
            };
        }
        return GridRowClick;
    }());
    MDirective.GridRowClick = GridRowClick;
    var SearchBox = /** @class */ (function () {
        function SearchBox($location, acMgr) {
            var _this = this;
            this.$location = $location;
            this.acMgr = acMgr;
            this.conditions = {};
            this.scope = true;
            this.restrict = 'EA';
            this.replace = true;
            this.templateUrl = '/vpn/template/directives/searchBox.html';
            this.link = function ($scope, $element, $attrs, $ctrl, $transclude) {
                var parentScope = $scope.$parent;
                var options = parentScope[$attrs.wOptions];
                var location = $location.search();
                function initSearch() {
                    $scope.searchBox = {
                        currentDialogKey: null,
                        currentDialogValue: null,
                        currentDisplayValue: null,
                        currentListKey: null,
                        currentListValue: null,
                        currentListTextValue: null,
                        currentOtherKey: null,
                        currentOtherValue: null,
                        currentOtherTextValue: null,
                        firstRelate: null,
                        secondRelate: null,
                        thirdRelate: null
                    };
                    if (options.dialog) {
                        $scope.searchBox.currentDialogKey = options.dialog;
                        if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.account)) {
                            var msg = new ApiHeader.QueryObject();
                            msg.addCondition({ name: 'uuid', op: '=', value: location.account });
                            acMgr.query(msg, function (accounts) {
                                $scope.searchBox.currentDialogValue = accounts[0];
                                $scope.searchBox.currentDisplayValue = Utils.notNullnotUndefined($scope.searchBox.currentDialogValue) ? $scope.searchBox.currentDialogValue.name : null;
                            }, false);
                        }
                        else {
                            $scope.searchBox.currentDialogValue = options.dialog.value;
                            $scope.searchBox.currentDisplayValue = Utils.notNullnotUndefined($scope.searchBox.currentDialogValue) ? $scope.searchBox.currentDialogValue.name : null;
                        }
                    }
                    if (options.list) {
                        if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.name) && Utils.notNullnotUndefined(location.value)) {
                            angular.forEach(options.list, function (item) {
                                if (item.name == location.name) {
                                    $scope.searchBox.currentListKey = item;
                                    return false;
                                }
                            });
                            if (Utils.notNullnotUndefined($scope.searchBox.currentListKey.valueList)) {
                                angular.forEach($scope.searchBox.currentListKey.valueList, function (item) {
                                    if (item.value == location.value) {
                                        $scope.searchBox.currentListValue = item;
                                        return false;
                                    }
                                });
                            }
                            else {
                                $scope.searchBox.currentListTextValue = location.value;
                            }
                        }
                        else {
                            $scope.searchBox.currentListKey = options.list[0];
                            if ($scope.searchBox.currentListKey.valueList) {
                                $scope.searchBox.currentListValue = $scope.searchBox.currentListKey.valueList[0];
                            }
                        }
                        $scope.$watch(function () {
                            return $scope.searchBox.currentListKey;
                        }, function (val, old) {
                            if (val != old) {
                                if (Utils.notNullnotUndefined(val.valueList)) {
                                    $scope.searchBox.currentListTextValue = null;
                                    $scope.searchBox.currentListValue = val.valueList[0];
                                }
                            }
                        }, true);
                    }
                    if (options.other) {
                        if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.otherName) && Utils.notNullnotUndefined(location.otherValue)) {
                            angular.forEach(options.other, function (item) {
                                if (item.name == location.otherName) {
                                    $scope.searchBox.currentOtherKey = item;
                                    return false;
                                }
                            });
                            if (Utils.notNullnotUndefined($scope.searchBox.currentOtherKey.valueList)) {
                                angular.forEach($scope.searchBox.currentOtherKey.valueList, function (item) {
                                    if (item.value == location.otherValue) {
                                        $scope.searchBox.currentOtherValue = item;
                                        return false;
                                    }
                                });
                            }
                            else {
                                $scope.searchBox.currentOtherTextValue = location.otherValue;
                            }
                        }
                        else {
                            $scope.searchBox.currentOtherKey = options.other[0];
                            if ($scope.searchBox.currentOtherKey.valueList) {
                                $scope.searchBox.currentOtherValue = $scope.searchBox.currentOtherKey.valueList[0];
                            }
                        }
                        $scope.$watch(function () {
                            return $scope.searchBox.currentOtherKey;
                        }, function (val, old) {
                            if (val != old) {
                                if (Utils.notNullnotUndefined(val.valueList)) {
                                    $scope.searchBox.currentOtherTextValue = null;
                                    $scope.searchBox.currentOtherValue = val.valueList[0];
                                }
                            }
                        }, true);
                    }
                    if (options.text) {
                        angular.forEach(options.text, function (item, index) {
                            if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location[item.name])) {
                                var list = item.valueList, len = list.length;
                                for (var i = 0; i < len; i++) {
                                    if (list[i].value == location[item.name]) {
                                        $scope.searchBox[item.name] = list[i];
                                        break;
                                    }
                                }
                            }
                            else {
                                $scope.searchBox[item.name] = item.valueList[0];
                            }
                        });
                    }
                    if (options.datetime) {
                        var start = Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.start) ? new Date(location.start) : null;
                        var end = Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location.end) ? new Date(location.end) : null;
                        $scope.searchBox.startDate = {
                            value: start,
                            isOpend: false,
                            datepickerOptions: {
                                formatYear: 'yy',
                                /*maxDate: new Date(),*/
                                showWeeks: false,
                                startingDay: 1
                            },
                            open: function () {
                                $scope.searchBox.startDate.isOpend = true;
                            }
                        };
                        $scope.$watch(function () {
                            return $scope.searchBox.startDate.value;
                        }, function (val) {
                            if (Utils.notNullnotUndefined(val)) {
                                $scope.searchBox.endDate.datepickerOptions.minDate = val;
                            }
                        });
                        $scope.$watch(function () {
                            return $scope.searchBox.endDate.value;
                        }, function (val) {
                            if (Utils.notNullnotUndefined(val)) {
                                $scope.searchBox.startDate.datepickerOptions.maxDate = val;
                            }
                        });
                        if (options.datetime.length == 2) {
                            $scope.searchBox.endDate = {
                                value: end,
                                isOpend: false,
                                datepickerOptions: {
                                    formatYear: 'yy',
                                    /*maxDate: new Date(),*/
                                    showWeeks: false,
                                    startingDay: 1
                                },
                                open: function () {
                                    $scope.searchBox.endDate.isOpend = true;
                                }
                            };
                        }
                    }
                    if (options.relate) {
                        var relateData_1 = options.relate.data;
                        angular.forEach($scope.searchOptions.relate.relation, function (item, index) {
                            if (index == 0) {
                                item.data = relateData_1;
                                item.data.unshift(item.all);
                            }
                            else {
                                item.data = [];
                                item.data.unshift(item.all);
                            }
                            if (Utils.notNullnotUndefined(location) && Utils.notNullnotUndefined(location[item.name])) {
                                if (index != 0) {
                                    var currentData = relateData_1[item.dataName];
                                    item.data = item.data.concat(currentData);
                                }
                                for (var i = 0; i < item.data.length; i++) {
                                    if (item.data[i][item.field] == location[item.name]) {
                                        $scope.searchBox[item.name] = item.data[i];
                                        relateData_1 = item.data[i];
                                        break;
                                    }
                                }
                            }
                            else {
                                $scope.searchBox[item.name] = item.data[0];
                            }
                        });
                        relateData_1 = null;
                    }
                }
                _this.$scope = $scope;
                _this.options = options;
                $scope.searchOptions = parentScope[$attrs.wOptions];
                initSearch();
                if (options.dialog) {
                    $scope.$watch(function () {
                        return parentScope[$attrs.wOptions].dialog.value;
                    }, function (newVal) {
                        if (Utils.notNullnotUndefined(newVal)) {
                            $scope.searchBox.currentDialogValue = newVal;
                            $scope.searchBox.currentDisplayValue = newVal.name;
                        }
                        else {
                            $scope.searchBox.currentDialogValue = null;
                            $scope.searchBox.currentDisplayValue = '';
                        }
                    });
                }
                $scope.changeRelate = function (data, index, last) {
                    if (!last) {
                        var relateData = data;
                        var lastIndex = index + 1;
                        var all = [$scope.searchOptions.relate.relation[lastIndex].all];
                        var notAll = relateData[$scope.searchOptions.relate.relation[lastIndex].dataName];
                        var field = $scope.searchOptions.relate.relation[lastIndex].name;
                        $scope.searchOptions.relate.relation[lastIndex].data = all.concat(notAll);
                        $scope.searchBox[field] = $scope.searchOptions.relate.relation[lastIndex].data[0];
                    }
                };
                $scope.startSearch = function () {
                    var req = [], val = null, op = null, searchObj = {
                        account: null,
                        portName: null,
                        name: null,
                        value: null,
                        otherName: null,
                        otherValue: null,
                        start: null,
                        end: null
                    };
                    if ($scope.searchOptions.dialog) {
                        if (Utils.notNullnotUndefined($scope.searchBox.currentDialogValue)) {
                            req.push({
                                name: $scope.searchBox.currentDialogKey.name,
                                op: '=',
                                value: $scope.searchBox.currentDialogValue.uuid
                            });
                            searchObj.account = $scope.searchBox.currentDialogValue.uuid;
                        }
                    }
                    if ($scope.searchOptions.list) {
                        if (Utils.notNullnotUndefined($scope.searchBox.currentListKey) && $scope.searchBox.currentListTextValue) {
                            if (_this.isBelongcheckInput()) {
                                op = '=';
                                val = $scope.searchBox.currentListTextValue;
                            }
                            else {
                                op = 'like';
                                val = '%' + $scope.searchBox.currentListTextValue + '%';
                            }
                            searchObj.name = $scope.searchBox.currentListKey.name;
                            searchObj.value = $scope.searchBox.currentListTextValue;
                            req.push({
                                name: $scope.searchBox.currentListKey.name,
                                op: op,
                                value: val
                            });
                        }
                        else if ($scope.searchBox.currentListValue && $scope.searchBox.currentListValue.value) {
                            if ($scope.searchBox.currentListKey.name == 'expireDate') {
                                if ($scope.searchBox.currentListValue.value == 'expired') {
                                    val = MRoot.filterDate()(new Date());
                                    op = '<';
                                }
                                else if ($scope.searchBox.currentListValue.value == 'expireing') {
                                    var timestamp = 1000 * 60 * 60 * 24 * 7 + new Date().getTime();
                                    val = MRoot.filterDate()(new Date());
                                    op = '>';
                                    req.push({
                                        name: $scope.searchBox.currentListKey.name,
                                        op: '<',
                                        value: MRoot.filterDate()(new Date(timestamp))
                                    });
                                }
                                else {
                                    val = MRoot.filterDate()(new Date());
                                    op = '>';
                                }
                            }
                            else {
                                val = $scope.searchBox.currentListValue.value;
                                op = '=';
                            }
                            req.push({
                                name: $scope.searchBox.currentListKey.name,
                                op: op,
                                value: val
                            });
                            searchObj.name = $scope.searchBox.currentListKey.name;
                            searchObj.value = $scope.searchBox.currentListValue.value;
                        }
                    }
                    if ($scope.searchOptions.other) {
                        if ($scope.searchBox.currentOtherTextValue) {
                            val = '%' + $scope.searchBox.currentOtherTextValue + '%';
                            if ($scope.searchBox.currentOtherKey.name.toLowerCase().indexOf('uuid') > -1) {
                                op = '=';
                            }
                            else {
                                op = 'like';
                            }
                            searchObj.otherName = $scope.searchBox.currentOtherKey.name;
                            searchObj.otherValue = $scope.searchBox.currentOtherTextValue;
                            req.push({
                                name: $scope.searchBox.currentOtherKey.name,
                                op: op,
                                value: val
                            });
                        }
                        else if ($scope.searchBox.currentOtherValue && $scope.searchBox.currentOtherValue.value) {
                            val = $scope.searchBox.currentOtherValue.value;
                            op = '=';
                            searchObj.otherName = $scope.searchBox.currentOtherKey.name;
                            searchObj.otherValue = $scope.searchBox.currentOtherValue.value;
                            req.push({
                                name: $scope.searchBox.currentOtherKey.name,
                                op: op,
                                value: val
                            });
                        }
                    }
                    if ($scope.searchOptions.text) {
                        angular.forEach($scope.searchOptions.text, function (item, index) {
                            if (Utils.notNullnotUndefined($scope.searchBox[item.name]) && Utils.notNullnotUndefined($scope.searchBox[item.name].value)) {
                                req.push({
                                    name: item.name,
                                    op: '=',
                                    value: $scope.searchBox[item.name].value
                                });
                                searchObj[item.name] = $scope.searchBox[item.name].value;
                            }
                        });
                    }
                    if ($scope.searchOptions.datetime) {
                        var len_1 = $scope.searchOptions.datetime.length;
                        angular.forEach($scope.searchOptions.datetime, function (item, index) {
                            var filter = MRoot.filterDate();
                            if (index == 0 && Utils.notNullnotUndefined($scope.searchBox.startDate.value)) {
                                var op_1 = len_1 == 1 ? '=' : '>';
                                var date = filter($scope.searchBox.startDate.value, false, true);
                                req.push({
                                    name: item.name,
                                    op: op_1,
                                    value: date + ' 00:00:00'
                                });
                                searchObj.start = date;
                            }
                            else if (index == 1 && Utils.notNullnotUndefined($scope.searchBox.endDate.value)) {
                                var date = filter($scope.searchBox.endDate.value, false, true);
                                req.push({
                                    name: item.name,
                                    op: '<',
                                    value: date + ' 23:59:59'
                                });
                                searchObj.end = date;
                            }
                        });
                    }
                    if ($scope.searchOptions.relate) {
                        angular.forEach($scope.searchOptions.relate.relation, function (item, index) {
                            if ($scope.searchBox[item.name] != item.all) {
                                req.push({
                                    name: item.name,
                                    op: '=',
                                    value: $scope.searchBox[item.name][item.field]
                                });
                                searchObj[item.name] = $scope.searchBox[item.name][item.field];
                            }
                        });
                    }
                    if ($scope.searchOptions.linkage) {
                        angular.forEach($scope.searchOptions.linkage, function (item, index) {
                            var linkage = parentScope[$attrs.wOptions].linkage[index].ngModel;
                            var name = item.name;
                            if (Utils.notNullnotUndefined(linkage)) {
                                var value = linkage[item.linkField];
                                req.push({
                                    name: name,
                                    op: '=',
                                    value: value
                                });
                                searchObj[name] = value;
                            }
                            else {
                                searchObj[name] = null;
                            }
                        });
                    }
                    if ($scope.searchOptions.hasAdvancedSearch) {
                        options.search(searchObj);
                    }
                    else {
                        if (_this.searchChanged(searchObj, $location.search())) {
                            $location.search(searchObj);
                        }
                        else {
                            if (Utils.notNullnotUndefined(options.search)) {
                                options.search(req);
                            }
                        }
                    }
                };
            };
        }
        SearchBox.prototype.searchChanged = function (local, url) {
            var flag = false;
            angular.forEach(local, function (value, key) {
                if ((value && !url[key]) || (url[key] && !value) || (value && url[key] && value != url[key])) {
                    flag = true;
                    return false;
                }
            });
            return flag;
        };
        SearchBox.prototype.isBelongcheckInput = function () {
            var keyName = this.$scope.searchBox.currentListKey.name.toLowerCase();
            var arr = ['uuid', 'number'];
            var keepGoing = true;
            var flag = false;
            angular.forEach(arr, function (i) {
                if (keepGoing) {
                    if (keyName == i || keyName.indexOf(i) > -1) {
                        keepGoing = false;
                        flag = true;
                    }
                }
            });
            return flag;
        };
        return SearchBox;
    }());
    MDirective.SearchBox = SearchBox;
    var LinkagePicker = /** @class */ (function () {
        function LinkagePicker() {
            this.replace = true;
            this.restrict = 'EA';
            this.scope = {
                relation: '='
            };
            this.link = function (scope, $element, $attrs) {
                scope.activeJustified = 0;
                scope.skipNextTab = function (index, isLast, skip) {
                    if (isLast) {
                        scope.activeJustified = 0;
                        $element.parent().hide();
                    }
                    else {
                        scope.activeJustified = index + skip;
                    }
                };
            };
            this.templateUrl = '/vpn/template/directives/linkagePicker.html';
        }
        return LinkagePicker;
    }());
    MDirective.LinkagePicker = LinkagePicker;
    var ConfirmBox = /** @class */ (function () {
        function ConfirmBox($scope, $sce, $attrs, $element, $compile) {
            this.$scope = $scope;
            this.$sce = $sce;
            this.$attrs = $attrs;
            this.$element = $element;
            this.$compile = $compile;
            var options = this.options = $scope.$parent[$attrs.wOptions];
            var windowOptions = this.windowOptions
                = new Utils.DialogManage($element, { width: options.width, type: options.type, height: options.height });
            if (Utils.notNullnotUndefined(options.html)) {
                var desc = $element.find('#description');
                var el = $(options.html);
                desc.append(el);
            }
            $scope.dialogOptions = {
                title: options.title,
                close: function (el) {
                    windowOptions.close(el);
                }
            };
            if (Utils.notNullnotUndefinedNotEmptyString(options.tips)) {
                $scope.isTips = true;
                $scope.tips = this.$sce.trustAsHtml(this.options.tips());
            }
            else {
                $scope.isTips = false;
            }
            if (Utils.notNullnotUndefinedNotEmptyString(options.showRefundRule)) {
                $scope.isShowRefundRule = true;
                var compileFn = $compile(this.options.showRefundRule());
                var $dom = compileFn($scope);
                $('.showRefundRule').empty();
                $dom.appendTo('.showRefundRule');
            }
            else {
                $scope.isShowRefundRule = false;
            }
            $scope.confirm = function () {
                if (Utils.notNullnotUndefined(options.confirm)) {
                    options.confirm();
                }
                windowOptions.close();
            };
            $scope.cancel = function (e) {
                if (Utils.notNullnotUndefined(options.cancel)) {
                    options.cancel();
                }
                windowOptions.close(e);
            };
        }
        ConfirmBox.prototype.open = function () {
            if (Utils.notNullnotUndefined(this.options.description)) {
                this.$scope.description = this.$sce.trustAsHtml(this.options.description());
            }
            this.windowOptions.open();
        };
        ConfirmBox.prototype.close = function () {
            this.windowOptions.close();
        };
        return ConfirmBox;
    }());
    var CommonWindow = /** @class */ (function () {
        function CommonWindow($sce, $compile) {
            this.$sce = $sce;
            this.$compile = $compile;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                scope.$parent[$attrs.wCommonWindow] = new ConfirmBox(scope, $sce, $attrs, $element, $compile);
                scope.refundRule = function () {
                    scope.$parent.refundRuleParent();
                };
            };
            this.templateUrl = '/vpn/template/directives/commonWindow.html';
        }
        return CommonWindow;
    }());
    MDirective.CommonWindow = CommonWindow;
    var OneBtnWindow = /** @class */ (function () {
        function OneBtnWindow($sce, $compile) {
            this.$sce = $sce;
            this.$compile = $compile;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                scope.$parent[$attrs.wOneBtnWindow] = new ConfirmBox(scope, $sce, $attrs, $element, $compile);
            };
            this.templateUrl = '/vpn/template/directives/oneBtnWindow.html';
        }
        return OneBtnWindow;
    }());
    MDirective.OneBtnWindow = OneBtnWindow;
    var LoadingWindow = /** @class */ (function () {
        function LoadingWindow($sce, $compile) {
            this.$sce = $sce;
            this.$compile = $compile;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                scope.$parent[$attrs.wLoadingWindow] =
                    new ConfirmBox(scope, $sce, $attrs, $element, $compile);
            };
            this.templateUrl = '/vpn/template/directives/loadingWindow.html';
        }
        return LoadingWindow;
    }());
    MDirective.LoadingWindow = LoadingWindow;
    var RefundRule = /** @class */ (function () {
        function RefundRule($sce, $compile) {
            var _this = this;
            this.$sce = $sce;
            this.$compile = $compile;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wRefundRule] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, {
                    width: options.width,
                    type: options.type,
                    height: 500
                });
            };
            this.templateUrl = '/vpn/template/directives/refundRule.html';
        }
        RefundRule.prototype.open = function () {
            this.options.open();
        };
        return RefundRule;
    }());
    MDirective.RefundRule = RefundRule;
    var ProxyAccount = /** @class */ (function () {
        function ProxyAccount() {
            this.restrict = 'EA';
            this.replace = true;
            this.scope = {
                accountName: '@'
            };
            this.controllerAs = 'ProxyAccountCtrl';
            this.link = function ($scope, $element, $attrs) {
            };
            this.controller = ['$scope', '$cookies', '$route', 'WAccountManage', function ($scope, $cookies, $route, acMgr) {
                    $scope.optionsSearchAccount = {
                        width: '650px',
                        type: 'center',
                        done: function (account) {
                            acMgr.proxyAccount(account.uuid, function () {
                                $scope.accountName = account.name;
                                $cookies.put('proxyName', account.name, { path: '/' });
                                $route.reload();
                            });
                        }
                    };
                    $scope.resetProxy = function () {
                        acMgr.proxyAccount('', function () {
                            $cookies.remove('proxyName', { path: '/' });
                            $scope.accountName = '';
                            $route.reload();
                        });
                    };
                    $scope.openWin = function () {
                        $scope.searchAccount.open();
                    };
                }];
            this.templateUrl = '/vpn/template/directives/proxyAccount.html';
        }
        return ProxyAccount;
    }());
    MDirective.ProxyAccount = ProxyAccount;
    var Bandwidth = /** @class */ (function () {
        function Bandwidth() {
            var _this = this;
            this.restrict = 'AE';
            this.replace = true;
            this.scope = {
                wOptions: '=',
                inputName: '='
            };
            this.link = function (scope, $element, $attrs, controller) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wBandwidth] = _this;
                scope.bandwidthResult = null;
                scope.bandwidthRanges = Utils.bandwidthRanges;
                scope.bandwidthRange = scope.bandwidthRanges[0];
                scope.$watch('wOptions', function (newVal) {
                    if (newVal) {
                        if (newVal.models) {
                            scope.bandwidthResult = newVal.models;
                            scope.changeBandwidthRange(scope.bandwidthRange);
                        }
                        if (newVal.currentItem) {
                            scope.currentItem = newVal.currentItem;
                            var currentItemSize = Utils.parseSize(newVal.currentItem);
                            if (currentItemSize <= Utils.parseSize('100M')) {
                                scope.bandwidthRange = scope.bandwidthRanges[0];
                            }
                            else if (currentItemSize <= Utils.parseSize('200M')) {
                                scope.bandwidthRange = scope.bandwidthRanges[1];
                            }
                            else if (currentItemSize <= Utils.parseSize('1G')) {
                                scope.bandwidthRange = scope.bandwidthRanges[2];
                            }
                            else {
                                scope.bandwidthRange = scope.bandwidthRanges[3];
                            }
                            scope.changeBandwidthRange(scope.bandwidthRange);
                            scope.outputBandwidth = scope.bandwidthResult.filter(function (item) { return item.uuid === newVal.currentItem; })[0];
                        }
                    }
                }, true);
                scope.selectBandwidth = function (item) {
                    scope.outputBandwidth = item;
                    if (scope.wOptions) {
                        scope.wOptions.done(item);
                    }
                };
                scope.changeBandwidthRange = function (item) {
                    scope.bandwidthRange = item;
                    scope.outputBandwidth = null;
                    scope.wOptions.done(null);
                    if (scope.bandwidthResult) {
                        switch (scope.bandwidthRange.text) {
                            case '小于100M':
                                scope.allBandwidth = [];
                                angular.forEach(scope.bandwidthResult, function (item) {
                                    if (item.bandwidth <= Utils.parseSize('100M')) {
                                        scope.allBandwidth.push(item);
                                    }
                                });
                                break;
                            case '100M-200M':
                                scope.allBandwidth = [];
                                angular.forEach(scope.bandwidthResult, function (item) {
                                    if (item.bandwidth > Utils.parseSize('100M') && item.bandwidth <= Utils.parseSize('200M')) {
                                        scope.allBandwidth.push(item);
                                    }
                                });
                                break;
                            case '200M-1G':
                                scope.allBandwidth = [];
                                angular.forEach(scope.bandwidthResult, function (item) {
                                    if (item.bandwidth > Utils.parseSize('200M') && item.bandwidth <= Utils.parseSize('1G')) {
                                        scope.allBandwidth.push(item);
                                    }
                                });
                                break;
                            case '大于1G':
                                scope.allBandwidth = [];
                                angular.forEach(scope.bandwidthResult, function (item) {
                                    if (item.bandwidth > Utils.parseSize('1G')) {
                                        scope.allBandwidth.push(item);
                                    }
                                });
                                break;
                        }
                    }
                };
            };
            this.templateUrl = '/vpn/template/directives/bandwidth.html';
        }
        return Bandwidth;
    }());
    MDirective.Bandwidth = Bandwidth;
})(MDirective || (MDirective = {}));
angular.module('app.directive', ['ui.bootstrap', 'ngLocale'])
    .directive('wLeftNav', ['$location', '$rootScope', function ($location, $rootScope) {
        return new MDirective.LeftNav($location, $rootScope);
    }])
    .directive('wPagination', ['$location', function ($location) {
        return new MDirective.Pagination($location);
    }])
    .directive('wCommonWindow', ['$sce', '$compile', function ($sce, $compile) {
        return new MDirective.CommonWindow($sce, $compile);
    }])
    .directive('wOneBtnWindow', ['$sce', '$compile', function ($sce, $compile) {
        return new MDirective.OneBtnWindow($sce, $compile);
    }])
    .directive('wGridRowClick', [function () {
        return new MDirective.GridRowClick();
    }])
    .directive('wLinkage', [function () {
        return new MDirective.LinkagePicker();
    }])
    .directive('wSearch', ['$location', 'WAccountManage', function ($location, acMgr) {
        return new MDirective.SearchBox($location, acMgr);
    }])
    .directive('wLoadingWindow', ['$sce', '$compile', function ($sce, $compile) {
        return new MDirective.LoadingWindow($sce, $compile);
    }])
    .directive('wRefundRule', ['$sce', '$compile', function ($sce, $compile) {
        return new MDirective.RefundRule($sce, $compile);
    }]).directive('wProxyAccount', [function () {
        return new MDirective.ProxyAccount();
    }]).directive('wBandwidth', [function () {
        return new MDirective.Bandwidth();
    }]);
;
/// <reference path = './d.ts/angularjs/angular.d.ts'/>
/// <reference path = './d.ts/zstack.d.ts' />
var MRoot;
(function (MRoot) {
    var Events = /** @class */ (function () {
        function Events() {
        }
        Events.NOTIFICATION = 'root.notification';
        return Events;
    }());
    MRoot.Events = Events;
    var Details = /** @class */ (function () {
        function Details() {
        }
        return Details;
    }());
    var Main = /** @class */ (function () {
        function Main($scope, $rootScope, $location, $cookies, api) {
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$location = $location;
            this.$cookies = $cookies;
            this.api = api;
            //session 验证
            $rootScope.loginFlag = !!$cookies.get('sessionid');
            //通知信息
            $scope.alertMessage = {
                data: [],
                close: function (index) {
                    $scope.alertMessage.data.splice(index, 1);
                },
                add: function (msg) {
                    $scope.alertMessage.data.push(msg);
                }
            };
            api.installListener(null, function (request, response) {
                var d = new Details();
                d.apiId = Utils.firstItem(response).apiId;
                d.request = JSON.stringify(request.toApiMap(), null, 2);
                d.response = JSON.stringify(response, null, 2);
                d.success = Utils.firstItem(response).success;
                d.error = Utils.firstItem(response).error;
                if (!d.success && Utils.notNullnotUndefined(d.error)) {
                    if (d.error.code == 'ID.1000') {
                        $rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                            type: 'danger',
                            msg: '登陆认证错误!'
                        });
                    }
                    else if (d.error.code == 'ID.1001') {
                        $rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                            type: 'danger',
                            msg: 'session无效!'
                        });
                    }
                    else if (d.error.code == 'ID.1002') {
                        $rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                            type: 'danger',
                            msg: '权限不足!'
                        });
                    }
                    else {
                        $rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                            type: 'danger',
                            msg: d.error.details
                        });
                    }
                }
            });
            $scope.$on(Events.NOTIFICATION, function (error, message) {
                $scope.alertMessage.add(message);
            });
            //分页
            $rootScope.pageSize = 10;
            //登录相关
            $rootScope.loginError = false;
            $scope.getAccountName = function () {
                return $cookies.get('accountName');
            };
            $scope.logout = function () {
                var msg = new ApiHeader.APILogOutMsg();
                msg.sessionUuid = $cookies.get('sessionid');
                _this.api.restCall(msg, function (ret) {
                    $rootScope.loginFlag = false;
                    $rootScope.sessionUuid = null;
                    $scope.accountName = null;
                    $scope.password = null;
                    $rootScope.loginError = false;
                    $cookies.remove('accountName', { path: '/' });
                    $cookies.remove('accountUuid', { path: '/' });
                    $cookies.remove('userUuid', { path: '/' });
                    $cookies.remove('sessionid', { path: '/' });
                    $cookies.remove('sidebar', { path: '/' });
                    $cookies.remove('loginType');
                    window.location.href = '/naas/account/login.html';
                });
            };
            $scope.isProxy = $cookies.get('accountType') === 'Proxy';
            $scope.proxyAccountName = $cookies.get('proxyName');
            //点击其他地方收起节点折叠
            angular.element(document).bind('click', function (e) {
                var target = angular.element(e.target);
                if (target.closest('.linkComponent').length == 0) {
                    angular.element('.linkComponent .linkage-container').slideUp(200);
                }
                e.stopPropagation();
            });
            //左侧导航
            $scope.mainMenuConfig = {
                toggle: $cookies.get('sidebar') == 'open',
                toggleClick: function (toggle) {
                    $cookies.put('sidebar', toggle ? 'open' : 'close', { path: '/' });
                }
            };
            $scope.subMenuConfig = [{
                    main: /#\/vpn/,
                    config: [{
                            text: '云网关',
                            link: null,
                            isHeader: true,
                            hasMenu: false
                        }, {
                            text: '云网关',
                            link: '#/vpn/gateway',
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /gateway/g
                        }, {
                            text: '云网关证书',
                            link: '#/vpn/vpnCertificate',
                            isHeader: false,
                            hasMenu: false,
                            urlRegexp: /vpnCertificate/g
                        }]
                }];
        }
        Main.$inject = ['$scope', '$rootScope', '$location', '$cookies', 'Api'];
        return Main;
    }());
    MRoot.Main = Main;
    function filterDate() {
        return function (time, isTimeStamp, onlyDate) {
            if (isTimeStamp === void 0) { isTimeStamp = false; }
            if (onlyDate === void 0) { onlyDate = false; }
            if (time) {
                var timer = isTimeStamp ? parseFloat(time) * 1000 : time, theDate = new Date(timer), year = theDate.getFullYear(), month = theDate.getMonth() + 1, day = theDate.getDate(), hour = theDate.getHours(), minutes = theDate.getMinutes(), second = theDate.getSeconds();
                function addPrefix(t) {
                    return t < 10 ? ('0' + t) : t;
                }
                month = addPrefix(month);
                day = addPrefix(day);
                hour = addPrefix(hour);
                minutes = addPrefix(minutes);
                second = addPrefix(second);
                return onlyDate ? year + "-" + month + "-" + day : year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + second;
            }
            else {
                return '';
            }
        };
    }
    MRoot.filterDate = filterDate;
})(MRoot || (MRoot = {}));
// angular.module('root',['ngRoute','ngCookies','angular-slidezilla','ui.bootstrap','ngLocale','ngGrid','app.service','app.directive','ng-echarts'])
angular.module('root', ['ngRoute', 'ngCookies', 'ui.bootstrap', 'ngLocale', 'ngGrid', 'app.service', 'app.directive', 'app.menu'])
    .run(['$rootScope', '$templateCache', function ($rootScope, $templateCache) {
        $rootScope.$on('$routeChangeStart', function (event, next, current) {
        });
    }])
    .controller('mainController', MRoot.Main)
    .filter('wDate', function () {
    return MRoot.filterDate();
});
/// <reference path='./d.ts/angularjs/angular.d.ts' />
///<reference path="./d.ts/zstack.d.ts"/>
var MAccount;
(function (MAccount) {
    var Account = /** @class */ (function (_super) {
        __extends(Account, _super);
        function Account() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.cashBalance = '0.00';
            _this.presentBalance = '0.00';
            _this.creditPoint = '0.00';
            _this.salesName = '无';
            _this.salesman = null;
            return _this;
        }
        Account.prototype.getTranslateStatus = function () {
            if (this.status == 'Available') {
                this.translateStatus = '正常';
            }
            else if (this.status == 'Disabled') {
                this.translateStatus = '禁用';
            }
        };
        Account.prototype.getTranslateType = function () {
            if (this.type == 'SystemAdmin') {
                this.translateType = '系统管理员';
            }
            else if (this.type == 'Proxy') {
                this.translateType = '分销商';
            }
            else if (this.type == 'Normal') {
                this.translateType = '普通';
            }
        };
        Account.prototype.getTranslateOrigin = function () {
            if (this.extraInfo.createWay == 'SystemAdmin') {
                this.translateOrigin = '管理员';
            }
            else if (this.extraInfo.createWay == 'Proxy') {
                this.translateOrigin = '分销商';
            }
            else if (this.extraInfo.createWay == 'register') {
                this.translateOrigin = '注册';
            }
        };
        Account.prototype.updateAccountMessage = function (inv) {
            var self = this;
            angular.extend(self, inv);
            self.getTranslateStatus();
            self.getTranslateType();
            self.getTranslateOrigin();
        };
        Account.prototype.updateBillingMessage = function (inv) {
            var self = this;
            self.cashBalance = Utils.toFixed(inv.cashBalance, 2);
            self.presentBalance = Utils.toFixed(inv.presentBalance, 2);
            self.creditPoint = Utils.toFixed(inv.creditPoint, 2);
        };
        Account.STATES = ['Available', 'Disabled'];
        Account.TYPES = ['SystemAdmin', 'Proxy', 'Normal'];
        return Account;
    }(ApiHeader.AccountInventory));
    MAccount.Account = Account;
    var AccountManage = /** @class */ (function () {
        function AccountManage($rootScope, api) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.$inject = ['$rootScope', 'Api'];
        }
        AccountManage.prototype.query = function (qobj, callback, queryBill) {
            var _this = this;
            if (queryBill === void 0) { queryBill = true; }
            var msg = new ApiHeader.APIQueryAccountMsg();
            msg.count = qobj.count === true;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                var accounts = [], userUuids = [], uuids = '', total = 0, accountUuids = [];
                if (ret.success && ret.inventories) {
                    total = ret.total;
                    if (ret.inventories.length > 0) {
                        angular.forEach(ret.inventories, function (item) {
                            var account = new Account();
                            account.updateAccountMessage(item);
                            accounts.push(account);
                            if (queryBill) {
                                accountUuids.push(item.uuid);
                                if (Utils.notNullnotUndefined(item.extraInfo.userUuid)) {
                                    userUuids.push(item.extraInfo.userUuid);
                                }
                            }
                        });
                        if (queryBill) {
                            var message = new ApiHeader.APIGetAccountBalanceListMsg();
                            message.accountUuids = accountUuids;
                            _this.api.restCall(message, function (reply) {
                                if (reply.success) {
                                    if (reply.inventories) {
                                        var length_1 = reply.inventories.length;
                                        angular.forEach(accounts, function (item) {
                                            for (var i = 0; i < length_1; i++) {
                                                if (item.uuid == reply.inventories[i].uuid) {
                                                    item.updateBillingMessage(reply.inventories[i]);
                                                    break;
                                                }
                                            }
                                        });
                                    }
                                    if (userUuids.length > 0) {
                                        uuids = userUuids.join(',');
                                        var userMsg = new ApiHeader.APIQueryUserMsg();
                                        userMsg.conditions = [{ name: 'uuid', op: 'in', value: uuids }, {
                                                name: 'userType',
                                                op: '=',
                                                value: 'sales'
                                            }];
                                        _this.api.restCall(userMsg, function (userRet) {
                                            if (userRet.success) {
                                                var len_2 = userRet.inventories.length;
                                                if (len_2 > 0) {
                                                    angular.forEach(accounts, function (item) {
                                                        for (var i = 0; i < len_2; i++) {
                                                            if (item.extraInfo.userUuid == userRet.inventories[i].uuid) {
                                                                item.salesman = userRet.inventories[i];
                                                                item.salesName = userRet.inventories[i].trueName;
                                                                break;
                                                            }
                                                        }
                                                    });
                                                }
                                                callback(accounts, ret.total);
                                            }
                                        });
                                    }
                                    else {
                                        callback(accounts, total);
                                    }
                                }
                            });
                        }
                        else {
                            callback(accounts, total);
                        }
                    }
                    else {
                        callback([], total);
                    }
                }
            });
        };
        AccountManage.prototype.getAccount = function (done) {
            var msg = new ApiHeader.APIGetAccountMsg();
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var account = new Account();
                    account.updateAccountMessage(ret.inventory);
                    done(account);
                }
            });
        };
        AccountManage.prototype.proxyAccount = function (accountUuid, done) {
            var _this = this;
            var msg = new ApiHeader.APIProxyChangeAccountMsg();
            msg.changeAccountUuid = accountUuid;
            this.api.restCall(msg, function (rst) {
                if (rst.success) {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('切换账户{0}成功!', rst.accountName)
                    });
                    done(rst);
                }
                else {
                    _this.$rootScope.$broadcast(MRoot.Events.NOTIFICATION, {
                        type: 'error',
                        msg: Utils.sprintf('切换账户失败!')
                    });
                }
            });
        };
        return AccountManage;
    }());
    MAccount.AccountManage = AccountManage;
    var SearchAccount = /** @class */ (function () {
        function SearchAccount(acMgr, $q) {
            var _this = this;
            this.acMgr = acMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wSearchAccount] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.hasError = false;
                scope.confirm = function (e) {
                    if (scope.searchUserSelected.length) {
                        scope.hasError = false;
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(scope.searchUserSelected[0]);
                            scope.searchUserSelected.shift();
                        }
                        scope.dialogOptions.close(e);
                    }
                    else {
                        scope.hasError = true;
                    }
                };
                scope.cancel = function (e) {
                    if (scope.searchUserSelected.length) {
                        scope.searchUserSelected.shift();
                    }
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.controller = ['$scope', function ($scope) {
                    $scope.searchUserSelected = [];
                    $scope.searchUserGrid = {
                        data: null,
                        options: {
                            enableSorting: false,
                            multiSelect: false,
                            enableColumnResize: true,
                            selectedItems: $scope.searchUserSelected,
                            data: 'searchUserGrid.data',
                            headerRowHeight: 40,
                            rowHeight: 40,
                            columnDefs: [
                                {
                                    field: 'name',
                                    width: '25%',
                                    displayName: '账户名'
                                }, {
                                    field: 'phone',
                                    width: '25%',
                                    displayName: '手机号'
                                }, {
                                    field: 'email',
                                    width: '25%',
                                    displayName: '邮箱'
                                }, {
                                    field: 'company',
                                    width: '25%',
                                    displayName: '公司名称'
                                }
                            ],
                            plugins: [new Utils.flexRowHeight(), new Utils.ngGridFlexibleHeightPlugin()]
                        },
                        show: true
                    };
                    $scope.searchNames = [{
                            name: 'name',
                            text: '账户名'
                        }, {
                            name: 'phone',
                            text: '手机号'
                        }, {
                            name: 'company',
                            text: '公司名'
                        }, {
                            name: 'uuid',
                            text: 'uuid'
                        }];
                    var queryAccount = function (start) {
                        var qobj = new ApiHeader.QueryObject(), val = $scope.searchBox.value, name = $scope.searchBox.nameObj.name;
                        qobj.start = start;
                        qobj.limit = $scope.searchAccountPagination.pageSize;
                        if (val) {
                            qobj.conditions = [{ name: name, op: 'like', value: "%" + val + "%" }];
                        }
                        acMgr.query(qobj, function (accounts, total) {
                            $scope.searchUserGrid.data = accounts;
                            $scope.searchAccountPagination.totalSize = total;
                            $scope.searchUserGrid.show = total == 0;
                        }, false);
                    };
                    $scope.searchBox = {
                        nameObj: $scope.searchNames[0],
                        value: null,
                        confirm: function () {
                            queryAccount(0);
                        }
                    };
                    $scope.searchAccountPagination = {
                        pageSizeArr: [10, 15, 20],
                        pageSize: 10,
                        currentPage: 1,
                        totalSize: 0,
                        getData: function () {
                            var start = ($scope.searchAccountPagination.currentPage - 1) * $scope.searchAccountPagination.pageSize;
                            queryAccount(start);
                        }
                    };
                }];
            this.templateUrl = '/vpn/template/account/searchAccount.html';
        }
        SearchAccount.prototype.open = function () {
            var _this = this;
            this.$scope.searchBox.nameObj = this.$scope.searchNames[0];
            this.$scope.searchBox.value = null;
            this.$scope.hasError = false;
            var qobj = new ApiHeader.QueryObject();
            qobj.start = 0;
            qobj.limit = this.$scope.searchAccountPagination.pageSize;
            this.acMgr.query(qobj, function (accounts, total) {
                _this.$scope.searchUserGrid.data = accounts;
                _this.$scope.searchAccountPagination.totalSize = total;
                _this.$scope.searchUserGrid.show = total == 0;
                _this.options.open();
            });
        };
        return SearchAccount;
    }());
    MAccount.SearchAccount = SearchAccount;
})(MAccount || (MAccount = {}));
angular.module('root')
    .factory('WAccountManage', ['$rootScope', 'Api', function ($rootScope, api) {
        return new MAccount.AccountManage($rootScope, api);
    }]).directive('wSearchAccount', ['WAccountManage', '$q', function (acMgr, $q) {
        return new MAccount.SearchAccount(acMgr, $q);
    }]);
var MCertificate;
(function (MCertificate) {
    var Action = /** @class */ (function () {
        function Action($scope, certMgr) {
            this.$scope = $scope;
            this.certMgr = certMgr;
        }
        Action.prototype.updateCertName = function () {
            var vpnCertificateIf = this.$scope.selectedVpnCert[0];
            this.$scope.updateCertName.open(vpnCertificateIf);
        };
        Action.prototype.deleteCert_pass = function () {
            var vpnCertificateIf = this.$scope.selectedVpnCert[0];
            this.$scope.deleteCert_pass.open(vpnCertificateIf);
        };
        Action.prototype.deleteCert_fail = function () {
            var vpnCertificateIf = this.$scope.selectedVpnCert[0];
            this.$scope.deleteCert_fail.open(vpnCertificateIf);
        };
        Action.prototype.resetVpnCert = function () {
            var _this = this;
            var vpnCertificateIf = this.$scope.selectedVpnCert[0];
            var qobj = new ApiHeader.QueryObject();
            qobj.start = 0;
            qobj.fields = ["uuid", "name"];
            qobj.conditions = [{
                    "name": "vpnCertUuid",
                    "op": "=",
                    "value": vpnCertificateIf.uuid
                }];
            this.certMgr.getVpnNameList(qobj, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    vpnCertificateIf.vpnCertNames = ret;
                }
                else {
                    vpnCertificateIf.vpnCertNames = [];
                }
                _this.$scope.resetVpnCert.open(vpnCertificateIf);
            });
        };
        Action.prototype.certDownload = function () {
            var _this = this;
            var vpnCertificateIf = this.$scope.selectedVpnCert[0];
            this.certMgr.getCertDownloadUrl(vpnCertificateIf.uuid, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    vpnCertificateIf.downloadUrl = ret.downloadUrl;
                }
                _this.$scope.certDownload.open(vpnCertificateIf);
            });
        };
        Action.prototype.isActionShow = function (action) {
            if (Utils.notNullnotUndefinedNotEmptyString(this.$scope.selectedVpnCert)) {
                switch (action) {
                    case "delete_pass":
                        return this.$scope.selectedVpnCert[0].vpnNum == 0;
                    case "delete_fail":
                        return this.$scope.selectedVpnCert[0].vpnNum != 0;
                }
            }
        };
        return Action;
    }());
    var CertificateManager = /** @class */ (function () {
        function CertificateManager($rootScope, api) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.$inject = ['$rootScope', 'Api'];
        }
        //查询证书
        CertificateManager.prototype.query = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryVpnCertMsg();
            msg.conditions = qobj.conditions;
            msg.count = qobj.count;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.replyWithCount = qobj.replyWithCount;
            msg.sortBy = "createDate";
            msg.sortDirection = "desc";
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories, ret.total);
            });
        };
        //创建证书
        CertificateManager.prototype.create = function (currentCert, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateVpnCertMsg();
            msg.name = currentCert.name;
            msg.description = currentCert.description;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        //修改名称
        CertificateManager.prototype.updateName = function (currentCert, done) {
            var msg = new ApiHeader.APIUpdateVpnCertMsg();
            msg.uuid = currentCert.uuid;
            msg.name = currentCert.name;
            msg.description = currentCert.description;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                }
            });
        };
        //删除证书
        CertificateManager.prototype.delete = function (uuid, done) {
            var msg = new ApiHeader.APIDeleteVpnCertMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret);
                }
            });
        };
        //重置证书
        CertificateManager.prototype.reset = function (uuid, done) {
            var msg = new ApiHeader.APIResetVpnCertMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret);
                }
            });
        };
        //查询已关联vpn名称
        CertificateManager.prototype.getVpnNameList = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryVpnMsg();
            msg.conditions = qobj.conditions;
            msg.start = qobj.start;
            msg.fields = qobj.fields;
            this.api.restCall(msg, function (ret) {
                callback(ret.inventories);
            });
        };
        //获取下载证书地址
        CertificateManager.prototype.getCertDownloadUrl = function (uuid, callback) {
            var msg = new ApiHeader.APIGenerateDownloadUrlMsg();
            msg.uuid = uuid;
            msg.type = "cert";
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        return CertificateManager;
    }());
    MCertificate.CertificateManager = CertificateManager;
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, certificateParams, certMgr) {
            this.$scope = $scope;
            this.$location = $location;
            this.certificateParams = certificateParams;
            this.certMgr = certMgr;
            $scope.action = new Action($scope, certMgr);
            $scope.selectedVpnCert = [];
            var locationSearch = $location.search();
            //列表展示
            $scope.cretGrid = {
                data: certificateParams.certs,
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    selectedItems: $scope.selectedVpnCert,
                    headerRowHeight: 40,
                    rowHeight: 40,
                    data: 'cretGrid.data',
                    //列属性设置
                    columnDefs: [{
                            field: 'uuid',
                            width: '20%',
                            displayName: 'UUID',
                        }, {
                            field: 'name',
                            width: '15%',
                            displayName: '名称'
                        }, {
                            field: 'description',
                            width: '21%',
                            displayName: '描述'
                        }, {
                            field: 'vpnNum',
                            width: '10%',
                            displayName: '关联云网关数量'
                        }, {
                            field: 'createDate',
                            width: '12%',
                            displayName: '创建时间',
                            // cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)| wDate}}</div>'//重写cell
                            cellTemplate: '<div class="ngCellText ng-scope" ng-class="col.colIndex()"><span class="ng-binding">{{row.getProperty(col.field)| wDate}}</span></div>'
                        }, {
                            field: 'lastOpDate',
                            width: '12%',
                            displayName: '最后操作时间',
                            // cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>'
                            cellTemplate: '<div class="ngCellText ng-scope" ng-class="col.colIndex()"><span class="ng-binding">{{row.getProperty(col.field)| wDate}}</span></div>'
                        }, {
                            width: '10%',
                            displayName: '操作',
                            cellTemplate: '<div class="ngCellText operate-dropdown" uib-dropdown ng-if="row.getProperty(\'type\')!=\'SystemAdmin\'">' +
                                '<span uib-dropdown-toggle>更多<i class="caret"></i></span>' +
                                '<ul class="dropdown-menu" style="width: 118px;"  uib-dropdown-menu>' +
                                '<li ng-click="action.updateCertName()">修改名称</li>' +
                                '<li ng-click="action.resetVpnCert()">重置</li>' +
                                '<li ng-click="action.certDownload()">证书下载</li>' +
                                '<li ng-show="action.isActionShow(' + "'delete_pass'" + ')" ng-click="action.deleteCert_pass()">删除</li>' +
                                '<li ng-show="action.isActionShow(' + "'delete_fail'" + ')" ng-click="action.deleteCert_fail()">删除</li>' +
                                '</ul></div>'
                        }],
                    plugins: [new Utils.flexRowHeight(), new Utils.ngGridFlexibleHeightPlugin()],
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size ? locationSearch.size : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: certificateParams.total
                },
                show: certificateParams.total == 0,
            };
            //点击创建证书
            $scope.openCreateCert = function () {
                $scope.createCert.open();
            };
            //创建证书
            $scope.optionsCreateCert = {
                width: '500px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('创建{0}证书成功!', cert.inventory.name)
                    });
                    $scope.cretGrid.data.unshift(cert.inventory); //arrayObject 的新长度。
                }
            };
            //修改证书
            $scope.optionsUpdateVpnCertName = {
                width: '500px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('修改证书接口{0}成功!', cert.name)
                    });
                    Utils.arrayUpdateItem($scope.cretGrid.data, cert);
                }
            };
            //删除证书
            $scope.optionsDeleteVpnCert = {
                width: '500px',
                type: 'center',
                title: '删除证书',
                description: function () {
                    var modal = $scope.selectedVpnCert[0];
                    return Utils.sprintf('您确定要删除证书 "{0}"', modal.name);
                },
                confirm: function () {
                    var model = $scope.selectedVpnCert[0];
                    certMgr.delete(model.uuid, function (data) {
                        if (data.success) {
                            $scope.$emit(MRoot.Events.NOTIFICATION, {
                                type: 'success',
                                msg: Utils.sprintf('删除证书接口{0}成功!', model.name)
                            });
                            Utils.arrayDeleteItem($scope.cretGrid.data, model);
                        }
                    });
                }
            };
            //删除证书 --  已绑定证书
            $scope.optionsDeleteVpnCertFail = {
                width: '500px',
                type: 'center',
                title: '删除证书',
                // tips: ()=>{
                //     return "该证书正在被VPN网关使用，如要删除，请先解绑证书";
                // },
                description: function () {
                    // return Utils.sprintf('<span class="error">删除失败</span>');
                    return Utils.sprintf('该证书正在被云网关使用，如要删除，请先解绑证书');
                }
            };
            //重置证书
            $scope.optionsResetVpnCert = {
                width: '500px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('重置证书接口{0}成功!', cert.name)
                    });
                    Utils.arrayUpdateItem($scope.cretGrid.data, cert.inventory);
                }
            };
            //证书下载
            $scope.optionsDownloadVpnCert = {
                width: '500px',
                type: 'center',
                title: '证书下载',
                description: function () {
                    var modal = $scope.selectedVpnCert[0];
                    return Utils.sprintf('<div class="oneBtnContent margin-btm30"><span>名称：</span><span>{0}</span></div>' +
                        '<div class="oneBtnContent"><span>下载路径：</span><span>' +
                        '<a href="{1}" target="_blank">{1}</a>' +
                        '</span></div>', modal.name, modal.downloadUrl);
                }
            };
            $scope.optionsCreateCertLoading = {
                width: '500px',
                type: 'center',
            };
        }
        Controller.$inject = ['$scope', '$location', 'certificateParams', 'CertificateManager'];
        return Controller;
    }());
    MCertificate.Controller = Controller;
    //创建证书
    var CreateCert = /** @class */ (function () {
        function CreateCert(certMgr, $q, $cookies) {
            var _this = this;
            this.certMgr = certMgr;
            this.$q = $q;
            this.$cookies = $cookies;
            this.replace = true; //这里replace为true，所以原来的内容会被template代替
            this.restrict = 'EA'; // 指令类型  E：element A：attribute M：comment C: class
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wCreateCert] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions
                    = new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.currentCert = {
                    name: '',
                    description: '',
                };
                scope.blurValidate = {
                    name: false,
                    description: false,
                };
                //参数置空
                scope.reset = function () {
                    scope.currentCert = {
                        name: null,
                        description: null,
                    };
                    scope.blurValidate = {
                        name: false,
                        description: false,
                    };
                };
                //点击确定
                scope.confirm = function (e) {
                    scope.dialogOptions.close();
                    scope.createCertLoading.open();
                    certMgr.create(scope.currentCert, function (ret) {
                        scope.createCertLoading.close();
                        if (options.done) {
                            options.done(ret);
                        }
                    }, function (ret) {
                        scope.createCertLoading.close();
                    });
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/vpn/template/vpnCertificate/create.html';
        }
        CreateCert.prototype.open = function () {
            this.$scope.reset();
            this.options.open();
        };
        ;
        return CreateCert;
    }());
    MCertificate.CreateCert = CreateCert;
    //修改名称
    var UpdateCertName = /** @class */ (function () {
        function UpdateCertName(certMgr, $q) {
            var _this = this;
            this.certMgr = certMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateCertName] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions
                    = new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.currentCert = {
                    name: '',
                    description: '',
                };
                scope.blurValidate = {
                    name: false,
                    description: false
                };
                scope.reset = function () {
                    scope.currentCert = {
                        name: '',
                        description: '',
                    };
                    scope.blurValidate = {
                        name: false,
                        description: false
                    };
                };
                scope.confirm = function (e) {
                    certMgr.updateName(scope.currentCert, function (ret) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(ret);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/vpn/template/vpnCertificate/update.html';
        }
        UpdateCertName.prototype.open = function (cert) {
            var defer = this.$q.defer();
            this.$scope.reset();
            this.$scope.currentCert = angular.copy(cert);
            this.options.open();
        };
        ;
        return UpdateCertName;
    }());
    MCertificate.UpdateCertName = UpdateCertName;
    //重置证书
    var ResetVpnCert = /** @class */ (function () {
        function ResetVpnCert(certMgr, $q, $sce) {
            var _this = this;
            this.certMgr = certMgr;
            this.$q = $q;
            this.$sce = $sce;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wResetVpnCert] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions
                    = new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.currentCert = {
                    uuid: ''
                };
                //获取vpn名称
                scope.getVpnName = function (e) {
                    for (var i = 0, html = ''; i < e.length; i++) {
                        if (i == e.length - 1) {
                            html += e[i].name;
                        }
                        else {
                            html += e[i].name + '、';
                        }
                    }
                    if (e.length == 0) {
                        html = '无';
                    }
                    return html;
                };
                scope.confirm = function (e) {
                    certMgr.reset(scope.currentCert.uuid, function (data) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(data);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/vpn/template/vpnCertificate/reset.html';
        }
        ResetVpnCert.prototype.open = function (cert) {
            this.$scope.currentCert = angular.copy(cert);
            this.$scope.tipTxt = {
                isTips: true,
                tips: ''
            };
            var vpnName = this.$scope.getVpnName(cert.vpnCertNames);
            this.$scope.tipTxt.tips = this.$sce.trustAsHtml("<div>重置该证书会影响已关联的所有云网关业务</div><div>已关联云网关：" +
                vpnName +
                "</div><div>重置后客户端需要重新下载证书</div>");
            this.$scope.description = this.$sce.trustAsHtml("是否确定重置证书?");
            this.options.open();
        };
        ;
        return ResetVpnCert;
    }());
    MCertificate.ResetVpnCert = ResetVpnCert;
})(MCertificate || (MCertificate = {}));
angular.module('root')
    .factory('CertificateManager', ['$rootScope', 'Api', function ($rootScope, api) {
        return new MCertificate.CertificateManager($rootScope, api);
    }])
    .directive('wResetVpnCert', ['CertificateManager', '$q', '$sce', function (certMgr, $q, $sce) {
        return new MCertificate.ResetVpnCert(certMgr, $q, $sce);
    }])
    .directive('wUpdateCertName', ['CertificateManager', '$q', function (certMgr, $q) {
        return new MCertificate.UpdateCertName(certMgr, $q);
    }])
    .directive('wCreateCert', ['CertificateManager', '$q', '$cookies', function (certMgr, $q, $cookies) {
        return new MCertificate.CreateCert(certMgr, $q, $cookies);
    }])
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/vpn/vpnCertificate', {
            templateUrl: '/vpn/template/vpnCertificate/list.html',
            controller: MCertificate.Controller,
            resolve: {
                certificateParams: ['$rootScope', '$q', '$location', 'CertificateManager',
                    function ($rootScope, $q, $location, certMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                        }
                        certMgr.query(qobj, function (datas, total) {
                            defer.resolve({ certs: datas, total: total });
                        });
                        return defer.promise;
                        // return {total:0, certs:[]}
                    }]
            }
        });
    }]);
// 借助$ocLazyLoad动态加载js、css，用法如下：
// resolve: {
//     deps: ['$ocLazyLoad', function($ocLazyLoad) {
//         return $ocLazyLoad.load({
//             name: 'App',
//             insertBefore: '#ng_load_plugins_before',
//             files: [
//                 'xx/js/controllers/xx.js'
//             ]
//         });
//     }],
//     showImgFiles: ['$ocLazyLoad', function($ocLazyLoad) {
//         return $ocLazyLoad.load([{
//             name: 'App',
//             insertBefore: '#ng_load_plugins_before',
//             files: [
//                 'xx/xx/xx.css',
//                 'xx/xx/xx.js'
//             ]
//         }]).then(function(){
//             //做些事情
//         });
//     }]
// }
///<reference path="./d.ts/angularjs/angular.d.ts"/>
///<reference path="./d.ts/echarts.d.ts"/>
var MCWVpn;
(function (MCWVpn) {
    var Action = /** @class */ (function () {
        function Action($scope, vMgr, l2VpnMgr) {
            this.$scope = $scope;
            this.vMgr = vMgr;
            this.l2VpnMgr = l2VpnMgr;
        }
        Action.prototype.resetVpnCertKey = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.resetCwVpnCertKey.open(vpn);
        };
        Action.prototype.updateVpnName = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.updateCwVpnName.open(vpn);
        };
        Action.prototype.settingIp = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.settingIp.open(vpn);
        };
        Action.prototype.updateMode = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.updateMode.open(vpn);
        };
        Action.prototype.updateVpnBandwidth = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.updateCwVpnBandwidth.open(vpn);
        };
        Action.prototype.detachVpnCert = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.detachCwVpnCert.open(vpn);
        };
        Action.prototype.attachVpnCert = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.attachCwVpnCert.open(vpn);
        };
        Action.prototype.configDownload = function () {
            var _this = this;
            var vpn = this.$scope.selectedVpn[0];
            this.l2VpnMgr.getCertDownloadUrl(vpn.uuid, 'conf', function (ret) {
                if (Utils.notNullnotUndefined(ret.downloadUrl)) {
                    vpn.configtDownloadUrl = ret.downloadUrl;
                    _this.l2VpnMgr.getCertDownloadUrl(vpn.vpnCertUuid, 'cert', function (ret) {
                        if (Utils.notNullnotUndefined(ret.downloadUrl)) {
                            vpn.certDownloadUrl = ret.downloadUrl;
                        }
                        _this.$scope.configDownloadCwVpn.open(vpn);
                    });
                }
            });
        };
        Action.prototype.renewVpn = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.renewCw.open(vpn);
        };
        Action.prototype.openVpn = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.openCwVpn.open(vpn);
        };
        Action.prototype.closeVpn = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.closeCwVpn.open(vpn);
        };
        Action.prototype.deleteVpn = function () {
            var _this = this;
            var vpn = this.$scope.selectedVpn[0];
            this.l2VpnMgr.getUnscribeVpnPrice(vpn.uuid, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    vpn.backMoneys = ret.cash.toFixed(2);
                }
                _this.$scope.deleteCwVpn.open(vpn);
            });
        };
        Action.prototype.flowMonitor = function () {
            var vpn = this.$scope.selectedVpn[0];
            this.$scope.flowMonitor.open(vpn);
        };
        Action.prototype.isActionShow = function (action) {
            if (Utils.notNullnotUndefinedNotEmptyString(this.$scope.selectedVpn)) {
                switch (action) {
                    case 'hasCertificate':
                        return Utils.notNullnotUndefinedNotEmptyString(this.$scope.selectedVpn[0].vpnCertName) && this.$scope.selectedVpn[0].resourceUuid != undefined;
                    case 'attachVpnCert':
                        return !Utils.notNullnotUndefinedNotEmptyString(this.$scope.selectedVpn[0].vpnCertName) && this.$scope.selectedVpn[0].resourceUuid != undefined;
                    case 'open':
                        return this.$scope.selectedVpn[0].state == 'Disabled' && this.$scope.selectedVpn[0].vpnCertName != '' && this.$scope.selectedVpn[0].resourceUuid != undefined;
                    case 'close':
                        return this.$scope.selectedVpn[0].state == 'Enabled';
                    case 'updateVpnBandwidth':
                        return this.$scope.selectedVpn[0].vpnCertName != '' && this.$scope.selectedVpn[0].state == 'Enabled' && this.$scope.selectedVpn[0].resourceUuid != undefined;
                    case 'settingIp':
                    case 'updateMode':
                        return this.$scope.selectedVpn[0].resourceType == 'network' && this.$scope.selectedVpn[0].state == 'Disabled' && this.$scope.selectedVpn[0].vpnCertName != '' && this.$scope.selectedVpn[0].resourceUuid != undefined;
                }
            }
        };
        return Action;
    }());
    var VpnManagerL2 = /** @class */ (function () {
        function VpnManagerL2($rootScope, api, acMgr) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.acMgr = acMgr;
            this.$inject = ['$rootScope', 'Api', 'WAccountManage'];
        }
        //获取专线列表
        VpnManagerL2.prototype.getTunnelLists = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryTunnelMsg();
            msg.limit = qobj.limit;
            msg.start = qobj.start;
            msg.count = qobj.count;
            msg.replyWithCount = qobj.replyWithCount;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            msg.fields = qobj.fields;
            msg.noError = qobj.noError ? qobj.noError : false;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //获取连接点名称
        VpnManagerL2.prototype.getEndpointLists = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryEndpointMsg();
            msg.conditions = qobj.conditions;
            msg.limit = qobj.limit;
            msg.start = qobj.start;
            msg.count = qobj.count;
            msg.replyWithCount = qobj.replyWithCount;
            msg.fields = qobj.fields;
            msg.noError = qobj.noError ? qobj.noError : false;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //获取可用节点
        VpnManagerL2.prototype.getVpnHostLists = function (tunnelUuid, callback) {
            var msg = new ApiHeader.APIListSupportedEndpointMsg();
            msg.tunnelUuid = tunnelUuid;
            msg.fields = ['uuid', 'name'];
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //创建vpn L2
        VpnManagerL2.prototype.creatVpnL2 = function (qobj, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateVpnMsg();
            msg.name = qobj.name;
            msg.description = qobj.description;
            msg.bandwidthOfferingUuid = qobj.bandwidthOfferingUuid;
            msg.endpointUuid = qobj.endpointUuid;
            msg.duration = qobj.duration;
            msg.productChargeModel = qobj.productChargeModel;
            msg.resourceUuid = qobj.tunnelUuid;
            msg.vlan = qobj.vlan;
            msg.vpnCertUuid = qobj.vpnCertUuid;
            msg.resourceType = 'tunnel';
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        //查询vpn价格
        VpnManagerL2.prototype.queryPrice = function (qobj, callback) {
            var msg = new ApiHeader.APIGetVpnPriceMsg();
            msg.bandwidthOfferingUuid = qobj.bandwidthOfferingUuid;
            msg.duration = qobj.duration;
            msg.productChargeModel = qobj.productChargeModel;
            msg.endpointUuid = qobj.endpointUuid;
            this.api.restCall(msg, function (ret) {
                callback(ret);
            });
        };
        //查询信用额度，余额信息
        VpnManagerL2.prototype.getBalance = function (callback) {
            var msg = new ApiHeader.APIGetAccountBalanceMsg();
            this.api.restCall(msg, function (ret) {
                callback(ret.inventory);
            });
        };
        //获取证书列表
        VpnManagerL2.prototype.getCertficateLists = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryVpnCertMsg();
            msg.count = qobj.count;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.replyWithCount = qobj.replyWithCount;
            msg.sortBy = 'createDate';
            msg.sortDirection = 'desc';
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            msg.fields = qobj.fields;
            this.api.restCall(msg, function (ret) {
                callback(ret);
            });
        };
        //获取带宽列表
        VpnManagerL2.prototype.getBandwidthList = function (qobj_Bandwidth, callback) {
            var msg = new ApiHeader.APIQueryBandwidthOfferingMsg();
            msg.limit = qobj_Bandwidth.limit;
            msg.start = qobj_Bandwidth.start;
            msg.count = qobj_Bandwidth.count;
            msg.replyWithCount = qobj_Bandwidth.replyWithCount;
            msg.sortBy = 'bandwidth';
            // msg.sortDirection="desc";
            msg.conditions = qobj_Bandwidth.conditions ? qobj_Bandwidth.conditions : [];
            msg.fields = qobj_Bandwidth.fields;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //查询续费价格
        VpnManagerL2.prototype.getRenewVpnPrice = function (qobj, callback) {
            var msg = new ApiHeader.APIGetRenewVpnPriceMsg();
            msg.uuid = qobj.uuid;
            msg.duration = qobj.duration;
            msg.productChargeModel = qobj.productChargeModel;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //查询VPN修改次数
        VpnManagerL2.prototype.getVpnModify = function (uuid, callback) {
            var msg = new ApiHeader.APIGetVpnModifyMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //查询修改带宽价格
        VpnManagerL2.prototype.getModifyVpnPriceDiff = function (qobj, callback) {
            var msg = new ApiHeader.APIGetModifyVpnPriceDiffMsg();
            msg.uuid = qobj.uuid;
            msg.bandwidthOfferingUuid = qobj.bandwidthOfferingUuid;
            this.api.restCall(msg, function (ret) {
                // if(ret.success){
                callback(ret);
                // }
            });
        };
        //删除vpn网关 查询返回金额
        VpnManagerL2.prototype.getUnscribeVpnPrice = function (uuid, callback) {
            var msg = new ApiHeader.APIGetUnscribeVpnPriceDiffMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //删除vpn网关
        VpnManagerL2.prototype.deleteVpn = function (uuid, callback) {
            var msg = new ApiHeader.APIDeleteVpnMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //修改VPN名称
        VpnManagerL2.prototype.updateName = function (qobj, done) {
            var msg = new ApiHeader.APIUpdateVpnMsg();
            msg.uuid = qobj.uuid;
            msg.name = qobj.name;
            msg.description = qobj.description;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                }
            });
        };
        //修改VPN带宽
        VpnManagerL2.prototype.updateBandwidth = function (qobj, callback) {
            var msg = new ApiHeader.APIUpdateVpnBandwidthMsg();
            msg.uuid = qobj.uuid;
            msg.bandwidth = qobj.newBandwidth;
            msg.bandwidthOfferingUuid = qobj.bandwidthOfferingUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //解绑证书
        VpnManagerL2.prototype.detachVpnCert = function (uuid, done) {
            var msg = new ApiHeader.APIDetachVpnCertMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret);
                }
            });
        };
        //绑定证书
        VpnManagerL2.prototype.attachVpnCert = function (qobj, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIAttachVpnCertMsg();
            msg.uuid = qobj.uuid;
            msg.vpnCertUuid = qobj.vpnCertUuid;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        //获取下载证书地址 + 获取下载配置地址
        VpnManagerL2.prototype.getCertDownloadUrl = function (uuid, type, callback) {
            var msg = new ApiHeader.APIGenerateDownloadUrlMsg();
            msg.uuid = uuid;
            msg.type = type;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //续费
        VpnManagerL2.prototype.renewVpn = function (qobj, callback) {
            var msg = new ApiHeader.APIRenewVpnMsg();
            msg.uuid = qobj.uuid;
            msg.duration = qobj.duration;
            msg.productChargeModel = qobj.productChargeModel;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //修改VPN状态
        VpnManagerL2.prototype.updateVpnState = function (qobj, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateVpnStateMsg();
            msg.uuid = qobj.uuid;
            msg.state = qobj.state;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        //重置秘钥key
        VpnManagerL2.prototype.resetVpnCertKey = function (uuid, done) {
            var msg = new ApiHeader.APIResetVpnSecretKeyMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    done(ret.inventory);
                }
            });
        };
        return VpnManagerL2;
    }());
    MCWVpn.VpnManagerL2 = VpnManagerL2;
    var VpnManagerL3 = /** @class */ (function () {
        function VpnManagerL3($rootScope, api, acMgr, l2VpnMgr, $http) {
            this.$rootScope = $rootScope;
            this.api = api;
            this.acMgr = acMgr;
            this.l2VpnMgr = l2VpnMgr;
            this.$http = $http;
            this.$inject = ['$rootScope', 'Api', 'WAccountManage', 'VpnManagerL2', '$http'];
        }
        //查询vpn网关
        VpnManagerL3.prototype.query = function (qobj, callback) {
            var _this = this;
            var msg = new ApiHeader.APIQueryVpnMsg();
            msg.count = qobj.count;
            msg.start = qobj.start;
            msg.limit = qobj.limit;
            msg.replyWithCount = qobj.replyWithCount;
            msg.sortBy = 'createDate';
            msg.sortDirection = 'desc';
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var endpointUuids_1 = [], endpointUuidsStr = '';
                    angular.forEach(ret.inventories, function (item, key) {
                        if (endpointUuids_1.indexOf(item.endpointUuid) == -1) {
                            endpointUuids_1.push(item.endpointUuid);
                        }
                        // if(item.resourceType=='network'){
                        // 		ipUuids.push(item.uuid);
                        // 		if(networkUuids_network.indexOf(item.resourceUuid) == -1) {
                        // 				networkUuids_network.push(item.resourceUuid);
                        // 		}
                        // }else if (item.resourceType=='tunnel' && networkUuids_tunnel.indexOf(item.resourceUuid) == -1){
                        // 		networkUuids_tunnel.push(item.resourceUuid);
                        // }
                        //获取时间判断是否过期
                        if (Utils.notNullnotUndefined(item.expireDate)) {
                            var currentDateTimeStamp = new Date().getTime();
                            var exexpireDate = new Date(item.expireDate).getTime();
                            var difference = exexpireDate - currentDateTimeStamp;
                            if (difference < 0) {
                                ret.inventories[key].expireDateComment = '已过期';
                            }
                            else {
                                var dayDuration = difference / (1000 * 60 * 60 * 24);
                                if (dayDuration <= 7) {
                                    ret.inventories[key].expireDateComment = '即将过期';
                                }
                            }
                        }
                    });
                    endpointUuidsStr = endpointUuids_1.join(',');
                    //查询连接点名称
                    var qobj_endpointName = new ApiHeader.QueryObject();
                    qobj_endpointName.addCondition({ name: 'uuid', op: 'in', value: endpointUuidsStr });
                    // qobj_endpointName.fields = ['uuid', 'name'];
                    qobj_endpointName.noError = true;
                    _this.getEndpointLists(qobj_endpointName, function (datas) {
                        if (datas.success) {
                            for (var i = 0; i < ret.inventories.length; i++) {
                                for (var j = 0; j < datas.inventories.length; j++) {
                                    if (ret.inventories[i].endpointUuid == datas.inventories[j].uuid) {
                                        ret.inventories[i].endpointName = datas.inventories[j].name;
                                        // ret.inventories[i].remoteIp = datas.inventories[j].remoteIp;
                                        // ret.inventories[i].localIP = datas.inventories[j].localIP;
                                        // ret.inventories[i].monitorIp = datas.inventories[j].monitorIp;
                                        break;
                                    }
                                }
                                if (j == datas.inventories.length) {
                                    ret.inventories[i].endpointName = '';
                                }
                            }
                        }
                    });
                    callback(ret.inventories, ret.total);
                }
            });
        };
        //获取云网络列表
        VpnManagerL3.prototype.getNetworkLists = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3NetworkMsg();
            msg.limit = qobj.limit;
            msg.start = qobj.start;
            msg.count = qobj.count;
            msg.replyWithCount = qobj.replyWithCount;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            msg.fields = qobj.fields;
            msg.noError = qobj.noError ? qobj.noError : false;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //获取连接点名称
        VpnManagerL3.prototype.getEndpointLists = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryEndpointMsg();
            msg.conditions = qobj.conditions;
            msg.limit = qobj.limit;
            msg.start = qobj.start;
            msg.count = qobj.count;
            msg.replyWithCount = qobj.replyWithCount;
            msg.fields = qobj.fields;
            msg.noError = qobj.noError ? qobj.noError : false;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //获取可用连接点
        VpnManagerL3.prototype.getVpnHostLists = function (l3NetworkUuid, callback) {
            var msg = new ApiHeader.APIListSupportedL3EndpointMsg();
            msg.l3NetworkUuid = l3NetworkUuid;
            // msg.fields = ['uuid', 'name'];
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //查询ip地址
        VpnManagerL3.prototype.getIps = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3VpnMsg();
            msg.limit = qobj.limit;
            msg.start = qobj.start;
            msg.count = qobj.count;
            msg.replyWithCount = qobj.replyWithCount;
            msg.conditions = qobj.conditions ? qobj.conditions : [];
            msg.fields = qobj.fields;
            msg.noError = qobj.noError ? qobj.noError : false;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //获取云网络节点列表
        VpnManagerL3.prototype.getL3EndpointLists = function (qobj, callback) {
            var msg = new ApiHeader.APIQueryL3EndpointMsg();
            msg.conditions = qobj.conditions;
            msg.limit = qobj.limit;
            msg.start = qobj.start;
            msg.count = qobj.count;
            msg.replyWithCount = qobj.replyWithCount;
            msg.fields = qobj.fields;
            msg.noError = qobj.noError ? qobj.noError : false;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //创建vpn L3
        VpnManagerL3.prototype.creatVpnL3 = function (qobj, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APICreateL3VpnMsg();
            msg.name = qobj.name;
            msg.description = qobj.description;
            msg.bandwidthOfferingUuid = qobj.bandwidthOfferingUuid;
            msg.l3EndpointUuid = qobj.l3EndpointUuid; //
            msg.endpointUuid = qobj.endpointUuid;
            msg.duration = qobj.duration;
            msg.productChargeModel = qobj.productChargeModel;
            msg.resourceUuid = qobj.l3NetworkUuid; //
            msg.vlan = qobj.vlan;
            msg.vpnCertUuid = qobj.vpnCertUuid;
            msg.workMode = qobj.workMode; //
            msg.startIp = qobj.startIp; //
            msg.endIp = qobj.endIp; //
            msg.netmask = qobj.netmask; //
            msg.gateway = qobj.gateway; //
            msg.remoteIp = qobj.remoteIp; //
            msg.monitorIp = qobj.monitorIp; //
            msg.resourceType = 'network'; //
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        //获取 当前客户端模式
        VpnManagerL3.prototype.getL3VpnWorkModeLists = function (uuid, callback) {
            var msg = new ApiHeader.APIGetL3VpnWorkModeMsg();
            msg.uuid = uuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    callback(ret);
                }
            });
        };
        //设置路由ip
        VpnManagerL3.prototype.updateL3VpnRouteIP = function (qobj, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateL3VpnIPMsg();
            msg.uuid = qobj.uuid;
            msg.startIp = qobj.startIp;
            msg.endIp = qobj.endIp;
            msg.netmask = qobj.netmask;
            msg.gateway = qobj.gateway;
            msg.remoteIp = qobj.remoteIp;
            msg.monitorIp = qobj.monitorIp;
            this.api.restCall(msg, function (ret) {
                if (ret.success && ret.inventory) {
                    done(ret.inventory);
                }
            });
        };
        //调整模式
        VpnManagerL3.prototype.updateL3VpnWorkMode = function (workMode, uuid, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateL3VpnWorkModeMsg();
            msg.uuid = uuid;
            msg.workMode = workMode;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        //修改VPN状态
        VpnManagerL3.prototype.updateVpnState = function (qobj, done, error) {
            if (error === void 0) { error = null; }
            var msg = new ApiHeader.APIUpdateL3VpnStateMsg();
            msg.uuid = qobj.uuid;
            msg.state = qobj.state;
            this.api.restCall(msg, function (ret) {
                if (Utils.notNullnotUndefined(ret)) {
                    done(ret);
                }
            }, function (ret) {
                if (Utils.notNullnotUndefined(error)) {
                    error(ret);
                }
            });
        };
        //查询监控条件
        VpnManagerL3.prototype.queryMonitorCondition = function (vpnUuid, callback) {
            var msg = new ApiHeader.APIQueryOpentsdbConditionMsg();
            msg.vpnUuid = vpnUuid;
            this.api.restCall(msg, function (ret) {
                if (ret.success) {
                    var conditions = [{
                            tags: {
                                endpoint: ret.endpoint,
                                iface: ret.iface,
                                vpnUuid: ret.vpnUuid
                            }
                        }];
                    callback(conditions);
                }
            });
        };
        //查看监控
        VpnManagerL3.prototype.flowMonitor = function (infoPage, conditions, callback) {
            var timeInterval = (parseInt(infoPage.end) - parseInt(infoPage.start)) / (1000 * 60);
            var params = [];
            if (infoPage.metrics.length == 4) {
                if (timeInterval <= 60) {
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.in.bytes',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.out.bytes',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.in.packets',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.out.packets',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                }
                else if (timeInterval <= 60 * 24) {
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.in.bytes.NEW.5m',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.out.bytes.NEW.5m',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.in.packets.NEW.5m',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.out.packets.NEW.5m',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                }
                else if (timeInterval <= 60 * 24 * 7) {
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.in.bytes.NEW.30m',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.out.bytes.NEW.30m',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.in.packets.NEW.30m',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.out.packets.NEW.30m',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                }
                else {
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.in.bytes.NEW.1h',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.out.bytes.NEW.1h',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.in.packets.NEW.1h',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                    params.push({
                        'aggregator': 'avg',
                        'rate': 'true',
                        'metric': 'net.if.out.packets.NEW.1h',
                        'tags': {
                            'endpoint': conditions.endpoint,
                            'iface': conditions.iface
                        },
                        'rateOptions': { 'counter': true, 'resetValue': 1 }
                    });
                }
            }
            this.$http({
                method: 'post',
                url: '/api/query',
                data: {
                    'start': infoPage.start,
                    'end': infoPage.end,
                    'queries': params
                }
            }).success(function (req) {
                callback(req);
            });
        };
        return VpnManagerL3;
    }());
    MCWVpn.VpnManagerL3 = VpnManagerL3;
    var Controller = /** @class */ (function () {
        function Controller($scope, $location, CwVpnParams, vMgr, l2VpnMgr) {
            this.$scope = $scope;
            this.$location = $location;
            this.CwVpnParams = CwVpnParams;
            this.vMgr = vMgr;
            this.l2VpnMgr = l2VpnMgr;
            $scope.action = new Action($scope, vMgr, l2VpnMgr);
            $scope.selectedVpn = [];
            var locationSearch = $location.search();
            $scope.searchOptions = {
                list: [{
                        name: 'uuid',
                        text: 'UUID'
                    }, {
                        name: 'number',
                        text: '序号'
                    }, {
                        name: 'name',
                        text: '名称'
                    }, {
                        name: 'status',
                        text: '状态',
                        valueList: [{
                                text: '全部',
                                value: ''
                            }, {
                                text: '正常',
                                value: 'Connected'
                            }, {
                                text: '异常',
                                value: 'Disconnected'
                            }, {
                                text: '连接中',
                                value: 'Connecting'
                            }
                        ]
                    }, {
                        name: 'state',
                        text: '状况',
                        valueList: [
                            {
                                text: '全部',
                                value: ''
                            }, {
                                text: '启用',
                                value: 'Enabled'
                            }, {
                                text: '关闭',
                                value: 'Disabled'
                            }
                        ]
                    }, {
                        name: 'expireDate',
                        text: '过期状态',
                        valueList: [
                            {
                                text: '全部',
                                value: ''
                            }, {
                                text: '已过期',
                                value: 'expired'
                            }, {
                                text: '即将过期',
                                value: 'expireing'
                            }, {
                                text: '未过期',
                                value: 'unexpired'
                            }
                        ]
                    }],
                search: function (conds) {
                    if ($scope.vpnGrid.pagination.currentPage == 1) {
                        var qobj = new ApiHeader.QueryObject();
                        qobj.conditions = conds;
                        qobj.start = 0;
                        qobj.limit = $scope.vpnGrid.pagination.pageSize;
                        // vMgr.query(qobj, (ret, total) => {
                        // 		$scope.vpnGrid.data = ret;
                        // 		$scope.vpnGrid.pagination.totalSize = total;
                        // 		$scope.vpnGrid.show = total == 0;
                        // });
                    }
                    else {
                        $scope.vpnGrid.pagination.currentPage = 1;
                    }
                }
            };
            //列表展示
            $scope.vpnGrid = {
                data: CwVpnParams.vpns,
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    headerRowHeight: 40,
                    rowHeight: 40,
                    selectedItems: $scope.selectedVpn,
                    data: 'vpnGrid.data',
                    //列属性设置
                    columnDefs: [{
                            field: 'number',
                            width: '10%',
                            displayName: '序号',
                        },
                        {
                            field: 'name',
                            width: '16%',
                            displayName: '名称',
                        },
                        {
                            field: 'resourceType',
                            width: '8%',
                            displayName: '云网关类型',
                            cellTemplate: '<div class="ngCellText ng-scope" ng-class="col.colIndex()"><span class="ng-binding">{{row.getProperty(col.field)| wState}}</span></div>'
                        },
                        {
                            field: 'endpointName',
                            width: '12%',
                            displayName: '连接点',
                        },
                        {
                            field: 'status',
                            width: '5%',
                            displayName: '状态',
                            // cellTemplate: '<div class="ngCellText ng-scope col1 colt1" ng-class="col.colIndex()"><span class="ng-binding">{{row.getProperty(col.field) | wState}}</span></div>'//重写cell
                            // cellTemplate: '<div class="ngCellText ng-scope col1 colt1" ng-class="col.colIndex()"><span class="ng-binding">{{row.getProperty(col.field) | wState}}</span></div>'//重写cell
                            cellTemplate: '<div class="ng-cell-box ngCellText" ng-class="col.colIndex()">' +
                                '<span ng-if="row.getProperty(col.field)== \'Connecting\' " class="label label-default">{{row.getProperty(col.field) | wState}}</span>' +
                                '<span ng-if="row.getProperty(col.field)==\'Connected\'" class="label label-success">{{row.getProperty(col.field) | wState}}</span>' +
                                '<span ng-if="row.getProperty(col.field)==\'Disconnected\'" class="label label-danger">{{row.getProperty(col.field) | wState}}</span></div>'
                        },
                        {
                            field: 'state',
                            width: '5%',
                            displayName: '状况',
                            cellTemplate: '<div class="ng-cell-box ngCellText" ng-class="col.colIndex()">' +
                                '<span ng-if="row.getProperty(col.field)== \'Enabled\' " class="label label-success">{{row.getProperty(col.field) | wState}}</span>' +
                                '<span ng-if="row.getProperty(col.field)==\'Disabled\'" class="label label-danger">{{row.getProperty(col.field) | wState}}</span></div>'
                        },
                        {
                            field: 'vpnCertName',
                            width: '10%',
                            displayName: '绑定证书',
                            cellTemplate: '<div class="ngCellText ng-scope" ng-class="col.colIndex()"><span ng-cell-text="" class="ng-binding">{{row.getProperty(col.field)}}</span></div>'
                        },
                        {
                            field: 'createDate',
                            width: '10%',
                            displayName: '创建时间',
                            // cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)| wDate}}</div>'//重写cell
                            cellTemplate: '<div class="ngCellText ng-scope" ng-class="col.colIndex()"><span class="ng-binding">{{row.getProperty(col.field)| wDate}}</span></div>'
                        },
                        {
                            field: 'expireDate',
                            width: '10%',
                            displayName: '到期时间',
                            // cellTemplate: '<div class="ng-cell-box">{{row.getProperty(col.field)|wDate}}</div>'
                            cellTemplate: '<div class="ngCellText ng-scope" ng-class="col.colIndex()"><span class="ng-binding">{{row.getProperty(col.field) ? (row.getProperty(col.field) | wDate) : ""}}</span><br/>' +
                                '<span ng-if="row.getProperty(\'expireDateComment\')==\'已过期\'" class=" label label-danger">{{row.getProperty(\'expireDateComment\')}}</span>' +
                                '<span ng-if="row.getProperty(\'expireDateComment\')==\'即将过期\'" class=" label label-warning">{{row.getProperty(\'expireDateComment\')}}</span></div>'
                        },
                        {
                            field: 'isOpenMonitor',
                            width: '4%',
                            displayName: '监控',
                            cellTemplate: '<div ng-click="openQueryMonitor($event,row.getProperty(\'uuid\'))" class="ng-cell-box">' +
                                '<span><i class="iconfont icon-chart color-green"></i></span></div>'
                        },
                        {
                            width: '10%',
                            displayName: '操作',
                            cellTemplate: '<div class="ngCellText operate-dropdown" uib-dropdown is-open="nodeGridDropOpen" ng-click="changeClickOperate($event,row.getProperty(\'uuid\'))">' +
                                '<span uib-dropdown-toggle>更多<i class="caret"></i></span>' +
                                '<ul ng-click="nodeGridDropOpen=false" class="dropdown-menu" style="width: 118px;left: auto;right:20px;"  uib-dropdown-menu>' +
                                '<li ng-click="action.updateVpnName()">修改名称</li>' +
                                '<li ng-show="action.isActionShow(' + "\'settingIp\'" + ')" ng-click="action.settingIp()">设置IP地址</li>' +
                                '<li ng-show="action.isActionShow(' + "\'updateMode\'" + ')" ng-click="action.updateMode()">调整模式</li>' +
                                '<li ng-show="action.isActionShow(' + "\'updateVpnBandwidth\'" + ')" ng-click="action.updateVpnBandwidth()">调整带宽</li>' +
                                '<li ng-show="action.isActionShow(' + "\'hasCertificate\'" + ')" ng-click="action.detachVpnCert()">解绑证书</li>' +
                                '<li ng-show="action.isActionShow(' + "\'hasCertificate\'" + ')" ng-click="action.configDownload()">配置下载</li>' +
                                '<li ng-show="action.isActionShow(' + "\'attachVpnCert\'" + ')" ng-click="action.attachVpnCert()">绑定证书</li>' +
                                '<li ng-click="action.renewVpn()">续费</li>' +
                                '<li ng-show="action.isActionShow(' + "\'open\'" + ')" ng-click="action.openVpn()">开启</li>' +
                                '<li ng-show="action.isActionShow(' + "\'close\'" + ')" ng-click="action.closeVpn()">关闭</li>' +
                                '<li ng-click="action.deleteVpn()">删除</li>' +
                                '</ul></div>'
                        }],
                    plugins: [new Utils.flexRowHeight(), new Utils.ngGridFlexibleHeightPlugin()]
                },
                pagination: {
                    pageSizeArr: [10, 20, 50],
                    pageSize: locationSearch.size ? locationSearch.size : $scope.pageSize,
                    currentPage: locationSearch.page ? locationSearch.page : 1,
                    showPageOnUrl: true,
                    totalSize: CwVpnParams.total
                },
                show: CwVpnParams.total == 0,
            };
            $scope.changeClickOperate = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.vpnGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.vpnGrid.options.selectRow(index, true);
                        return false;
                    }
                });
            };
            $scope.openQueryMonitor = function (e, uuid) {
                e.stopPropagation();
                angular.forEach($scope.vpnGrid.data, function (item, index) {
                    if (item.uuid == uuid) {
                        $scope.vpnGrid.options.selectRow(index, true);
                        return false;
                    }
                });
                $scope.action.flowMonitor();
            };
            //展开右侧详情
            $scope.optionsCwVpnDetail = {
                width: '360px',
                type: 'right'
            };
            $scope.clickGridCell = function (e) {
                var vpn = $scope.selectedVpn[0];
                $scope.CwVpnDetail.open(vpn);
            };
            //重置秘钥key
            $scope.optionsResetCwVpnCertKey = {
                width: '500px',
                type: 'center',
                title: '重置密钥',
                description: function () {
                    var modal = $scope.selectedVpn[0];
                    return Utils.sprintf('重置操作不可恢复,您确定<span class=\"error\">重置云网关 "{0}" </span>密钥？', modal.name);
                },
                confirm: function () {
                    var model = $scope.selectedVpn[0];
                    l2VpnMgr.resetVpnCertKey(model.uuid, function (ret) {
                        if (Utils.notNullnotUndefined(ret)) {
                            $scope.$emit(MRoot.Events.NOTIFICATION, {
                                type: 'success',
                                msg: Utils.sprintf('云网关{0} 重置密钥成功!', ret.name)
                            });
                            Utils.arrayUpdateItem($scope.vpnGrid.data, ret);
                        }
                    });
                }
            };
            //新建
            $scope.openCreateCWVpn = function () {
                $scope.createCwVpn.open();
            };
            $scope.optionsCreateCwVpn = {
                width: '1000px',
                type: 'center',
                done: function (vpn) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('创建云网关{0}成功!', vpn.name)
                    });
                    $scope.vpnGrid.data.unshift(vpn.inventory);
                }
            };
            //修改名称
            $scope.optionsUpdateCwVpnName = {
                width: '500px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('修改云网关{0}名称成功!', cert.name)
                    });
                    Utils.arrayUpdateItem($scope.vpnGrid.data, cert);
                    // $scope.vpnGrid.data.unshift(vpn);
                }
            };
            //修改带宽
            $scope.optionsUpdateCwVpnBandwidth = {
                width: '800px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('修改云网关{0}带宽成功!', cert.name)
                    });
                    Utils.arrayUpdateItem($scope.vpnGrid.data, cert);
                }
            };
            //解绑证书
            $scope.optionsDetachCwVpnCert = {
                width: '500px',
                type: 'center',
                title: '解绑证书',
                tips: function () {
                    return '解绑证书后将关闭云网关，影响相关业务<br/>未绑定新的证书前，无法正常开启';
                },
                description: function () {
                    var modal = $scope.selectedVpn[0];
                    return Utils.sprintf('您确定解绑证书 "<span class="error">{0}</span>"', modal.vpnCertName);
                },
                confirm: function () {
                    var model = $scope.selectedVpn[0];
                    l2VpnMgr.detachVpnCert(model.uuid, function (data) {
                        if (data.success) {
                            $scope.$emit(MRoot.Events.NOTIFICATION, {
                                type: 'success',
                                msg: Utils.sprintf('解绑证书 {0} 成功!', model.vpnCertName)
                            });
                            if (data.inventory.vpnCertUuid == undefined) {
                            }
                            Utils.arrayUpdateItem($scope.vpnGrid.data, data.inventory);
                        }
                    });
                }
            };
            //绑定证书
            $scope.optionsAttachCwVpnCert = {
                width: '450px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('绑定证书 {0} 成功!', cert.inventory.vpnCertName)
                    });
                    Utils.arrayUpdateItem($scope.vpnGrid.data, cert.inventory);
                }
            };
            //配置下载
            $scope.optionsDownloadCwVpn = {
                width: '500px',
                height: 500,
                type: 'center',
                title: '配置下载',
                description: function () {
                    var modal = $scope.selectedVpn[0];
                    return Utils.sprintf('<div class="oneBtnContent margin-btm30"><span style="width: 90px">配置下载路径：</span><span style="padding-left: 90px;"><a href="{0}" target="_blank">{0}</a></span></div>' +
                        '<div class="oneBtnContent"><span style="width: 90px">证书下载路径：</span><span style="padding-left: 90px;"><a href="{1}" target="_blank">{1}</a></span></div>', modal.configtDownloadUrl, modal.certDownloadUrl);
                }
            };
            //续费
            $scope.optionsRenewCw = {
                width: '500px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('续费{0}成功!', cert.name)
                    });
                    Utils.arrayUpdateItem($scope.vpnGrid.data, cert);
                }
            };
            //开启vpn
            $scope.optionsOpenCwVpn = {
                width: '500px',
                type: 'center',
                title: '开启',
                description: function () {
                    var modal = $scope.selectedVpn[0];
                    return Utils.sprintf('您确定 <span class="error">开启"{0}"</span> 云网关？', modal.name);
                },
                confirm: function () {
                    var model = angular.copy($scope.selectedVpn[0]);
                    model.state = 'Enabled';
                    if (model.resourceType == 'network') {
                        vMgr.updateVpnState(model, function (data) {
                            if (data.success) {
                                $scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: 'success',
                                    msg: Utils.sprintf('开启云网关接口{0}成功!', model.name)
                                });
                                Utils.arrayUpdateItem($scope.vpnGrid.data, data.inventory);
                            }
                        });
                    }
                    else {
                        l2VpnMgr.updateVpnState(model, function (data) {
                            if (data.success) {
                                $scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: 'success',
                                    msg: Utils.sprintf('开启云网关接口{0}成功!', model.name)
                                });
                                Utils.arrayUpdateItem($scope.vpnGrid.data, data.inventory);
                            }
                        });
                    }
                }
            };
            //关闭vpn
            $scope.optionsCloseCwVpn = {
                width: '500px',
                type: 'center',
                title: '关闭',
                tips: function () {
                    return '关闭云网关后将无法正常运行，相关业务可能会有影响，请谨慎操作。<br/>关闭云网关后，将按原价继续计费。';
                },
                description: function () {
                    var modal = $scope.selectedVpn[0];
                    return Utils.sprintf('您确定关闭云网关 <span class="error">"{0}"</span>？', modal.name);
                },
                confirm: function () {
                    var model = angular.copy($scope.selectedVpn[0]);
                    model.state = 'Disabled';
                    if (model.resourceType == 'network') {
                        vMgr.updateVpnState(model, function (data) {
                            if (data.success) {
                                $scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: 'success',
                                    msg: Utils.sprintf('关闭云网关接口{0}成功!', model.name)
                                });
                                Utils.arrayUpdateItem($scope.vpnGrid.data, data.inventory);
                            }
                        });
                    }
                    else {
                        l2VpnMgr.updateVpnState(model, function (data) {
                            if (data.success) {
                                $scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: 'success',
                                    msg: Utils.sprintf('关闭云网关接口{0}成功!', model.name)
                                });
                                Utils.arrayUpdateItem($scope.vpnGrid.data, data.inventory);
                            }
                        });
                    }
                }
            };
            //删除vpn
            $scope.optionsDeleteCwVpn = {
                width: '600px',
                type: 'center',
                title: '删除云网关',
                // tips: ()=>{
                //     return "资源删除后数据不可恢复，将无法承载相关业务，请谨慎操作！<br/>资源删除后，剩余金额将自动返还到您的现金账户(赠送金额不予返还)，详细退费规则";
                // },
                showRefundRule: function () {
                    return '<div>资源删除后数据不可恢复，将无法承载相关业务，请谨慎操作！</div>' +
                        '<div>资源删除后，剩余金额将自动返还到您的现金账户(赠送金额不予返还)，详细请见<a ng-click=\'refundRule()\'>退费规则</a>！</div>';
                },
                description: function () {
                    var modal = $scope.selectedVpn[0];
                    return Utils.sprintf('请确定是否删除云网关：<span class="error">{0}</span><br>本次返还金额：&yen;{1}', modal.name, modal.backMoneys);
                },
                confirm: function () {
                    var model = $scope.selectedVpn[0];
                    l2VpnMgr.deleteVpn(model.uuid, function (data) {
                        if (data.success) {
                            $scope.$emit(MRoot.Events.NOTIFICATION, {
                                type: 'success',
                                msg: Utils.sprintf('删除云网关 {0} 成功!', model.name)
                            });
                            Utils.arrayDeleteItem($scope.vpnGrid.data, model);
                        }
                    });
                }
            };
            //退费规则
            $scope.refundRuleParent = function () {
                $scope.refundRule.open();
            };
            $scope.optionsRefundRule = {
                width: '550px',
                type: 'center'
            };
            //设置IP地址
            $scope.optionsSettingIp = {
                width: '500px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('{0}修改IP地址成功!', cert.name)
                    });
                    Utils.arrayUpdateItem($scope.vpnGrid.data, cert);
                }
            };
            //调整模式
            $scope.optionsUpdateMode = {
                width: '600px',
                type: 'center',
                done: function (cert) {
                    $scope.$emit(MRoot.Events.NOTIFICATION, {
                        type: 'success',
                        msg: Utils.sprintf('{0}调整模式成功!', cert.name)
                    });
                    Utils.arrayUpdateItem($scope.vpnGrid.data, cert);
                }
            };
            $scope.checkIp = function (remoteIp, localIP, monitorIp, startIp, endIp) {
                //排序 remoteIp localIP monitorIp
                var ipBox = [remoteIp, localIP, monitorIp];
                ipBox = ipBox.sort();
                startIp = Number(startIp);
                endIp = Number(endIp);
                if (startIp > endIp) {
                    return [0, '终止IP需大于等于起始IP'];
                }
                if (startIp < ipBox[0] && endIp > ipBox[0]) {
                    return [0, 'IP冲突'];
                }
                if (startIp < ipBox[1] && endIp > ipBox[1]) {
                    return [0, 'IP冲突'];
                }
                if (startIp < ipBox[1] && endIp > ipBox[1]) {
                    return [0, 'IP冲突'];
                }
                return [1];
            };
            //监控
            $scope.optionsFlowMonitor = {
                width: '800px',
                type: 'center',
                height: '500px',
                done: function (cert) {
                }
            };
        }
        Controller.$inject = ['$scope', '$location', 'CwVpnParams', 'VpnManagerL3', 'VpnManagerL2'];
        return Controller;
    }());
    MCWVpn.Controller = Controller;
    //支付
    var payController = /** @class */ (function () {
        function payController($scope, $location, params, vMgr, l2VpnMgr, $cookies) {
            this.$scope = $scope;
            this.$location = $location;
            this.params = params;
            this.vMgr = vMgr;
            this.l2VpnMgr = l2VpnMgr;
            this.$cookies = $cookies;
            $scope.optionsPayLoading = {
                width: '500px',
                type: 'center'
            };
            $scope.isDisabled = true;
            if (Utils.notNullnotUndefined(this.params)) {
                $scope.currentParam = JSON.parse(params);
                $scope.timeStr = null;
                if ($scope.currentParam.itemMsg.productChargeModel == 'BY_MONTH') {
                    $scope.timeStr = $scope.currentParam.itemMsg.duration + '个月';
                }
                else if ($scope.currentParam.itemMsg.productChargeModel == 'BY_YEAR') {
                    $scope.timeStr = $scope.currentParam.itemMsg.duration + '年';
                }
                else if ($scope.currentParam.itemMsg.productChargeModel == 'BY_WEEK') {
                    $scope.timeStr = $scope.currentParam.itemMsg.duration + '周';
                }
                else {
                    var wDates = MRoot.filterDate();
                    $scope.timeStr = wDates($scope.currentParam.itemMsg.expireDate);
                }
                l2VpnMgr.getBalance(function (ret) {
                    $scope.balanceMsg = ret;
                    if (ret.cashBalance > 0) {
                        $scope.remainCredit = ret.creditPoint;
                        $scope.remainBuyNumber = $scope.balanceMsg.cashBalance + $scope.balanceMsg.presentBalance + $scope.remainCredit;
                    }
                    else {
                        $scope.remainCredit = ret.creditPoint + ret.cashBalance;
                        $scope.remainBuyNumber = $scope.balanceMsg.presentBalance + $scope.remainCredit;
                    }
                    $scope.isDisabled = false;
                });
            }
            else {
                $location.path('/vpn/gateway');
            }
            $scope.confirm = function (e) {
                if ($scope.remainBuyNumber >= $scope.currentParam.discountPrice) {
                    $scope.isDisabled = true;
                    $scope.payLoading.open();
                    if ($scope.currentParam.type == '调整带宽') {
                        l2VpnMgr.updateBandwidth($scope.currentParam.itemMsg, function (data) {
                            $scope.$emit(MRoot.Events.NOTIFICATION, {
                                type: 'success',
                                msg: Utils.sprintf('修改{0}带宽成功!', data.inventory.name)
                            });
                            $scope.isDisabled = false;
                            $location.path($scope.currentParam.backUrl);
                        });
                    }
                    else if ($scope.currentParam.type == '购买') {
                        if ($scope.currentParam.networkPages) {
                            vMgr.creatVpnL3($scope.currentParam.itemMsg, function (data) {
                                $scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: 'success',
                                    msg: Utils.sprintf('创建{0}成功!', data.inventory.name)
                                });
                                $scope.isDisabled = false;
                                $location.path($scope.currentParam.backUrl);
                            }, function (ret) {
                                $scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: 'danger',
                                    msg: Utils.sprintf('新建云网关失败,{0}!', ret.details)
                                });
                                $scope.isDisabled = false;
                                $location.path($scope.currentParam.backUrl);
                            });
                        }
                        else {
                            l2VpnMgr.creatVpnL2($scope.currentParam.itemMsg, function (data) {
                                $scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: 'success',
                                    msg: Utils.sprintf('创建{0}成功!', data.inventory.name)
                                });
                                $scope.isDisabled = false;
                                $location.path($scope.currentParam.backUrl);
                            }, function (ret) {
                                $scope.$emit(MRoot.Events.NOTIFICATION, {
                                    type: 'danger',
                                    msg: Utils.sprintf('新建云网关失败,{0}!', ret.details)
                                });
                                $scope.isDisabled = false;
                                $location.path($scope.currentParam.backUrl);
                            });
                        }
                    }
                    else if ($scope.currentParam.type == '续费') {
                        l2VpnMgr.renewVpn($scope.currentParam.itemMsg, function (data) {
                            $scope.$emit(MRoot.Events.NOTIFICATION, {
                                type: 'success',
                                msg: Utils.sprintf('续费{0}成功!', data.inventory.name)
                            });
                            $scope.isDisabled = false;
                            $location.path($scope.currentParam.backUrl);
                        });
                    }
                }
            };
            $scope.cancel = function (e) {
                $location.path($scope.currentParam.backUrl);
            };
        }
        payController.$inject = ['$scope', '$location', 'params', 'VpnManagerL3', 'VpnManagerL2', '$cookies'];
        return payController;
    }());
    MCWVpn.payController = payController;
    //右侧详情
    var CwVpnDetail = /** @class */ (function () {
        function CwVpnDetail(vpnMgr, l2VpnMgr, $q) {
            var _this = this;
            this.vpnMgr = vpnMgr;
            this.l2VpnMgr = l2VpnMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.templateUrl = '/vpn/template/L3MPLSVpn/detail.html';
            this.link = function (scope, $element, $attrs) {
                _this.$scope = scope;
                var parentScope = scope.$parent;
                var options = parentScope[$attrs.wOptions];
                parentScope[$attrs.wCwVpnDetail] = _this;
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.current = null;
                //请求 云专线名称/云网络名称
                scope.getNetworkName = function (item) {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({ name: 'uuid', op: '=', value: item.resourceUuid });
                    qobj.fields = ['name'];
                    qobj.noError = true;
                    if (item.resourceType == 'network') {
                        scope.getDetails(item.uuid);
                        vpnMgr.getNetworkLists(qobj, function (ret) {
                            if (ret.success) {
                                scope.current.networkName = ret.inventories[0].name;
                            }
                        });
                    }
                    else {
                        l2VpnMgr.getTunnelLists(qobj, function (ret) {
                            if (ret.success) {
                                scope.current.networkName = ret.inventories[0].name;
                            }
                        });
                    }
                };
                //请求 l3EndpointUuid、workMode、startIp、endIp
                scope.getDetails = function (uuid) {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({ name: 'uuid', op: '=', value: uuid });
                    qobj.fields = ['l3EndpointUuid', 'workMode', 'startIp', 'endIp'];
                    qobj.noError = true;
                    vpnMgr.getIps(qobj, function (ret) {
                        if (ret.success) {
                            scope.current.l3EndpointUuid = ret.inventories[0].l3EndpointUuid;
                            scope.current.workMode = ret.inventories[0].workMode;
                            scope.current.startIp = ret.inventories[0].startIp;
                            scope.current.endIp = ret.inventories[0].endIp;
                            scope.getIp(scope.current.l3EndpointUuid);
                        }
                    });
                };
                //请求 remoteIp、localIP、monitorIp
                scope.getIp = function (l3EndpointUuid) {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({ name: 'uuid', op: '=', value: l3EndpointUuid });
                    qobj.fields = ['remoteIp', 'localIP', 'monitorIp'];
                    qobj.noError = true;
                    vpnMgr.getL3EndpointLists(qobj, function (ret) {
                        if (ret.success) {
                            scope.current.remoteIp = ret.inventories[0].remoteIp;
                            scope.current.localIP = ret.inventories[0].localIP;
                            scope.current.monitorIp = ret.inventories[0].monitorIp;
                        }
                    });
                };
            };
        }
        CwVpnDetail.prototype.open = function (item) {
            var _this = this;
            this.$scope.current = null;
            this.$scope.getNetworkName(item);
            var defer = this.$q.defer();
            defer.promise.then(function (item) {
                _this.$scope.current = angular.copy(item);
            }).then(function () {
                _this.options.open();
            });
            defer.resolve(item);
        };
        return CwVpnDetail;
    }());
    MCWVpn.CwVpnDetail = CwVpnDetail;
    //新建vpn
    var CreateController = /** @class */ (function () {
        function CreateController($scope, vpnMgr, l2VpnMgr, $rootScope, $location) {
            this.$scope = $scope;
            this.vpnMgr = vpnMgr;
            this.l2VpnMgr = l2VpnMgr;
            this.$rootScope = $rootScope;
            this.$location = $location;
            var parentScope = $scope.$parent;
            // 获取 LeftNav
            angular.forEach(angular.element('.left-nav .sub-nav a'), function (v, i) {
                if (v.text == '云网关') {
                    v.className += ' current';
                }
            });
            $scope.searchUserSelected = [];
            $scope.currentAccount = null;
            $scope.searchUserGrid = {
                data: null,
                show: true,
                options: {
                    enableSorting: false,
                    multiSelect: false,
                    enableColumnResize: true,
                    headerRowHeight: 40,
                    rowHeight: 40,
                    selectedItems: $scope.searchUserSelected,
                    data: 'searchUserGrid.data',
                    columnDefs: [
                        {
                            field: 'name',
                            width: '25%',
                            displayName: '账户名'
                        }, {
                            field: 'phone',
                            width: '25%',
                            displayName: '手机号'
                        }, {
                            field: 'email',
                            width: '25%',
                            displayName: '邮箱'
                        }, {
                            field: 'company',
                            width: '25%',
                            displayName: '公司名称'
                        }
                    ],
                    plugins: [
                        new Utils.flexRowHeight(),
                        new Utils.ngGridFlexibleHeightPlugin()
                    ]
                }
            };
            //账户选择弹窗
            $scope.optionsSearchAccount = {
                width: '650px',
                height: '308px',
                type: 'center',
                done: function (isCreate, a) {
                    if (isCreate === void 0) { isCreate = false; }
                    var account = $scope.searchUserSelected.length > 0 ? $scope.searchUserSelected[0] : null;
                    if (isCreate) {
                        Utils.safeApply($scope, function () {
                            $scope.currentAccount = account;
                        });
                    }
                    else {
                        $scope.searchOptions.dialog.value = account;
                    }
                }
            };
            $scope.searchAct = function () {
                $scope.searchAccount.open(true);
            };
            //付费类型
            $scope.payType = [{
                    name: 'BY_WEEK',
                    text: '按周'
                }, {
                    name: 'BY_MONTH',
                    text: '按月'
                }, {
                    name: 'BY_YEAR',
                    text: '按年'
                }];
            $scope.payDuration = [
                {
                    duration: 1,
                    text: '1个月'
                }, {
                    duration: 2,
                    text: '2个月'
                }, {
                    duration: 3,
                    text: '3个月'
                }, {
                    duration: 4,
                    text: '4个月'
                }, {
                    duration: 5,
                    text: '5个月'
                }, {
                    duration: 6,
                    text: '6个月'
                }, {
                    duration: 7,
                    text: '7个月'
                }, {
                    duration: 8,
                    text: '8个月'
                }, {
                    duration: 9,
                    text: '9个月'
                }, {
                    duration: 10,
                    text: '10个月'
                }
            ];
            //切换付费类型
            $scope.$watch(function () {
                return $scope.condition1;
            }, function (val) {
                if (Utils.notNullnotUndefined(val)) {
                    $scope.qobj_priceParam.productChargeModel = val.name;
                    if (val.name == 'BY_MONTH') {
                        $scope.payDuration = [{
                                duration: 1,
                                text: '1个月'
                            }, {
                                duration: 2,
                                text: '2个月'
                            }, {
                                duration: 3,
                                text: '3个月'
                            }, {
                                duration: 4,
                                text: '4个月'
                            }, {
                                duration: 5,
                                text: '5个月'
                            }, {
                                duration: 6,
                                text: '6个月'
                            }, {
                                duration: 7,
                                text: '7个月'
                            }, {
                                duration: 8,
                                text: '8个月'
                            }, {
                                duration: 9,
                                text: '9个月'
                            }, {
                                duration: 10,
                                text: '10个月'
                            }];
                        $scope.condition2 = $scope.payDuration[0];
                    }
                    else if (val.name == 'BY_WEEK') {
                        $scope.payDuration = [{
                                duration: 1,
                                text: '1周'
                            }, {
                                duration: 2,
                                text: '2周'
                            }, {
                                duration: 3,
                                text: '3周'
                            }];
                        $scope.condition2 = $scope.payDuration[0];
                    }
                    else {
                        $scope.payDuration = [{
                                duration: 1,
                                text: '1年'
                            }, {
                                duration: 2,
                                text: '2年'
                            }, {
                                duration: 3,
                                text: '3年'
                            }];
                        $scope.condition2 = $scope.payDuration[0];
                    }
                }
            });
            //切换付费时长
            $scope.$watch(function () {
                return $scope.condition2;
            }, function (val) {
                if (Utils.notNullnotUndefined(val)) {
                    $scope.qobj_priceParam.duration = val.duration;
                }
            });
            //客户端模式
            $scope.clientModeLists = [
                {
                    name: '路由模式',
                    value: 'RouteMode'
                }, {
                    name: '网关模式',
                    value: 'GatewayMode'
                }
            ];
            //通用参数 置空
            $scope.resetCommon = function () {
                $scope.currentVpn = {
                    name: null,
                    description: null,
                    productChargeModel: null,
                    duration: null
                };
                $scope.blurValidate = {
                    name: false,
                    description: false,
                    startIp: false,
                    endIp: false,
                    startIpCheck: function () {
                        this.startIp = true;
                        if (Utils.notNullnotUndefinedNotEmptyString($scope.ipBox.startIp)
                            && ($scope.ipBox.startIp == $scope.ipDatas.remoteIpLastNum
                                || $scope.ipBox.startIp == $scope.ipDatas.gatewayLastNum
                                || $scope.ipBox.startIp == $scope.ipDatas.monitorIpLastNum)) {
                            $scope.createVpn.startIp.$invalid = true;
                            $scope.startIpRepeat = true;
                        }
                        else {
                            $scope.startIpRepeat = false;
                        }
                    },
                    endIpCheck: function () {
                        this.endIp = true;
                        if (Utils.notNullnotUndefinedNotEmptyString($scope.ipBox.endIp)
                            && ($scope.ipBox.endIp == $scope.ipDatas.remoteIpLastNum
                                || $scope.ipBox.endIp == $scope.ipDatas.gatewayLastNum
                                || $scope.ipBox.endIp == $scope.ipDatas.monitorIpLastNum)) {
                            $scope.createVpn.endIp.$invalid = true;
                            $scope.endIpRepeat = true;
                        }
                        else {
                            $scope.endIpRepeat = false;
                        }
                    }
                };
                $scope.createVpnTips = {
                    endpoint: false,
                    bandwidth: false,
                    cert: false,
                    network: false,
                    tunnel: false
                };
                $scope.cert = null;
                $scope.certLists = [];
                //付费类型
                $scope.condition1 = $scope.payType[1];
                $scope.condition2 = $scope.payDuration[0];
                //查询价格 参数
                $scope.qobj_priceParam = {
                    productChargeModel: 'BY_MONTH',
                    duration: 1,
                    endpointUuid: null,
                    bandwidthOfferingUuid: null
                };
                $scope.networkPages = true; //默认，云网络
            };
            //云网络参数 置空
            $scope.resetNetwork = function () {
                $scope.currentVpn.bandwidthOfferingUuid = null;
                $scope.currentVpn.vpnCertUuid = null;
                $scope.currentVpn.vlan = null;
                $scope.currentVpn.endpointUuid = null;
                $scope.currentVpn.l3NetworkUuid = null;
                $scope.currentVpn.l3EndpointUuid = null;
                $scope.currentVpn.workMode = null;
                $scope.currentVpn.startIp = null;
                $scope.currentVpn.endIp = null;
                $scope.currentVpn.remoteIp = null;
                $scope.currentVpn.gateway = null;
                $scope.currentVpn.monitorIp = null;
                $scope.currentVpn.netmask = null;
                $scope.vlan = null;
                $scope.networkLists = [];
                $scope.endpoint = null;
                $scope.endpointLists = [];
                $scope.vpnPrice = null;
                $scope.ipDatas = [];
                $scope.ipBox = {
                    startIp: null,
                    endIp: null
                };
                $scope.unchange = false;
                $scope.unchangeText = '';
                $scope.clientMode = $scope.clientModeLists[0];
                $scope.networkPages = true;
            };
            //云专线参数 置空
            $scope.resetExpress = function () {
                $scope.currentVpn.bandwidthOfferingUuid = null;
                $scope.currentVpn.vpnCertUuid = null;
                $scope.currentVpn.vlan = null;
                $scope.currentVpn.endpointUuid = null;
                $scope.currentVpn.tunnelUuid = null;
                $scope.vlan = null;
                $scope.vlanLists = [];
                $scope.endpoint = null;
                $scope.endpointLists = [];
                $scope.vpnPrice = null;
                $scope.networkPages = false;
            };
            //通用请求 qobj
            $scope.creatQobj = function () {
                var qobj = new ApiHeader.QueryObject();
                qobj.start = 0;
                qobj.limit = 200;
                qobj.fields = ['uuid', 'name'];
                qobj.noError = true;
                return qobj;
            };
            //参数置空
            $scope.reset_test = function () {
                //提交参数
                $scope.currentVpn = {
                    name: null,
                    description: null,
                    productChargeModel: null,
                    duration: null,
                    bandwidthOfferingUuid: null,
                    vpnCertUuid: null,
                    vlan: null,
                    endpointUuid: null,
                    tunnelUuid: null,
                    l3NetworkUuid: null,
                    l3EndpointUuid: null,
                    workMode: null,
                    startIp: null,
                    endIp: null,
                    remoteIp: null,
                    gateway: null,
                    monitorIp: null,
                    netmask: null
                };
                $scope.blurValidate = {
                    name: false,
                    description: false,
                    startIp: false,
                    endIp: false,
                    startIpCheck: function () {
                        this.startIp = true;
                        if (Utils.notNullnotUndefinedNotEmptyString($scope.ipBox.startIp)
                            && ($scope.ipBox.startIp == $scope.ipDatas.remoteIpLastNum
                                || $scope.ipBox.startIp == $scope.ipDatas.gatewayLastNum
                                || $scope.ipBox.startIp == $scope.ipDatas.monitorIpLastNum)) {
                            $scope.createVpn.startIp.$invalid = true;
                            $scope.startIpRepeat = true;
                        }
                        else {
                            $scope.startIpRepeat = false;
                        }
                    },
                    endIpCheck: function () {
                        this.endIp = true;
                        if (Utils.notNullnotUndefinedNotEmptyString($scope.ipBox.endIp)
                            && ($scope.ipBox.endIp == $scope.ipDatas.remoteIpLastNum
                                || $scope.ipBox.endIp == $scope.ipDatas.gatewayLastNum
                                || $scope.ipBox.endIp == $scope.ipDatas.monitorIpLastNum)) {
                            $scope.createVpn.endIp.$invalid = true;
                            $scope.endIpRepeat = true;
                        }
                        else {
                            $scope.endIpRepeat = false;
                        }
                    }
                };
                $scope.createVpnTips = {
                    endpoint: false,
                    bandwidth: false,
                    cert: false,
                    network: false,
                    tunnel: false
                };
                $scope.vlan = null;
                $scope.networkLists = [];
                $scope.vlanLists = [];
                $scope.endpoint = null;
                $scope.endpointLists = [];
                $scope.cert = null;
                $scope.certLists = [];
                //付费类型
                $scope.condition1 = $scope.payType[1];
                $scope.condition2 = $scope.payDuration[0];
                //查询价格 参数
                $scope.vpnPrice = null;
                $scope.qobj_priceParam = {
                    productChargeModel: 'BY_MONTH',
                    duration: 1,
                    endpointUuid: null,
                    bandwidthOfferingUuid: null
                };
                $scope.ipDatas = [];
                $scope.ipBox = {
                    startIp: null,
                    endIp: null
                };
                $scope.unchange = false;
                $scope.unchangeText = '';
                $scope.networkPages = true; //默认，云网络
            };
            $scope.reset = function () {
                $scope.resetCommon();
                $scope.resetNetwork();
                $scope.resetExpress();
                $scope.networkPages = true; //默认，云网络
            };
            $scope.reset();
            //证书列表
            $scope.getCertList = function () {
                var qobj = $scope.creatQobj();
                //证书列表
                l2VpnMgr.getCertficateLists(qobj, function (ret) {
                    if (ret.inventories.length > 0) {
                        $scope.createVpnTips.cert = false;
                        $scope.cert = ret.inventories[0];
                        $scope.certLists = ret.inventories;
                    }
                    else {
                        $scope.createVpnTips.cert = true;
                    }
                });
            };
            //云网络|云专线 列表
            $scope.getNetWorkOrVlanLists = function () {
                var qobj = $scope.creatQobj();
                //判断类型
                if ($scope.networkPages) {
                    //云网络列表
                    vpnMgr.getNetworkLists(qobj, function (ret) {
                        if (ret.inventories.length > 0) {
                            $scope.createVpnTips.network = false;
                            $scope.networkLists = ret.inventories;
                            $scope.vlan = $scope.networkLists[0];
                        }
                        else {
                            $scope.createVpnTips.network = true;
                            $scope.networkLists = [];
                            $scope.vlan = null;
                        }
                    });
                }
                else {
                    qobj.addCondition({ name: 'purpose', op: '!=', value: 'Cutover' });
                    //专线列表
                    l2VpnMgr.getTunnelLists(qobj, function (ret) {
                        if (ret.inventories.length > 0) {
                            $scope.createVpnTips.tunnel = false;
                            $scope.vlanLists = ret.inventories;
                            $scope.vlan = $scope.vlanLists[0];
                        }
                        else {
                            $scope.createVpnTips.tunnel = true;
                            $scope.vlanLists = [];
                            $scope.vlan = null;
                        }
                    });
                }
            };
            $scope.getCertList();
            $scope.getNetWorkOrVlanLists();
            //类型切换
            $scope.selecType = function (type) {
                if (type == 'network') {
                    if ($scope.networkPages) {
                        return;
                    }
                    $scope.resetNetwork(); //清空参数
                }
                else if (type == 'private') {
                    if (!$scope.networkPages) {
                        return;
                    }
                    $scope.resetExpress(); //清空参数
                }
                $scope.getBandWidthLists(); //清空带宽选择
                $scope.cert = $scope.certLists[0]; //清空证书
                $scope.getNetWorkOrVlanLists();
            };
            //切换 云网络|云专线
            $scope.$watch(function () {
                return $scope.vlan;
            }, function (val) {
                if (Utils.notNullnotUndefined(val)) {
                    if ($scope.networkPages) {
                        //云网络 -- 可用连接点选择列表
                        vpnMgr.getVpnHostLists(val.uuid, function (ret) {
                            if (ret.inventories.length > 0) {
                                $scope.createVpnTips.endpoint = false;
                                $scope.endpoint = ret.inventories[0];
                                $scope.endpointLists = ret.inventories;
                                $scope.currentVpn.endpointName = ret.inventories[0].name;
                                $scope.currentVpn.endpointUuid = ret.inventories[0].endpointUuid;
                                $scope.qobj_priceParam.endpointUuid = ret.inventories[0].endpointUuid;
                            }
                            else {
                                $scope.createVpnTips.endpoint = true;
                                $scope.endpointLists = [];
                                $scope.currentVpn.endpointName = null;
                                $scope.currentVpn.endpointUuid = null;
                                $scope.qobj_priceParam.endpointUuid = null;
                                $scope.currentVpn.remoteIp = null;
                                $scope.currentVpn.gateway = null;
                                $scope.currentVpn.monitorIp = null;
                                $scope.currentVpn.netmask = null;
                                $scope.ipDatas = [];
                            }
                        });
                    }
                    else {
                        //云专线 -- 可用连接点选择列表
                        l2VpnMgr.getVpnHostLists(val.uuid, function (ret) {
                            if (ret.inventories.length > 0) {
                                $scope.createVpnTips.endpoint = false;
                                $scope.endpoint = ret.inventories[0];
                                $scope.endpointLists = ret.inventories;
                                $scope.currentVpn.endpointName = ret.inventories[0].name;
                                $scope.currentVpn.endpointUuid = ret.inventories[0].uuid;
                                $scope.qobj_priceParam.endpointUuid = ret.inventories[0].uuid;
                            }
                            else {
                                $scope.createVpnTips.endpoint = true;
                                $scope.endpointLists = [];
                                $scope.currentVpn.endpointUuid = null;
                                $scope.qobj_priceParam.endpointUuid = null;
                            }
                        });
                    }
                }
            });
            //切换连接点
            $scope.$watch(function () {
                return $scope.endpoint;
            }, function (val) {
                if (Utils.notNullnotUndefined(val)) {
                    if ($scope.networkPages) {
                        $scope.currentVpn.vlan = val.vlan;
                        $scope.currentVpn.endpointUuid = val.endpointUuid;
                        $scope.currentVpn.l3EndpointUuid = val.uuid;
                        $scope.currentVpn.endpointName = val.name;
                        $scope.qobj_priceParam.endpointUuid = val.endpointUuid;
                        $scope.getIp(val.uuid);
                    }
                    else {
                        $scope.currentVpn.vlan = val.vlan;
                        $scope.currentVpn.endpointUuid = val.uuid;
                        $scope.currentVpn.endpointName = val.name;
                        $scope.qobj_priceParam.endpointUuid = val.uuid;
                    }
                }
            });
            //IP地址设置
            $scope.getIp = function (l3EndpointUuid) {
                //云网络节点信息
                var qobj = new ApiHeader.QueryObject();
                qobj.addCondition({ name: 'uuid', op: '=', value: l3EndpointUuid });
                // qobj.fields = ['uuid', 'name'];
                qobj.noError = true;
                vpnMgr.getL3EndpointLists(qobj, function (ret) {
                    if (ret.inventories.length > 0 && Utils.notNullnotUndefinedNotEmptyString(ret.inventories[0].netmask)) {
                        $scope.currentVpn.remoteIp = ret.inventories[0].remoteIp;
                        $scope.currentVpn.gateway = ret.inventories[0].localIP;
                        $scope.currentVpn.monitorIp = ret.inventories[0].monitorIp;
                        $scope.currentVpn.netmask = ret.inventories[0].netmask;
                        $scope.ipDatas = [];
                        var remoteIp = $scope.currentVpn.remoteIp.split('.');
                        $scope.ipDatas.ip = [];
                        $scope.ipDatas.ip.push(remoteIp[0]);
                        $scope.ipDatas.ip.push(remoteIp[1]);
                        $scope.ipDatas.ip.push(remoteIp[2]);
                        $scope.ipDatas.remoteIpLastNum = remoteIp[3];
                        var gateway = $scope.currentVpn.gateway.split('.');
                        $scope.ipDatas.gatewayLastNum = gateway[3];
                        var monitorIp = $scope.currentVpn.monitorIp.split('.');
                        $scope.ipDatas.monitorIpLastNum = monitorIp[3];
                    }
                    else {
                        $scope.currentVpn.remoteIp = null;
                        $scope.currentVpn.gateway = null;
                        $scope.currentVpn.monitorIp = null;
                        $scope.currentVpn.netmask = null;
                        $scope.ipDatas = [];
                    }
                });
            };
            //带宽 列表
            $scope.getBandWidthLists = function () {
                $scope.bandwidthLists = [];
                $scope.qobj_priceParam.bandwidthOfferingUuid = null;
                $scope.bandwidthParams = {
                    seleBandWidth_idnex: null
                };
                /*let qobj_Bandwidth=new ApiHeader.QueryObject();
                qobj_Bandwidth.start=0;
                qobj_Bandwidth.limit=200;
                qobj_Bandwidth.fields=['uuid', 'name'];*/
                var qobj_Bandwidth = new ApiHeader.QueryObject();
                qobj_Bandwidth.sortBy = 'bandwidth';
                qobj_Bandwidth.sortDirection = 'asc';
                qobj_Bandwidth.conditions = [];
                l2VpnMgr.getBandwidthList(qobj_Bandwidth, function (ret) {
                    /*if(ret.inventories.length>0){
                        $scope.createVpnTips.bandwidth=false;
                        $scope.bandwidthLists=ret.inventories;
                    }else{
                        $scope.createVpnTips.bandwidth=true;
                    }*/
                    $scope.bandwidthOption.models = ret.inventories;
                });
            };
            $scope.getBandWidthLists();
            $scope.bandwidthOption = {
                models: null,
                currentItem: null,
                done: function (data) {
                    if (data) {
                        $scope.qobj_priceParam.bandwidthOfferingUuid = data.uuid;
                    }
                    else {
                        $scope.qobj_priceParam.bandwidthOfferingUuid = null;
                    }
                    $scope.createVpnTips.bandwidth = false;
                }
            };
            //带宽点击
            $scope.seleBandWidth = function (i, v) {
                $scope.bandwidthParams.seleBandWidth_idnex = i;
                $scope.qobj_priceParam.bandwidthOfferingUuid = v.uuid;
            };
            //查询新建vpn价格
            $scope.getPrice = function () {
                l2VpnMgr.queryPrice($scope.qobj_priceParam, function (ret) {
                    $scope.vpnPrice = ret;
                    //计算折扣
                    // $scope.vpnPrice.discount = (ret.discountPrice / ret.originalPrice) * 10;
                });
            };
            //监控vpn价格 参数
            $scope.$watch(function () {
                return $scope.qobj_priceParam;
            }, function (val) {
                if (Utils.notNullnotUndefined(val.duration)
                    && Utils.notNullnotUndefined(val.bandwidthOfferingUuid)
                    && Utils.notNullnotUndefined(val.endpointUuid)) {
                    $scope.getPrice();
                    $scope.createVpnTips.bandwidth = false;
                }
                else {
                    $scope.vpnPrice = null;
                }
            }, true);
            $scope.checkIp = function (remoteIp, localIP, monitorIp, startIp, endIp) {
                //排序 remoteIp localIP monitorIp
                var ipBox = [remoteIp, localIP, monitorIp];
                ipBox = ipBox.sort();
                startIp = Number(startIp);
                endIp = Number(endIp);
                if (startIp >= endIp) {
                    return [0, '终止IP需大于起始IP'];
                }
                if (startIp < ipBox[0] && endIp > ipBox[0]) {
                    return [0, 'IP冲突'];
                }
                if (startIp < ipBox[1] && endIp > ipBox[1]) {
                    return [0, 'IP冲突'];
                }
                if (startIp < ipBox[1] && endIp > ipBox[1]) {
                    return [0, 'IP冲突'];
                }
                return [1];
            };
            $scope.confirm = function () {
                if (!$scope.qobj_priceParam.bandwidthOfferingUuid) {
                    $scope.createVpnTips.bandwidth = true;
                }
                if ($scope.networkPages) {
                    //与三个ip冲突
                    var checked = $scope.checkIp($scope.ipDatas.remoteIpLastNum, $scope.ipDatas.gatewayLastNum, $scope.ipDatas.monitorIpLastNum, $scope.ipBox.startIp, $scope.ipBox.endIp);
                    if (!checked[0]) {
                        $scope.unchange = true;
                        $scope.unchangeText = checked[1];
                        return;
                    }
                    if (!$scope.createVpnTips.network
                        && !$scope.createVpnTips.endpoint
                        && !$scope.createVpnTips.bandwidth
                        && !$scope.createVpnTips.cert) {
                        $scope.currentVpn.vpnCertUuid = $scope.cert.uuid;
                        $scope.currentVpn.duration = $scope.qobj_priceParam.duration;
                        $scope.currentVpn.productChargeModel = $scope.qobj_priceParam.productChargeModel;
                        $scope.currentVpn.bandwidthOfferingUuid = $scope.qobj_priceParam.bandwidthOfferingUuid;
                        $scope.currentVpn.l3NetworkUuid = $scope.vlan.uuid;
                        $scope.currentVpn.workMode = $scope.clientMode.value;
                        $scope.currentVpn.startIp = $scope.ipDatas.ip.concat($scope.ipBox.startIp).join('.');
                        $scope.currentVpn.endIp = $scope.ipDatas.ip.concat($scope.ipBox.endIp).join('.');
                        var params = {
                            name: '云网关',
                            type: '购买',
                            discountPrice: null,
                            itemMsg: null,
                            backUrl: '/vpn/gateway',
                            networkPages: true
                        };
                        params.discountPrice = $scope.vpnPrice.discountPrice; //支付价格
                        params.itemMsg = $scope.currentVpn; //提交数据
                        $rootScope.currentParam = params;
                        $location.path('/vpn/gateway/pay');
                    }
                }
                else {
                    if (!$scope.createVpnTips.tunnel
                        && !$scope.createVpnTips.endpoint
                        && !$scope.createVpnTips.bandwidth
                        && !$scope.createVpnTips.cert) {
                        $scope.currentVpn.vpnCertUuid = $scope.cert.uuid;
                        $scope.currentVpn.duration = $scope.qobj_priceParam.duration;
                        $scope.currentVpn.productChargeModel = $scope.qobj_priceParam.productChargeModel;
                        $scope.currentVpn.bandwidthOfferingUuid = $scope.qobj_priceParam.bandwidthOfferingUuid;
                        $scope.currentVpn.tunnelUuid = $scope.vlan.uuid;
                        var params = {
                            name: '云网关',
                            type: '购买',
                            discountPrice: null,
                            itemMsg: null,
                            backUrl: '/vpn/gateway',
                            networkPages: false
                        };
                        params.discountPrice = $scope.vpnPrice.discountPrice; //支付价格
                        params.itemMsg = $scope.currentVpn; //提交数据
                        $rootScope.currentParam = params;
                        $location.path('/vpn/gateway/pay');
                    }
                }
            };
            //跳转新建证书
            $scope.newCert = function () {
                angular.forEach(angular.element('.left-nav .sub-nav a'), function (v, i) {
                    if (v.text == '云网关') {
                        v.classList.remove('current');
                    }
                });
                $location.path('/vpn/vpnCertificate');
            };
        }
        CreateController.$inject = ['$scope', 'VpnManagerL3', 'VpnManagerL2', '$rootScope', '$location'];
        return CreateController;
    }());
    MCWVpn.CreateController = CreateController;
    //修改名称
    var UpdateCwVpnName = /** @class */ (function () {
        function UpdateCwVpnName(l2VpnMgr, $q) {
            var _this = this;
            this.l2VpnMgr = l2VpnMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.templateUrl = '/vpn/template/L3MPLSVpn/update.html';
            this.link = function (scope, $element, $attrs) {
                _this.$scope = scope;
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateCwVpnName] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions
                    = new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.currentData = {
                    name: null,
                    description: null
                };
                scope.blurValidate = {
                    name: false,
                    description: false
                };
                scope.reset = function () {
                    scope.currentData = {
                        name: null,
                        description: null
                    };
                    scope.blurValidate = {
                        // noUser: false,
                        name: false,
                        description: false
                    };
                };
                scope.confirm = function (e) {
                    l2VpnMgr.updateName(scope.currentData, function (ret) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(ret);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
            };
        }
        UpdateCwVpnName.prototype.open = function (cert) {
            var defer = this.$q.defer();
            this.$scope.reset();
            this.$scope.currentData = angular.copy(cert);
            this.options.open();
        };
        return UpdateCwVpnName;
    }());
    MCWVpn.UpdateCwVpnName = UpdateCwVpnName;
    //设置IP地址
    var SettingIp = /** @class */ (function () {
        function SettingIp(vpnMgr, $q) {
            var _this = this;
            this.vpnMgr = vpnMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.templateUrl = '/vpn/template/L3MPLSVpn/settingIp.html';
            this.link = function (scope, $element, $attrs) {
                _this.$scope = scope;
                var parentScope = scope.$parent;
                parentScope[$attrs.wSettingIp] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions
                    = new Utils.DialogManage($element, { width: options.width, type: options.type });
                //参数置空
                scope.reset = function () {
                    scope.submitDatas = {
                        uuid: null,
                        startIp: null,
                        endIp: null,
                        netmask: null,
                        gateway: null,
                        remoteIp: null,
                        monitorIp: null
                    };
                    scope.ipDatas = [];
                    scope.blurValidate = {
                        startIp: false,
                        endIp: false,
                        startIpCheck: function () {
                            this.startIp = true;
                            if (Utils.notNullnotUndefinedNotEmptyString(scope.ipBox.startIp)
                                && (scope.ipBox.startIp == scope.ipDatas.remoteIpLastNum
                                    || scope.ipBox.startIp == scope.ipDatas.gatewayLastNum
                                    || scope.ipBox.startIp == scope.ipDatas.monitorIpLastNum)) {
                                scope.settingIpForm.startIp.$invalid = true;
                                scope.startIpRepeat = true;
                            }
                            else {
                                scope.startIpRepeat = false;
                            }
                        },
                        endIpCheck: function () {
                            this.endIp = true;
                            if (Utils.notNullnotUndefinedNotEmptyString(scope.ipBox.endIp)
                                && (scope.ipBox.endIp == scope.ipDatas.remoteIpLastNum
                                    || scope.ipBox.endIp == scope.ipDatas.gatewayLastNum
                                    || scope.ipBox.endIp == scope.ipDatas.monitorIpLastNum)) {
                                scope.settingIpForm.endIp.$invalid = true;
                                scope.endIpRepeat = true;
                            }
                            else {
                                scope.endIpRepeat = false;
                            }
                        }
                    };
                    scope.unchange = false;
                    scope.unchangeText = '';
                };
                //设置前三位
                scope.setIpNum = function () {
                    scope.ipDatas = [];
                    var remoteIp = scope.currentData.remoteIp.split('.');
                    scope.ipDatas.ip = [];
                    scope.ipDatas.ip.push(remoteIp[0]);
                    scope.ipDatas.ip.push(remoteIp[1]);
                    scope.ipDatas.ip.push(remoteIp[2]);
                    scope.ipDatas.remoteIpLastNum = remoteIp[3];
                    scope.ipDatas.gatewayLastNum = scope.currentData.gateway.split('.')[3];
                    scope.ipDatas.monitorIpLastNum = scope.currentData.monitorIp.split('.')[3];
                };
                //请求 l3EndpointUuid、workMode、startIp、endIp
                scope.getDetails = function (uuid) {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({ name: 'uuid', op: '=', value: uuid });
                    qobj.fields = ['l3EndpointUuid', 'startIp', 'endIp'];
                    qobj.noError = true;
                    vpnMgr.getIps(qobj, function (ret) {
                        if (ret.success) {
                            scope.currentData.l3EndpointUuid = ret.inventories[0].l3EndpointUuid;
                            scope.currentData.startIp = ret.inventories[0].startIp;
                            scope.currentData.endIp = ret.inventories[0].endIp;
                            scope.ipBox = {
                                startIp: scope.currentData.startIp.split('.')[3],
                                endIp: scope.currentData.endIp.split('.')[3]
                            };
                            scope.getIp(scope.currentData.l3EndpointUuid);
                        }
                    });
                };
                //请求ip信息
                scope.getIp = function (l3EndpointUuid) {
                    var qobj = new ApiHeader.QueryObject();
                    qobj.addCondition({ name: 'uuid', op: '=', value: l3EndpointUuid });
                    qobj.fields = ['remoteIp', 'localIP', 'monitorIp', 'netmask'];
                    qobj.noError = true;
                    vpnMgr.getL3EndpointLists(qobj, function (ret) {
                        if (ret.success) {
                            scope.currentData.remoteIp = ret.inventories[0].remoteIp;
                            scope.currentData.localIP = ret.inventories[0].localIP;
                            scope.currentData.gateway = ret.inventories[0].localIP;
                            scope.currentData.monitorIp = ret.inventories[0].monitorIp;
                            scope.currentData.netmask = ret.inventories[0].netmask;
                            scope.setIpNum();
                        }
                    });
                };
                //提交
                scope.confirm = function (e) {
                    //未修改
                    scope.submitDatas.startIp = scope.ipDatas.ip.concat(scope.ipBox.startIp).join('.');
                    scope.submitDatas.endIp = scope.ipDatas.ip.concat(scope.ipBox.endIp).join('.');
                    if (scope.submitDatas.startIp == scope.currentData.startIp && scope.submitDatas.endIp == scope.currentData.endIp) {
                        scope.unchange = true;
                        scope.unchangeText = '未修改数据';
                        return;
                    }
                    //与三个ip冲突
                    var checked = parentScope.checkIp(scope.ipDatas.remoteIpLastNum, scope.ipDatas.gatewayLastNum, scope.ipDatas.monitorIpLastNum, scope.ipBox.startIp, scope.ipBox.endIp);
                    if (!checked[0]) {
                        scope.unchange = true;
                        scope.unchangeText = checked[1];
                        return;
                    }
                    scope.unchange = false;
                    if (Utils.notNullnotUndefinedNotEmptyString(scope.submitDatas.startIp)
                        && Utils.notNullnotUndefinedNotEmptyString(scope.submitDatas.endIp)) {
                        scope.submitDatas.uuid = scope.currentData.uuid;
                        scope.submitDatas.netmask = scope.currentData.netmask;
                        scope.submitDatas.gateway = scope.currentData.gateway;
                        scope.submitDatas.remoteIp = scope.currentData.remoteIp;
                        scope.submitDatas.monitorIp = scope.currentData.monitorIp;
                        vpnMgr.updateL3VpnRouteIP(scope.submitDatas, function (ret) {
                            if (Utils.notNullnotUndefined(options.done)) {
                                options.done(ret);
                            }
                        });
                        scope.dialogOptions.close(e);
                    }
                };
            };
        }
        SettingIp.prototype.open = function (cert) {
            this.$scope.currentData = angular.copy(cert);
            this.$scope.reset();
            this.options.open();
            if (cert.resourceType == 'network') {
                this.$scope.getDetails(cert.uuid);
            }
        };
        return SettingIp;
    }());
    MCWVpn.SettingIp = SettingIp;
    //调整模式
    var UpdateMode = /** @class */ (function () {
        function UpdateMode(vpnMgr, $q) {
            var _this = this;
            this.vpnMgr = vpnMgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.templateUrl = '/vpn/template/L3MPLSVpn/updateMode.html';
            this.link = function (scope, $element, $attrs) {
                _this.$scope = scope;
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateMode] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions
                    = new Utils.DialogManage($element, { width: options.width, type: options.type });
                //客户端模式 workMode
                scope.judgeMode = function () {
                    scope.clientModeLists = {};
                    scope.isDisabled = false;
                    if (scope.currentData.workMode == 'RouteMode') {
                        scope.clientModeLists = [
                            {
                                name: '网关模式',
                                value: 'GatewayMode'
                            }
                        ];
                        scope.clientMode = scope.clientModeLists[0];
                    }
                    else if (scope.currentData.workMode == 'GatewayMode') {
                        scope.clientModeLists = [
                            {
                                name: '路由模式',
                                value: 'RouteMode'
                            }
                        ];
                        scope.clientMode = scope.clientModeLists[0];
                    }
                    else {
                        scope.isDisabled = true;
                    }
                };
                //确定修改
                scope.confirm = function (e) {
                    scope.workMode = scope.clientMode.value;
                    vpnMgr.updateL3VpnWorkMode(scope.workMode, scope.currentData.uuid, function (ret) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            ret.inventory.workMode = scope.clientMode.value;
                            options.done(ret.inventory);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
            };
        }
        UpdateMode.prototype.open = function (cert) {
            var _this = this;
            this.$scope.currentData = angular.copy(cert);
            this.vpnMgr.getL3VpnWorkModeLists(cert.uuid, function (ret) {
                if (ret.success) {
                    _this.$scope.currentData.workMode = ret.workMode;
                    _this.$scope.judgeMode();
                }
            });
            this.options.open();
        };
        return UpdateMode;
    }());
    MCWVpn.UpdateMode = UpdateMode;
    //修改带宽
    var UpdateCwVpnBandwidth = /** @class */ (function () {
        function UpdateCwVpnBandwidth(vpnMgr, $q, $location, $rootScope, l2VpnMgr) {
            var _this = this;
            this.vpnMgr = vpnMgr;
            this.$q = $q;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l2VpnMgr = l2VpnMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.templateUrl = '/vpn/template/L3MPLSVpn/updateVpnBandwidth.html';
            this.link = function (scope, $element, $attrs) {
                _this.$scope = scope;
                var parentScope = scope.$parent;
                parentScope[$attrs.wUpdateCwVpnBandwidth] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions
                    = new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.needPayMoney = 0.00; //应补差价
                scope.updateInvalid = true;
                scope.modifie = true;
                scope.currentData = {
                    modifies: 0,
                    name: 0,
                    bandwidth: null,
                    expireDate: null,
                    bandwidthOfferingUuid: null
                };
                scope.reset = function () {
                    scope.isDisabled = false;
                    scope.needPayMoney = 0.00; //应补差价
                    scope.updateInvalid = true;
                    scope.modifie = true;
                    scope.bandwidthLists = [];
                    scope.currentData = {
                        modifies: 0,
                        name: 0,
                        bandwidth: null,
                        expireDate: null,
                        bandwidthOfferingUuid: null
                    };
                };
                //创建-带宽点击
                $element.on('click', '#updateVpnBandWidth .bandwidth li', function () {
                    var _this = this;
                    if (angular.element(this).text() != scope.currentData.bandwidth) {
                        angular.element(this).addClass('active').siblings('li').removeClass('active');
                        Utils.safeApply(scope, function () {
                            var val = angular.element(_this).text();
                            scope.currentData.bandwidthOfferingUuid = angular.element(_this)[0].dataset.uuid;
                            scope.currentData.newBandwidth = angular.element(_this)[0].dataset.bandwidth;
                            scope.currentData.bandwidthName = angular.element(_this)[0].dataset.name;
                        });
                    }
                });
                //监控vpn价格 参数
                scope.$watch(function () {
                    return scope.currentData.bandwidthOfferingUuid;
                }, function (val) {
                    if (Utils.notNullnotUndefined(val)) {
                        //查询修改带宽价格
                        l2VpnMgr.getModifyVpnPriceDiff(scope.currentData, function (ret) {
                            if (ret.success) {
                                scope.needPayMoney = ret.needPayMoney.toFixed(2);
                                scope.updateInvalid = false;
                            }
                            else {
                                scope.updateInvalid = true;
                            }
                        });
                    }
                }, true);
                scope.confirm = function (e) {
                    if (!scope.updateInvalid && !scope.modifie && !scope.isDisabled) {
                        scope.isDisabled = true;
                        var params = {
                            name: 'VPN',
                            type: '调整带宽',
                            discountPrice: null,
                            itemMsg: null,
                            backUrl: '/vpn/gateway'
                        };
                        params.discountPrice = scope.needPayMoney; //应补差价
                        params.itemMsg = scope.currentData; //提交数据
                        $rootScope.currentParam = params;
                        $location.path('/vpn/gateway/pay');
                    }
                };
            };
        }
        UpdateCwVpnBandwidth.prototype.open = function (cert) {
            var _this = this;
            var defer = this.$q.defer();
            this.$scope.reset();
            this.$scope.currentData = angular.copy(cert);
            this.options.open();
            //查询VPN修改次数
            var uuid = this.$scope.currentData.uuid;
            this.l2VpnMgr.getVpnModify(uuid, function (ret) {
                if (Utils.notNullnotUndefined(ret.modifies)) {
                    _this.$scope.currentData.modifies = ret.modifies;
                    if (_this.$scope.currentData.modifies < _this.$scope.currentData.maxModifies) {
                        _this.$scope.modifie = false;
                    }
                    else {
                        _this.$scope.modifie = true;
                    }
                }
            });
            //带宽 列表
            var qobj_Bandwidth = new ApiHeader.QueryObject();
            qobj_Bandwidth.start = 0;
            qobj_Bandwidth.limit = 200;
            qobj_Bandwidth.fields = ['uuid', 'name'];
            this.l2VpnMgr.getBandwidthList(qobj_Bandwidth, function (ret) {
                _this.$scope.bandwidthLists = ret.inventories;
            });
        };
        return UpdateCwVpnBandwidth;
    }());
    MCWVpn.UpdateCwVpnBandwidth = UpdateCwVpnBandwidth;
    //绑定证书
    var AttachCwVpnCert = /** @class */ (function () {
        function AttachCwVpnCert(vpnMgr, $q, l2VpnMgr) {
            var _this = this;
            this.vpnMgr = vpnMgr;
            this.$q = $q;
            this.l2VpnMgr = l2VpnMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.templateUrl = '/vpn/template/L3MPLSVpn/attachVpnCert.html';
            this.link = function (scope, $element, $attrs) {
                _this.$scope = scope;
                var parentScope = scope.$parent;
                parentScope[$attrs.wAttachCwVpnCert] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions
                    = new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.currentData = {};
                scope.reset = function () {
                    scope.currentData = {};
                };
                scope.confirm = function (e) {
                    scope.currentData.vpnCertUuid = scope.cert.uuid;
                    l2VpnMgr.attachVpnCert(scope.currentData, function (ret) {
                        if (Utils.notNullnotUndefined(options.done)) {
                            options.done(ret);
                        }
                    });
                    scope.dialogOptions.close(e);
                };
            };
        }
        AttachCwVpnCert.prototype.open = function (cert) {
            var _this = this;
            var defer = this.$q.defer();
            this.$scope.reset();
            this.$scope.currentData = angular.copy(cert);
            this.options.open();
            //证书 列表
            var qobj_certificate = new ApiHeader.QueryObject();
            qobj_certificate.start = 0;
            qobj_certificate.limit = 200;
            qobj_certificate.fields = ['uuid', 'name'];
            this.l2VpnMgr.getCertficateLists(qobj_certificate, function (ret) {
                _this.$scope.cert = ret.inventories[0];
                _this.$scope.certLists = ret.inventories;
            });
        };
        return AttachCwVpnCert;
    }());
    MCWVpn.AttachCwVpnCert = AttachCwVpnCert;
    //续费
    var RenewCw = /** @class */ (function () {
        function RenewCw(vpnMgr, $q, $location, $rootScope, l2VpnMgr) {
            var _this = this;
            this.vpnMgr = vpnMgr;
            this.$q = $q;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.l2VpnMgr = l2VpnMgr;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.templateUrl = '/vpn/template/L3MPLSVpn/renew.html';
            this.link = function (scope, $element, $attrs) {
                _this.$scope = scope;
                var parentScope = scope.$parent;
                parentScope[$attrs.wRenewCw] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions =
                    new Utils.DialogManage($element, { width: options.width, type: options.type });
                scope.getPriceParamObj = {
                    uuid: null,
                    duration: 1,
                    productChargeModel: 'BY_MONTH'
                };
                //参数置空
                scope.reset = function () {
                    scope.isDisabled = false;
                    scope.type = scope.payType[1];
                    scope.duration = scope.payDuration[0];
                    scope.getPriceParamObj = {
                        uuid: scope.currentVpn.uuid,
                        duration: 1,
                        productChargeModel: 'BY_MONTH'
                    };
                };
                scope.payType = [{
                        name: 'BY_WEEK',
                        text: '按周'
                    }, {
                        name: 'BY_MONTH',
                        text: '按月'
                    }, {
                        name: 'BY_YEAR',
                        text: '按年'
                    }];
                scope.type = scope.payType[1];
                scope.payDuration = [
                    {
                        duration: 1,
                        text: '1个月'
                    }, {
                        duration: 2,
                        text: '2个月'
                    }, {
                        duration: 3,
                        text: '3个月'
                    }, {
                        duration: 4,
                        text: '4个月'
                    }, {
                        duration: 5,
                        text: '5个月'
                    }, {
                        duration: 6,
                        text: '6个月'
                    }, {
                        duration: 7,
                        text: '7个月'
                    }, {
                        duration: 8,
                        text: '8个月'
                    }, {
                        duration: 9,
                        text: '9个月'
                    }, {
                        duration: 10,
                        text: '10个月'
                    }
                ];
                scope.duration = scope.payDuration[0];
                //切换付费类型
                scope.$watch(function () {
                    return scope.type;
                }, function (val) {
                    scope.getPriceParamObj.productChargeModel = val.name;
                    if (val.name == 'BY_MONTH') {
                        scope.payDuration = [{
                                duration: 1,
                                text: '1个月'
                            }, {
                                duration: 2,
                                text: '2个月'
                            }, {
                                duration: 3,
                                text: '3个月'
                            }, {
                                duration: 4,
                                text: '4个月'
                            }, {
                                duration: 5,
                                text: '5个月'
                            }, {
                                duration: 6,
                                text: '6个月'
                            }, {
                                duration: 7,
                                text: '7个月'
                            }, {
                                duration: 8,
                                text: '8个月'
                            }, {
                                duration: 9,
                                text: '9个月'
                            }, {
                                duration: 10,
                                text: '10个月'
                            }];
                        scope.duration = scope.payDuration[0];
                    }
                    else if (val.name == 'BY_WEEK') {
                        scope.payDuration = [{
                                duration: 1,
                                text: '1周'
                            }, {
                                duration: 2,
                                text: '2周'
                            }, {
                                duration: 3,
                                text: '3周'
                            }];
                        scope.duration = scope.payDuration[0];
                    }
                    else {
                        scope.payDuration = [{
                                duration: 1,
                                text: '1年'
                            }, {
                                duration: 2,
                                text: '2年'
                            }, {
                                duration: 3,
                                text: '3年'
                            }];
                        scope.duration = scope.payDuration[0];
                    }
                });
                //切换付费时长
                scope.$watch(function () {
                    return scope.duration;
                }, function (val) {
                    scope.getPriceParamObj.duration = val.duration;
                });
                scope.confirm = function (e) {
                    if (!scope.isDisabled) {
                        scope.isDisabled = true;
                        l2VpnMgr.getRenewVpnPrice(scope.getPriceParamObj, function (ret) {
                            var params = {
                                name: 'VPN',
                                type: '续费',
                                discountPrice: null,
                                itemMsg: null,
                                backUrl: '/vpn/gateway'
                            };
                            params.discountPrice = ret.discountPrice; //应补差价
                            scope.currentVpn.duration = scope.getPriceParamObj.duration;
                            scope.currentVpn.productChargeModel = scope.getPriceParamObj.productChargeModel;
                            params.itemMsg = scope.currentVpn; //提交数据
                            $rootScope.currentParam = params;
                            $location.path('/vpn/gateway/pay');
                        });
                    }
                };
            };
        }
        RenewCw.prototype.open = function (item) {
            this.$scope.currentVpn = angular.copy(item);
            this.$scope.reset();
            this.options.open();
        };
        return RenewCw;
    }());
    MCWVpn.RenewCw = RenewCw;
    //监控
    var FlowMonitor = /** @class */ (function () {
        function FlowMonitor(Mgr, $q) {
            var _this = this;
            this.Mgr = Mgr;
            this.$q = $q;
            this.replace = true;
            this.restrict = 'EA';
            this.scope = true;
            this.link = function (scope, $element, $attrs) {
                var parentScope = scope.$parent;
                parentScope[$attrs.wFlowMonitor] = _this;
                var options = parentScope[$attrs.wOptions];
                _this.options = scope.dialogOptions = new Utils.DialogManage($element, { width: options.width, type: options.type, height: options.height });
                scope.reset = function (current) {
                    scope.infoPage = {
                        switchPortUuid: null,
                        metrics: null,
                        start: null,
                        end: null
                    };
                    scope.periods = [{
                            value: 'value1',
                            text: '一小时内'
                        }, {
                            value: 'value2',
                            text: '一天内'
                        }, {
                            value: 'value3',
                            text: '一周内'
                        }, {
                            value: 'value3',
                            text: '一个月内'
                        }];
                    scope.chartObj1 = [];
                    scope.chartObj2 = [];
                    Mgr.queryMonitorCondition(scope.currentItem.uuid, function (conditions) {
                        scope.infoPage.metrics = ['net.if.in.bytes', 'net.if.out.bytes', 'net.if.in.packets', 'net.if.out.packets'];
                        scope.period = scope.periods[0];
                        scope.beginDate = null;
                        scope.endDate = null;
                        scope.conditions = conditions;
                    });
                };
                scope.$watch(function () {
                    return scope.period;
                }, function (newVal) {
                    if (Utils.notNullnotUndefined(newVal)) {
                        if (newVal.text == '一小时内') {
                            scope.infoPage.start = new Date().getTime() - 60 * 60 * 1000;
                            scope.infoPage.end = new Date().getTime();
                            scope.search(false, true);
                        }
                        else if (newVal.text == '一天内') {
                            scope.infoPage.start = new Date().getTime() - 24 * 60 * 60 * 1000;
                            scope.infoPage.end = new Date().getTime();
                            scope.search(false, true);
                        }
                        else if (newVal.text == '一周内') {
                            scope.infoPage.start = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
                            scope.infoPage.end = new Date().getTime();
                            scope.search(false, true);
                        }
                        else if (newVal.text == '一个月内') {
                            scope.infoPage.start = new Date().getTime() - 30 * 24 * 60 * 60 * 1000;
                            scope.infoPage.end = new Date().getTime();
                            scope.search(false, true);
                        }
                    }
                });
                scope.queryPeriod = function () {
                    if (scope.period.text == '一小时内') {
                        scope.infoPage.start = new Date().getTime() - 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(false, false);
                    }
                    else if (scope.period.text == '一天内') {
                        scope.infoPage.start = new Date().getTime() - 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(false, false);
                    }
                    else if (scope.period.text == '一周内') {
                        scope.infoPage.start = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(false, false);
                    }
                    else if (scope.period.text == '一个月内') {
                        scope.infoPage.start = new Date().getTime() - 30 * 24 * 60 * 60 * 1000;
                        scope.infoPage.end = new Date().getTime();
                        scope.search(false, false);
                    }
                };
                scope.loadChart = function () {
                    var myChart = echarts.init(document.getElementById('flowMonitor'));
                    var echartOptions = {
                        color: ['#3cb371', '#ff7f50', '#ffa500', '#da70d6'],
                        title: {
                            text: scope.currentItem.portName,
                            x: 'center',
                            textStyle: {
                                fontSize: 14,
                                fontWeight: 'bolder',
                                color: '#00c1e0'
                            }
                        },
                        legend: {
                            data: ['net.if.in.bytes', 'net.if.out.bytes', 'net.if.in.packets', 'net.if.out.packets'],
                            y: 'bottom'
                        },
                        tooltip: {
                            trigger: 'axis',
                            backgroundColor: 'rgba(0,193,224,0.9)',
                            textStyle: {
                                color: '#fff'
                            },
                            borderColor: '#00c1e0',
                            borderWidth: 1,
                            axisPointer: {
                                type: 'line',
                                lineStyle: {
                                    color: '#ccc',
                                    width: 1,
                                    type: 'solid'
                                }
                            },
                            formatter: function (datas) {
                                var res = datas[0].name + '<br/>', val;
                                for (var i = 0, length_2 = datas.length; i < length_2; i++) {
                                    if (datas[i].seriesName == 'net.if.in.bytes' || datas[i].seriesName == 'net.if.out.bytes' || datas[i].seriesName == 'net.if.in.packets' || datas[i].seriesName == 'net.if.out.packets') {
                                        val = Utils.sizeRoundToString(datas[i].value);
                                    }
                                    else if (datas[i].seriesName == 'tunnel.packets.lost') {
                                        val = datas[i].value + '%';
                                    }
                                    else if (datas[i].seriesName == 'tunnel.packets.rtt') {
                                        val = datas[i].value + 'ms';
                                    }
                                    else {
                                        val = datas[i].value;
                                    }
                                    res += datas[i].seriesName + '：' + val + '<br/>';
                                }
                                return res;
                            }
                        },
                        grid: {
                            x: '80',
                            y: '50',
                            x2: '80',
                            y2: '60'
                        },
                        calculable: true,
                        xAxis: [
                            {
                                type: 'category',
                                boundaryGap: false,
                                axisLine: {
                                    show: false
                                },
                                data: scope.datas1.datasX,
                                axisTick: {
                                    show: false
                                }
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value',
                                axisLine: {
                                    show: false
                                },
                                axisLabel: {
                                    formatter: function (value) {
                                        return Utils.sizeRoundToString(value);
                                    }
                                },
                                axisTick: {
                                    show: false
                                }
                            },
                            {
                                type: 'value',
                                axisLine: {
                                    show: false
                                },
                                axisLabel: {
                                    formatter: '{value}'
                                },
                                axisTick: {
                                    show: false
                                }
                            }
                        ],
                        series: scope.chartObj1
                    };
                    myChart.setOption(echartOptions);
                    window.addEventListener('resize', function () {
                        myChart.resize();
                    });
                };
                $('.date-begin').datetimepicker({
                    minView: 'hour',
                    format: 'yyyy-mm-dd hh:ii',
                    language: 'zh-CN',
                    autoclose: true //选择日期后自动关闭
                }).on('change', function (ev) {
                    $('.date-end').datetimepicker('setStartDate', scope.beginDate);
                });
                $('.date-end').datetimepicker({
                    minView: 'hour',
                    format: 'yyyy-mm-dd hh:ii',
                    language: 'zh-CN',
                    autoclose: true //选择日期后自动关闭
                }).on('change', function (ev) {
                    $('.date-begin').datetimepicker('setEndDate', scope.endDate);
                });
                function getLocalTime(nS) {
                    var oDate = new Date(parseInt(nS) * 1000), oHour = oDate.getHours() < 10 ? '0' + oDate.getHours() : oDate.getHours(), oMin = oDate.getMinutes() < 10 ? '0' + oDate.getMinutes() : oDate.getMinutes(), oSen = oDate.getSeconds() < 10 ? '0' + oDate.getSeconds() : oDate.getSeconds();
                    var timeStr = oHour + ':' + oMin + ':' + oSen;
                    return timeStr;
                }
                function getFormatTime(nS) {
                    return new Date(parseInt(nS) * 1000).toLocaleString().replace(/年|月/g, '-').replace(/日/g, ' ');
                }
                scope.search = function (isCheck, isClear) {
                    clearInterval(scope.intervalNumber);
                    if (isCheck) {
                        if (Utils.notNullnotUndefinedNotEmptyString(scope.beginDate)) {
                            var begin = new Date(scope.beginDate + ':00');
                            scope.infoPage.start = begin.getTime();
                        }
                        else {
                            scope.infoPage.start = new Date().getTime() - 60 * 60 * 1000;
                            scope.intervalNumber = setInterval(function () {
                                scope.queryPeriod();
                            }, 5000);
                        }
                        if (Utils.notNullnotUndefinedNotEmptyString(scope.endDate)) {
                            var end = new Date(scope.endDate + ':00');
                            scope.infoPage.end = end.getTime();
                        }
                        else {
                            scope.infoPage.end = new Date().getTime();
                        }
                    }
                    else {
                        scope.intervalNumber = setInterval(function () {
                            scope.queryPeriod();
                        }, 5000);
                    }
                    scope.infoPage.switchPortUuid = scope.currentItem.uuid;
                    if (scope.infoPage.start == scope.infoPage.end) {
                        return;
                    }
                    angular.forEach(scope.conditions, function (item) {
                        //查看监控
                        Mgr.flowMonitor(scope.infoPage, item.tags, function (ret) {
                            _this.$scope.isShowLoading = false;
                            if (ret.length == 0) {
                                scope.noData = true;
                                $('#flowMonitor').hide();
                            }
                            else {
                                scope.chartObj1.splice(0, scope.chartObj1.length);
                                scope.datas1 = {
                                    datasX: [],
                                    datasY: [],
                                    tags: null
                                };
                                scope.noData = false;
                                $('#flowMonitor').show();
                                if (Utils.notNullnotUndefined(ret)) {
                                    if (ret.length != 0) {
                                        Utils.safeApply(scope, function () {
                                            var _loop_1 = function (i) {
                                                scope.datas1 = {
                                                    datasX: [],
                                                    datasY: [],
                                                    tags: null
                                                };
                                                angular.forEach(ret[i].dps, function (value, key) {
                                                    if (value < 0) {
                                                        value = 0;
                                                    }
                                                    scope.datas1.tags = ret[i].tags;
                                                    scope.datas1.datasX.push(getFormatTime(key));
                                                    scope.datas1.datasY.push((value).toFixed(2));
                                                });
                                                if (ret[i].metric.indexOf('net.if.in.bytes') > -1) {
                                                    scope.chartObj1.push({
                                                        name: 'net.if.in.bytes',
                                                        smooth: true,
                                                        type: 'line',
                                                        data: scope.datas1.datasY
                                                    });
                                                }
                                                else if (ret[i].metric.indexOf('net.if.out.bytes') > -1) {
                                                    scope.chartObj1.push({
                                                        name: 'net.if.out.bytes',
                                                        smooth: true,
                                                        type: 'line',
                                                        data: scope.datas1.datasY
                                                    });
                                                }
                                                else if (ret[i].metric.indexOf('net.if.in.packets') > -1) {
                                                    scope.chartObj1.push({
                                                        name: 'net.if.in.packets',
                                                        smooth: true,
                                                        type: 'line',
                                                        data: scope.datas1.datasY
                                                    });
                                                }
                                                else if (ret[i].metric.indexOf('net.if.out.packets') > -1) {
                                                    scope.chartObj1.push({
                                                        name: 'net.if.out.packets',
                                                        smooth: true,
                                                        type: 'line',
                                                        data: scope.datas1.datasY
                                                    });
                                                }
                                            };
                                            for (var i = 0; i < ret.length; i++) {
                                                _loop_1(i);
                                            }
                                        });
                                    }
                                }
                                if (isClear) {
                                    echarts.init(document.getElementById('flowMonitor')).clear();
                                }
                                scope.loadChart();
                            }
                        });
                    });
                };
                _this.$scope = scope;
            };
            this.templateUrl = '/vpn/template/L3MPLSVpn/flowMonitor.html';
        }
        FlowMonitor.prototype.open = function (current) {
            this.options.open();
            this.$scope.currentItem = current;
            this.$scope.reset(current);
            $('#flowMonitor').css('width', '740px');
            this.$scope.isShowLoading = true;
            this.$scope.noData = false;
            $('#flowMonitor').hide();
        };
        FlowMonitor.prototype.reset = function (current) {
            this.$scope.reset(current);
        };
        FlowMonitor.prototype.close = function () {
            this.$scope.periods = null;
            this.options.close();
            clearInterval(this.$scope.intervalNumber);
        };
        return FlowMonitor;
    }());
    MCWVpn.FlowMonitor = FlowMonitor;
    function filterState() {
        return function (v) {
            switch (v) {
                case 'Enabled':
                    return '启用';
                case 'Disabled':
                    return '关闭';
                case 'Connecting':
                    return '连接中';
                case 'Connected':
                    return '正常';
                case 'Disconnected':
                    return '异常';
                case 'RouteMode':
                    return '路由模式';
                case 'GatewayMode':
                    return '网关模式';
                case 'tunnel':
                    return '云专线';
                case 'network':
                    return '云网络';
            }
        };
    }
    MCWVpn.filterState = filterState;
})(MCWVpn || (MCWVpn = {}));
angular.module('root')
    .factory('VpnManagerL3', ['$rootScope', 'Api', 'WAccountManage', 'VpnManagerL2', '$http', function ($rootScope, api, acMgr, VpnManagerL2, $http) {
        return new MCWVpn.VpnManagerL3($rootScope, api, acMgr, VpnManagerL2, $http);
    }])
    .factory('VpnManagerL2', ['$rootScope', 'Api', 'WAccountManage', function ($rootScope, api, acMgr) {
        return new MCWVpn.VpnManagerL2($rootScope, api, acMgr);
    }])
    .directive('wCwVpnDetail', ['VpnManagerL3', 'VpnManagerL2', '$q', function (vpnMgr, l2VpnMgr, $q) {
        return new MCWVpn.CwVpnDetail(vpnMgr, l2VpnMgr, $q);
    }])
    .directive('wUpdateCwVpnName', ['VpnManagerL2', '$q', function (VpnManagerL2, $q) {
        return new MCWVpn.UpdateCwVpnName(VpnManagerL2, $q);
    }])
    .directive('wUpdateCwVpnBandwidth', ['VpnManagerL3', '$q', '$location', '$rootScope', 'VpnManagerL2', function (vpnMgr, $q, $location, $rootScope, VpnManagerL2) {
        return new MCWVpn.UpdateCwVpnBandwidth(vpnMgr, $q, $location, $rootScope, VpnManagerL2);
    }])
    .directive('wAttachCwVpnCert', ['VpnManagerL3', '$q', 'VpnManagerL2', function (vpnMgr, $q, VpnManagerL2) {
        return new MCWVpn.AttachCwVpnCert(vpnMgr, $q, VpnManagerL2);
    }])
    .directive('wRenewCw', ['VpnManagerL3', '$q', '$location', '$rootScope', 'VpnManagerL2', function (vpnMgr, $q, $location, $rootScope, VpnManagerL2) {
        return new MCWVpn.RenewCw(vpnMgr, $q, $location, $rootScope, VpnManagerL2);
    }])
    .directive('wSettingIp', ['VpnManagerL3', '$q', function (vpnMgr, $q) {
        return new MCWVpn.SettingIp(vpnMgr, $q);
    }])
    .directive('wUpdateMode', ['VpnManagerL3', '$q', function (vpnMgr, $q) {
        return new MCWVpn.UpdateMode(vpnMgr, $q);
    }])
    .directive('wFlowMonitor', ['VpnManagerL3', '$q', function (vpnMgr, $q) {
        return new MCWVpn.FlowMonitor(vpnMgr, $q);
    }])
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/vpn/gateway', {
            templateUrl: '/vpn/template/L3MPLSVpn/list.html',
            controller: MCWVpn.Controller,
            resolve: {
                CwVpnParams: ['$rootScope', '$q', '$location', 'VpnManagerL3', function ($rootScope, $q, $location, vpnMgr) {
                        var defer = $q.defer(), qobj = new ApiHeader.QueryObject(), location = $location.search();
                        qobj.limit = location.size ? location.size : $rootScope.pageSize;
                        qobj.start = 0;
                        if (Utils.notNullnotUndefined(location)) {
                            if (location.page) {
                                qobj.start = qobj.limit * (location.page - 1);
                            }
                            var conditions = {
                                listName: [{
                                        name: 'uuid',
                                        isSelect: false
                                    }, {
                                        name: 'number',
                                        isSelect: true
                                    }, {
                                        name: 'name',
                                        isSelect: false
                                    }, {
                                        name: 'status',
                                        isSelect: true
                                    }, {
                                        name: 'state',
                                        isSelect: true
                                    }, {
                                        name: 'expireDate',
                                        isSelect: true
                                    }]
                            };
                            qobj.conditions = Utils.getConditionFromUrl(location, conditions);
                        }
                        vpnMgr.query(qobj, function (datas, total) {
                            defer.resolve({ vpns: datas, total: total });
                        });
                        return defer.promise;
                        // return {vpns:[], total:0}
                    }]
            }
        })
            .when('/vpn/gateway/pay', {
            templateUrl: '/vpn/template/directives/pay.html',
            controller: MCWVpn.payController,
            resolve: {
                params: ['$rootScope', function ($rootScope) {
                        var data = $rootScope.currentParam;
                        $rootScope.currentParam = null;
                        return JSON.stringify(data);
                    }]
            }
        })
            .when('/vpn/gateway/create', {
            templateUrl: '/vpn/template/L3MPLSVpn/create.html',
            controller: MCWVpn.CreateController
        });
    }])
    .filter('wState', function () {
    return MCWVpn.filterState();
})
    .service('scopeService', function () {
    return {
        safeApply: function ($scope, fn) {
            var phase = $scope.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && typeof fn === 'function') {
                    fn();
                }
            }
            else {
                $scope.$apply(fn);
            }
        }
    };
});
